//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from "moment";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from "axios";
export class AuthorizedApiBase {
  private readonly config: Config;

  protected constructor(config: Config) {
    this.config = config;
  }

  protected transformOptions = (
    options: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> => {
    return Promise.resolve(this.config.transformHeaders(options));
  };

  protected transformResult(
    url: string,
    response: AxiosResponse,
    processor: (response: AxiosResponse) => Promise<any>
  ): Promise<any> {
    return this.config.transformResult(url, response, processor);
  }
}

export class ConsumerInformationClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    videos(signal?: AbortSignal): Promise<InformationalVideoDTO[]> {
        let url_ = this.baseUrl + "/ConsumerInformation/Videos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processVideos(_response));
        });
    }

    protected processVideos(response: AxiosResponse): Promise<InformationalVideoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InformationalVideoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InformationalVideoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InformationalVideoDTO[]>(null as any);
    }

    dealerVideos(signal?: AbortSignal): Promise<InformationalVideoDTO[]> {
        let url_ = this.baseUrl + "/ConsumerInformation/DealerVideos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerVideos(_response));
        });
    }

    protected processDealerVideos(response: AxiosResponse): Promise<InformationalVideoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InformationalVideoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InformationalVideoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InformationalVideoDTO[]>(null as any);
    }

    checklists(signal?: AbortSignal): Promise<ChecklistDTO[]> {
        let url_ = this.baseUrl + "/ConsumerInformation/Checklists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChecklists(_response));
        });
    }

    protected processChecklists(response: AxiosResponse): Promise<ChecklistDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChecklistDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistDTO[]>(null as any);
    }

    getChecklistByUid(checklistUid: string, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/ConsumerInformation/{checklistUid}/Checklist";
        if (checklistUid === undefined || checklistUid === null)
            throw new Error("The parameter 'checklistUid' must be defined.");
        url_ = url_.replace("{checklistUid}", encodeURIComponent("" + checklistUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChecklistByUid(_response));
        });
    }

    protected processGetChecklistByUid(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    websiteContentLinks(signal?: AbortSignal): Promise<WebsiteContentLinkDTO> {
        let url_ = this.baseUrl + "/ConsumerInformation/WebsiteContentLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWebsiteContentLinks(_response));
        });
    }

    protected processWebsiteContentLinks(response: AxiosResponse): Promise<WebsiteContentLinkDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebsiteContentLinkDTO.fromJS(resultData200);
            return Promise.resolve<WebsiteContentLinkDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebsiteContentLinkDTO>(null as any);
    }

    websitePostCategories(signal?: AbortSignal): Promise<WebsitePostCategoryDTO[]> {
        let url_ = this.baseUrl + "/ConsumerInformation/WebsitePostCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWebsitePostCategories(_response));
        });
    }

    protected processWebsitePostCategories(response: AxiosResponse): Promise<WebsitePostCategoryDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebsitePostCategoryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WebsitePostCategoryDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebsitePostCategoryDTO[]>(null as any);
    }
}

export class DealerAnnouncementClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    announcements(signal?: AbortSignal): Promise<DealerAnnouncementDTO[]> {
        let url_ = this.baseUrl + "/DealerAnnouncement/Announcements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAnnouncements(_response));
        });
    }

    protected processAnnouncements(response: AxiosResponse): Promise<DealerAnnouncementDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerAnnouncementDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerAnnouncementDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerAnnouncementDTO[]>(null as any);
    }

    createAnnouncement(dto: CreateDealerAnnouncementDTO, signal?: AbortSignal): Promise<CreateDealerAnnouncementDTO> {
        let url_ = this.baseUrl + "/DealerAnnouncement/CreateAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAnnouncement(_response));
        });
    }

    protected processCreateAnnouncement(response: AxiosResponse): Promise<CreateDealerAnnouncementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDealerAnnouncementDTO.fromJS(resultData200);
            return Promise.resolve<CreateDealerAnnouncementDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = CreateDealerAnnouncementDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDealerAnnouncementDTO>(null as any);
    }

    updateAnnouncement(dto: DealerAnnouncementDTO, signal?: AbortSignal): Promise<DealerAnnouncementDTO> {
        let url_ = this.baseUrl + "/DealerAnnouncement/UpdateAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAnnouncement(_response));
        });
    }

    protected processUpdateAnnouncement(response: AxiosResponse): Promise<DealerAnnouncementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerAnnouncementDTO.fromJS(resultData200);
            return Promise.resolve<DealerAnnouncementDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerAnnouncementDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerAnnouncementDTO>(null as any);
    }

    deleteAnnouncement(dto: DealerAnnouncementDTO, signal?: AbortSignal): Promise<DealerAnnouncementDTO> {
        let url_ = this.baseUrl + "/DealerAnnouncement/DeleteAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAnnouncement(_response));
        });
    }

    protected processDeleteAnnouncement(response: AxiosResponse): Promise<DealerAnnouncementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerAnnouncementDTO.fromJS(resultData200);
            return Promise.resolve<DealerAnnouncementDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerAnnouncementDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerAnnouncementDTO>(null as any);
    }

    announcementDocuments(announcementUid?: string | null | undefined, signal?: AbortSignal): Promise<DocumentDTO[]> {
        let url_ = this.baseUrl + "/DealerAnnouncement/AnnouncementDocuments?";
        if (announcementUid !== undefined && announcementUid !== null)
            url_ += "announcementUid=" + encodeURIComponent("" + announcementUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAnnouncementDocuments(_response));
        });
    }

    protected processAnnouncementDocuments(response: AxiosResponse): Promise<DocumentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDTO[]>(null as any);
    }

    createAnnouncementDocument(dto: DealerAnnouncementDocumentDTO, signal?: AbortSignal): Promise<DealerAnnouncementDocumentDTO> {
        let url_ = this.baseUrl + "/DealerAnnouncement/CreateAnnouncementDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAnnouncementDocument(_response));
        });
    }

    protected processCreateAnnouncementDocument(response: AxiosResponse): Promise<DealerAnnouncementDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerAnnouncementDocumentDTO.fromJS(resultData200);
            return Promise.resolve<DealerAnnouncementDocumentDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerAnnouncementDocumentDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerAnnouncementDocumentDTO>(null as any);
    }

    deleteAnnouncementDocument(dto: DeleteDealerAnnouncementDocDTO, signal?: AbortSignal): Promise<DeleteDealerAnnouncementDocDTO> {
        let url_ = this.baseUrl + "/DealerAnnouncement/DeleteAnnouncementDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAnnouncementDocument(_response));
        });
    }

    protected processDeleteAnnouncementDocument(response: AxiosResponse): Promise<DeleteDealerAnnouncementDocDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteDealerAnnouncementDocDTO.fromJS(resultData200);
            return Promise.resolve<DeleteDealerAnnouncementDocDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DeleteDealerAnnouncementDocDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteDealerAnnouncementDocDTO>(null as any);
    }
}

export class DealerClaimClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    claims(dto: DealerClaimSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO[]> {
        let url_ = this.baseUrl + "/DealerClaim/Claims?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClaims(_response));
        });
    }

    protected processClaims(response: AxiosResponse): Promise<DealerClaimDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerClaimDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerClaimDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO[]>(null as any);
    }

    createClaim(dto: CreateClaimDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaim?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaim(_response));
        });
    }

    protected processCreateClaim(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimFromRecall(dto: CreateClaimDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimFromRecall?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimFromRecall(_response));
        });
    }

    protected processCreateClaimFromRecall(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    editClaim(dto: DealerClaimDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/EditClaim?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditClaim(_response));
        });
    }

    protected processEditClaim(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    submitPreAuthorization(dealerAccountUid?: string | null | undefined, claimNumber?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/SubmitPreAuthorization?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (claimNumber !== undefined && claimNumber !== null)
            url_ += "claimNumber=" + encodeURIComponent("" + claimNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubmitPreAuthorization(_response));
        });
    }

    protected processSubmitPreAuthorization(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    submitWorkComplete(dealerAccountUid?: string | null | undefined, claimNumber?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/SubmitWorkComplete?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (claimNumber !== undefined && claimNumber !== null)
            url_ += "claimNumber=" + encodeURIComponent("" + claimNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubmitWorkComplete(_response));
        });
    }

    protected processSubmitWorkComplete(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    getByClaimNumber(dealerAccountUid?: string | null | undefined, claimNumber?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/GetByClaimNumber?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (claimNumber !== undefined && claimNumber !== null)
            url_ += "claimNumber=" + encodeURIComponent("" + claimNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByClaimNumber(_response));
        });
    }

    protected processGetByClaimNumber(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    getClaimLineAttachments(dealerAccountUid?: string | null | undefined, claimLineId?: number | undefined, signal?: AbortSignal): Promise<DealerClaimLineAttachmentDTO[]> {
        let url_ = this.baseUrl + "/DealerClaim/GetClaimLineAttachments?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (claimLineId === null)
            throw new Error("The parameter 'claimLineId' cannot be null.");
        else if (claimLineId !== undefined)
            url_ += "claimLineId=" + encodeURIComponent("" + claimLineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClaimLineAttachments(_response));
        });
    }

    protected processGetClaimLineAttachments(response: AxiosResponse): Promise<DealerClaimLineAttachmentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerClaimLineAttachmentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerClaimLineAttachmentDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimLineAttachmentDTO[]>(null as any);
    }

    createClaimLine(dto: CreateClaimLineDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimLine?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimLine(_response));
        });
    }

    protected processCreateClaimLine(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimLineItem(dto: CreateClaimLineItemDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimLineItem?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimLineItem(_response));
        });
    }

    protected processCreateClaimLineItem(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimLineMiscCharge(dto: CreateClaimLineMiscChargeDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimLineMiscCharge?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimLineMiscCharge(_response));
        });
    }

    protected processCreateClaimLineMiscCharge(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimLineAttachment(dto: CreateClaimLineAttachmentDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimLineAttachment?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimLineAttachment(_response));
        });
    }

    protected processCreateClaimLineAttachment(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimLineNote(dto: CreateaClaimLineNoteDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerClaimDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimLineNote?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimLineNote(_response));
        });
    }

    protected processCreateClaimLineNote(response: AxiosResponse): Promise<DealerClaimDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerClaimDTO.fromJS(resultData200);
            return Promise.resolve<DealerClaimDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerClaimDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerClaimDTO>(null as any);
    }

    createClaimReturnLabel(dto: ReturnLabelDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ReturnLabelDTO> {
        let url_ = this.baseUrl + "/DealerClaim/CreateClaimReturnLabel?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClaimReturnLabel(_response));
        });
    }

    protected processCreateClaimReturnLabel(response: AxiosResponse): Promise<ReturnLabelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnLabelDTO.fromJS(resultData200);
            return Promise.resolve<ReturnLabelDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ReturnLabelDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnLabelDTO>(null as any);
    }

    deleteClaimLine(dealerAccountUid?: string | null | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ValidationBaseDTO> {
        let url_ = this.baseUrl + "/DealerClaim/DeleteClaimLine?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClaimLine(_response));
        });
    }

    protected processDeleteClaimLine(response: AxiosResponse): Promise<ValidationBaseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationBaseDTO.fromJS(resultData200);
            return Promise.resolve<ValidationBaseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationBaseDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationBaseDTO>(null as any);
    }

    deleteClaimLineItem(dealerAccountUid?: string | null | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ValidationBaseDTO> {
        let url_ = this.baseUrl + "/DealerClaim/DeleteClaimLineItem?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClaimLineItem(_response));
        });
    }

    protected processDeleteClaimLineItem(response: AxiosResponse): Promise<ValidationBaseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationBaseDTO.fromJS(resultData200);
            return Promise.resolve<ValidationBaseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationBaseDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationBaseDTO>(null as any);
    }

    deleteClaimLineMiscCharge(dealerAccountUid?: string | null | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ValidationBaseDTO> {
        let url_ = this.baseUrl + "/DealerClaim/DeleteClaimLineMiscCharge?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClaimLineMiscCharge(_response));
        });
    }

    protected processDeleteClaimLineMiscCharge(response: AxiosResponse): Promise<ValidationBaseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationBaseDTO.fromJS(resultData200);
            return Promise.resolve<ValidationBaseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationBaseDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationBaseDTO>(null as any);
    }

    deleteClaimLineAttachment(dealerAccountUid?: string | null | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ValidationBaseDTO> {
        let url_ = this.baseUrl + "/DealerClaim/DeleteClaimLineAttachment?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClaimLineAttachment(_response));
        });
    }

    protected processDeleteClaimLineAttachment(response: AxiosResponse): Promise<ValidationBaseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationBaseDTO.fromJS(resultData200);
            return Promise.resolve<ValidationBaseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationBaseDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationBaseDTO>(null as any);
    }

    deleteClaimLineNote(dealerAccountUid?: string | null | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ValidationBaseDTO> {
        let url_ = this.baseUrl + "/DealerClaim/DeleteClaimLineNote?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClaimLineNote(_response));
        });
    }

    protected processDeleteClaimLineNote(response: AxiosResponse): Promise<ValidationBaseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationBaseDTO.fromJS(resultData200);
            return Promise.resolve<ValidationBaseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationBaseDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationBaseDTO>(null as any);
    }

    exportClaimsByStatus(dealerAccountUid?: string | null | undefined, status?: string | null | undefined, autoDenied?: boolean | undefined, signal?: AbortSignal): Promise<ExportDTO> {
        let url_ = this.baseUrl + "/DealerClaim/ExportClaimsByStatus?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (autoDenied === null)
            throw new Error("The parameter 'autoDenied' cannot be null.");
        else if (autoDenied !== undefined)
            url_ += "autoDenied=" + encodeURIComponent("" + autoDenied) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportClaimsByStatus(_response));
        });
    }

    protected processExportClaimsByStatus(response: AxiosResponse): Promise<ExportDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDTO.fromJS(resultData200);
            return Promise.resolve<ExportDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ExportDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDTO>(null as any);
    }

    claimReport(dealerAccountUid?: string | null | undefined, claimNumber?: string | null | undefined, signal?: AbortSignal): Promise<AttachmentInfoDTO> {
        let url_ = this.baseUrl + "/DealerClaim/ClaimReport?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (claimNumber !== undefined && claimNumber !== null)
            url_ += "claimNumber=" + encodeURIComponent("" + claimNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClaimReport(_response));
        });
    }

    protected processClaimReport(response: AxiosResponse): Promise<AttachmentInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentInfoDTO.fromJS(resultData200);
            return Promise.resolve<AttachmentInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentInfoDTO>(null as any);
    }
}

export class DealerClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    locationsByCompany(signal?: AbortSignal): Promise<DealerLocationDTO[]> {
        let url_ = this.baseUrl + "/Dealer/LocationsByCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLocationsByCompany(_response));
        });
    }

    protected processLocationsByCompany(response: AxiosResponse): Promise<DealerLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerLocationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerLocationDTO[]>(null as any);
    }

    locations(signal?: AbortSignal): Promise<DealerLocationDTO[]> {
        let url_ = this.baseUrl + "/Dealer/Locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLocations(_response));
        });
    }

    protected processLocations(response: AxiosResponse): Promise<DealerLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerLocationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerLocationDTO[]>(null as any);
    }

    chainGroups(signal?: AbortSignal): Promise<DealerChainGroupDTO[]> {
        let url_ = this.baseUrl + "/Dealer/ChainGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChainGroups(_response));
        });
    }

    protected processChainGroups(response: AxiosResponse): Promise<DealerChainGroupDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerChainGroupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerChainGroupDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerChainGroupDTO[]>(null as any);
    }

    dealerAddresInfo(dynamicsLocationId?: string | null | undefined, signal?: AbortSignal): Promise<DealerAddressInfoDTO[]> {
        let url_ = this.baseUrl + "/Dealer/DealerAddresInfo?";
        if (dynamicsLocationId !== undefined && dynamicsLocationId !== null)
            url_ += "dynamicsLocationId=" + encodeURIComponent("" + dynamicsLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerAddresInfo(_response));
        });
    }

    protected processDealerAddresInfo(response: AxiosResponse): Promise<DealerAddressInfoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerAddressInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerAddressInfoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerAddressInfoDTO[]>(null as any);
    }

    userDealerLocations(signal?: AbortSignal): Promise<UserDealerLocationsDTO> {
        let url_ = this.baseUrl + "/Dealer/UserDealerLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserDealerLocations(_response));
        });
    }

    protected processUserDealerLocations(response: AxiosResponse): Promise<UserDealerLocationsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDealerLocationsDTO.fromJS(resultData200);
            return Promise.resolve<UserDealerLocationsDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = UserDealerLocationsDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDealerLocationsDTO>(null as any);
    }

    inviteAdmin(dto: InviteDealerUserDTO, signal?: AbortSignal): Promise<InviteDealerUserDTO> {
        let url_ = this.baseUrl + "/Dealer/InviteAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInviteAdmin(_response));
        });
    }

    protected processInviteAdmin(response: AxiosResponse): Promise<InviteDealerUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteDealerUserDTO.fromJS(resultData200);
            return Promise.resolve<InviteDealerUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = InviteDealerUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteDealerUserDTO>(null as any);
    }

    inviteUser(dto: InviteDealerUserDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<InviteDealerUserDTO> {
        let url_ = this.baseUrl + "/Dealer/InviteUser?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInviteUser(_response));
        });
    }

    protected processInviteUser(response: AxiosResponse): Promise<InviteDealerUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteDealerUserDTO.fromJS(resultData200);
            return Promise.resolve<InviteDealerUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = InviteDealerUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteDealerUserDTO>(null as any);
    }

    completeDealerInvite(dto: CompleteDealerRegistrationDTO, signal?: AbortSignal): Promise<CompleteDealerRegistrationDTO> {
        let url_ = this.baseUrl + "/Dealer/CompleteDealerInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteDealerInvite(_response));
        });
    }

    protected processCompleteDealerInvite(response: AxiosResponse): Promise<CompleteDealerRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteDealerRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<CompleteDealerRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = CompleteDealerRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteDealerRegistrationDTO>(null as any);
    }

    getAllDealerUsers(dto: PaginationBaseRequestDTO, signal?: AbortSignal): Promise<DealerUserDTO[]> {
        let url_ = this.baseUrl + "/Dealer/GetAllDealerUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllDealerUsers(_response));
        });
    }

    protected processGetAllDealerUsers(response: AxiosResponse): Promise<DealerUserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerUserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerUserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerUserDTO[]>(null as any);
    }

    dealerUsers(dealerAccountUid: string, dto: PaginationBaseRequestDTO, signal?: AbortSignal): Promise<DealerUserDTO[]> {
        let url_ = this.baseUrl + "/Dealer/{dealerAccountUid}/DealerUsers";
        if (dealerAccountUid === undefined || dealerAccountUid === null)
            throw new Error("The parameter 'dealerAccountUid' must be defined.");
        url_ = url_.replace("{dealerAccountUid}", encodeURIComponent("" + dealerAccountUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerUsers(_response));
        });
    }

    protected processDealerUsers(response: AxiosResponse): Promise<DealerUserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerUserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerUserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerUserDTO[]>(null as any);
    }

    dealerAdmin(userId?: string | null | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Dealer/DealerAdmin?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerAdmin(_response));
        });
    }

    protected processDealerAdmin(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    editDealerAdmin(dto: EditDealerUserDTO, signal?: AbortSignal): Promise<EditDealerUserDTO> {
        let url_ = this.baseUrl + "/Dealer/EditDealerAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditDealerAdmin(_response));
        });
    }

    protected processEditDealerAdmin(response: AxiosResponse): Promise<EditDealerUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditDealerUserDTO.fromJS(resultData200);
            return Promise.resolve<EditDealerUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EditDealerUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditDealerUserDTO>(null as any);
    }

    editDealerUser(dto: EditDealerUserDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<EditDealerUserDTO> {
        let url_ = this.baseUrl + "/Dealer/EditDealerUser?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditDealerUser(_response));
        });
    }

    protected processEditDealerUser(response: AxiosResponse): Promise<EditDealerUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditDealerUserDTO.fromJS(resultData200);
            return Promise.resolve<EditDealerUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EditDealerUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditDealerUserDTO>(null as any);
    }

    dealerUser(userId?: string | null | undefined, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Dealer/DealerUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerUser(_response));
        });
    }

    protected processDealerUser(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    sendDealerAdminInvite(userId?: string | null | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Dealer/SendDealerAdminInvite?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendDealerAdminInvite(_response));
        });
    }

    protected processSendDealerAdminInvite(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    batchInviteDealerUsers(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Dealer/BatchInviteDealerUsers?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBatchInviteDealerUsers(_response));
        });
    }

    protected processBatchInviteDealerUsers(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    sendDealerUserInvite(userId?: string | null | undefined, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Dealer/SendDealerUserInvite?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendDealerUserInvite(_response));
        });
    }

    protected processSendDealerUserInvite(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    forgotPassword(forgotPasswordDto: ForgotPasswordDTO, signal?: AbortSignal): Promise<ForgotPasswordDTO> {
        let url_ = this.baseUrl + "/Dealer/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ForgotPasswordDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForgotPasswordDTO.fromJS(resultData200);
            return Promise.resolve<ForgotPasswordDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ForgotPasswordDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgotPasswordDTO>(null as any);
    }
}

export class DealerDashboardClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDashboardData(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerDashboardDTO> {
        let url_ = this.baseUrl + "/DealerDashboard/GetDashboardData?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDashboardData(_response));
        });
    }

    protected processGetDashboardData(response: AxiosResponse): Promise<DealerDashboardDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerDashboardDTO.fromJS(resultData200);
            return Promise.resolve<DealerDashboardDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerDashboardDTO>(null as any);
    }
}

export class DealerRecallClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    warrantyRecalls(dto: DealerRecallSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerRecallDTO[]> {
        let url_ = this.baseUrl + "/DealerRecall/WarrantyRecalls?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRecalls(_response));
        });
    }

    protected processWarrantyRecalls(response: AxiosResponse): Promise<DealerRecallDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerRecallDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerRecallDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerRecallDTO[]>(null as any);
    }

    warrantyRecallVins(dto: DealerRecallSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerRecallVinDTO[]> {
        let url_ = this.baseUrl + "/DealerRecall/WarrantyRecallVins?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRecallVins(_response));
        });
    }

    protected processWarrantyRecallVins(response: AxiosResponse): Promise<DealerRecallVinDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerRecallVinDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerRecallVinDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerRecallVinDTO[]>(null as any);
    }

    recallAttachment(dealerAccountUid?: string | null | undefined, attachmentRecId?: number | undefined, signal?: AbortSignal): Promise<AXDocumentDTO> {
        let url_ = this.baseUrl + "/DealerRecall/RecallAttachment?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (attachmentRecId === null)
            throw new Error("The parameter 'attachmentRecId' cannot be null.");
        else if (attachmentRecId !== undefined)
            url_ += "attachmentRecId=" + encodeURIComponent("" + attachmentRecId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRecallAttachment(_response));
        });
    }

    protected processRecallAttachment(response: AxiosResponse): Promise<AXDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXDocumentDTO.fromJS(resultData200);
            return Promise.resolve<AXDocumentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXDocumentDTO>(null as any);
    }

    exportRecallVins(dto: DealerRecallSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ExportDTO> {
        let url_ = this.baseUrl + "/DealerRecall/ExportRecallVins?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportRecallVins(_response));
        });
    }

    protected processExportRecallVins(response: AxiosResponse): Promise<ExportDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDTO.fromJS(resultData200);
            return Promise.resolve<ExportDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDTO>(null as any);
    }
}

export class DealerSalesOrderClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDealerSalesOrders(dto: DealerSalesOrderSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerSalesOrderDTO[]> {
        let url_ = this.baseUrl + "/DealerSalesOrder/GetDealerSalesOrders?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDealerSalesOrders(_response));
        });
    }

    protected processGetDealerSalesOrders(response: AxiosResponse): Promise<DealerSalesOrderDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealerSalesOrderDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealerSalesOrderDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerSalesOrderDTO[]>(null as any);
    }

    dealerSalesOrderMSRPReport(dealerAccountUid?: string | null | undefined, salesOrderId?: string | null | undefined, signal?: AbortSignal): Promise<AXDocumentDTO> {
        let url_ = this.baseUrl + "/DealerSalesOrder/DealerSalesOrderMSRPReport?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (salesOrderId !== undefined && salesOrderId !== null)
            url_ += "salesOrderId=" + encodeURIComponent("" + salesOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerSalesOrderMSRPReport(_response));
        });
    }

    protected processDealerSalesOrderMSRPReport(response: AxiosResponse): Promise<AXDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXDocumentDTO.fromJS(resultData200);
            return Promise.resolve<AXDocumentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXDocumentDTO>(null as any);
    }
}

export class DocumentClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    upload(signal?: AbortSignal): Promise<DocumentDTO> {
        let url_ = this.baseUrl + "/Document";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpload(_response));
        });
    }

    protected processUpload(response: AxiosResponse): Promise<DocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentDTO.fromJS(resultData200);
            return Promise.resolve<DocumentDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DocumentDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDTO>(null as any);
    }

    download(documentUid: string, token: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Document/{documentUid}/{token}";
        if (documentUid === undefined || documentUid === null)
            throw new Error("The parameter 'documentUid' must be defined.");
        url_ = url_.replace("{documentUid}", encodeURIComponent("" + documentUid));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownload(_response));
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(documentUid: string, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Document/{documentUid}";
        if (documentUid === undefined || documentUid === null)
            throw new Error("The parameter 'documentUid' must be defined.");
        url_ = url_.replace("{documentUid}", encodeURIComponent("" + documentUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }
}

export class IdentityClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    login(dto: AuthenticationRequestDTO, signal?: AbortSignal): Promise<AuthenticationResultDTO> {
        let url_ = this.baseUrl + "/Identity/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResultDTO.fromJS(resultData200);
            return Promise.resolve<AuthenticationResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = AuthenticationResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = AuthenticationResultDTO.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResultDTO>(null as any);
    }

    refreshToken(dto: RefreshTokenDTO, signal?: AbortSignal): Promise<AuthenticationResultDTO> {
        let url_ = this.baseUrl + "/Identity/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<AuthenticationResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResultDTO.fromJS(resultData200);
            return Promise.resolve<AuthenticationResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = AuthenticationResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResultDTO>(null as any);
    }

    revokeToken(dto: RefreshTokenDTO, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/RevokeToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRevokeToken(_response));
        });
    }

    protected processRevokeToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(forgotPasswordDTO: ForgotPasswordDTO, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(resetPasswordDto: ResetPasswordDTO, signal?: AbortSignal): Promise<ResetPasswordDTO> {
        let url_ = this.baseUrl + "/Identity/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordDTO.fromJS(resultData200);
            return Promise.resolve<ResetPasswordDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ResetPasswordDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordDTO>(null as any);
    }

    register(dto: RegisterDTO, signal?: AbortSignal): Promise<RegisterDTO> {
        let url_ = this.baseUrl + "/Identity/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterDTO.fromJS(resultData200);
            return Promise.resolve<RegisterDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RegisterDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterDTO>(null as any);
    }

    confirmEmail(dto: EmailConfirmationDTO, signal?: AbortSignal): Promise<EmailConfirmationDTO> {
        let url_ = this.baseUrl + "/Identity/ConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfirmEmail(_response));
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<EmailConfirmationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailConfirmationDTO.fromJS(resultData200);
            return Promise.resolve<EmailConfirmationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EmailConfirmationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailConfirmationDTO>(null as any);
    }

    acceptTermsAndConditions(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/AcceptTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAcceptTermsAndConditions(_response));
        });
    }

    protected processAcceptTermsAndConditions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    changePassword(dto: ChangePasswordDTO, signal?: AbortSignal): Promise<ChangePasswordDTO> {
        let url_ = this.baseUrl + "/Identity/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ChangePasswordDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePasswordDTO.fromJS(resultData200);
            return Promise.resolve<ChangePasswordDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ChangePasswordDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePasswordDTO>(null as any);
    }

    sendConfirmEmail(userId?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/SendConfirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendConfirmEmail(_response));
        });
    }

    protected processSendConfirmEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProfile(userId: string, signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/Identity/UserProfile/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProfile(_response));
        });
    }

    protected processGetProfile(response: AxiosResponse): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileDTO.fromJS(resultData200);
            return Promise.resolve<ProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    updateProfile(userId: string, userProfile: ProfileDTO, signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/Identity/UserProfile/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userProfile);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProfile(_response));
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileDTO.fromJS(resultData200);
            return Promise.resolve<ProfileDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProfileDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    getUsers(search?: string | null | undefined, signal?: AbortSignal): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/Identity/Users?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUsers(_response));
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    getUserVins(user?: string | undefined, signal?: AbortSignal): Promise<VehicleDTO[]> {
        let url_ = this.baseUrl + "/Identity/Vins?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserVins(_response));
        });
    }

    protected processGetUserVins(response: AxiosResponse): Promise<VehicleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDTO[]>(null as any);
    }

    updateUser(userId: string, user: UpdateUserDTO, signal?: AbortSignal): Promise<UpdateUserDTO> {
        let url_ = this.baseUrl + "/Identity/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUser(_response));
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UpdateUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserDTO.fromJS(resultData200);
            return Promise.resolve<UpdateUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = UpdateUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserDTO>(null as any);
    }

    toggleLockout(userId?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/ToggleLockout?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processToggleLockout(_response));
        });
    }

    protected processToggleLockout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRoles(signal?: AbortSignal): Promise<RoleDTO[]> {
        let url_ = this.baseUrl + "/Identity/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO[]>(null as any);
    }

    createRole(role: RoleDTO, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateRole(_response));
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }

    updateRole(roleId: string, role: RoleDTO, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRole(_response));
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }

    deleteRole(roleId: string, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteRole(_response));
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }
}

export class InvoiceClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    invoices(dto: InvoiceSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<InvoiceDTO[]> {
        let url_ = this.baseUrl + "/Invoice/Invoices?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInvoices(_response));
        });
    }

    protected processInvoices(response: AxiosResponse): Promise<InvoiceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(InvoiceDTO.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDTO[]>(null as any);
    }

    invoiceReport(dealerAccountUid?: string | null | undefined, invoiceId?: string | null | undefined, signal?: AbortSignal): Promise<AttachmentInfoDTO> {
        let url_ = this.baseUrl + "/Invoice/InvoiceReport?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (invoiceId !== undefined && invoiceId !== null)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInvoiceReport(_response));
        });
    }

    protected processInvoiceReport(response: AxiosResponse): Promise<AttachmentInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentInfoDTO.fromJS(resultData200);
            return Promise.resolve<AttachmentInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentInfoDTO>(null as any);
    }

    invoiceStatement(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<InvoiceStatementDTO> {
        let url_ = this.baseUrl + "/Invoice/InvoiceStatement?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInvoiceStatement(_response));
        });
    }

    protected processInvoiceStatement(response: AxiosResponse): Promise<InvoiceStatementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceStatementDTO.fromJS(resultData200);
            return Promise.resolve<InvoiceStatementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceStatementDTO>(null as any);
    }

    exportInvoiceStatement(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ExportDTO> {
        let url_ = this.baseUrl + "/Invoice/ExportInvoiceStatement?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportInvoiceStatement(_response));
        });
    }

    protected processExportInvoiceStatement(response: AxiosResponse): Promise<ExportDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDTO.fromJS(resultData200);
            return Promise.resolve<ExportDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDTO>(null as any);
    }
}

export class LookupClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    spiffTypes(signal?: AbortSignal): Promise<SpiffTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/SpiffTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSpiffTypes(_response));
        });
    }

    protected processSpiffTypes(response: AxiosResponse): Promise<SpiffTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiffTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SpiffTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpiffTypeDTO[]>(null as any);
    }

    brands(signal?: AbortSignal): Promise<BrandDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBrands(_response));
        });
    }

    protected processBrands(response: AxiosResponse): Promise<BrandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrandDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandDTO[]>(null as any);
    }

    catalogBrands(signal?: AbortSignal): Promise<CatalogBrandDTO[]> {
        let url_ = this.baseUrl + "/Lookup/CatalogBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCatalogBrands(_response));
        });
    }

    protected processCatalogBrands(response: AxiosResponse): Promise<CatalogBrandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogBrandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CatalogBrandDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogBrandDTO[]>(null as any);
    }

    deliveryModes(signal?: AbortSignal): Promise<DeliveryModeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DeliveryModes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeliveryModes(_response));
        });
    }

    protected processDeliveryModes(response: AxiosResponse): Promise<DeliveryModeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryModeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeliveryModeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryModeDTO[]>(null as any);
    }

    catalogYearsByBrand(brandId?: string | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/Lookup/CatalogYearsByBrand?";
        if (brandId !== undefined && brandId !== null)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCatalogYearsByBrand(_response));
        });
    }

    protected processCatalogYearsByBrand(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    checklistTypes(signal?: AbortSignal): Promise<ChecklistTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/ChecklistTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChecklistTypes(_response));
        });
    }

    protected processChecklistTypes(response: AxiosResponse): Promise<ChecklistTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChecklistTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistTypeDTO[]>(null as any);
    }

    companyType(signal?: AbortSignal): Promise<CompanyTypeDTO> {
        let url_ = this.baseUrl + "/Lookup/CompanyType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompanyType(_response));
        });
    }

    protected processCompanyType(response: AxiosResponse): Promise<CompanyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyTypeDTO.fromJS(resultData200);
            return Promise.resolve<CompanyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyTypeDTO>(null as any);
    }

    countries(signal?: AbortSignal): Promise<CountryLookupDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCountries(_response));
        });
    }

    protected processCountries(response: AxiosResponse): Promise<CountryLookupDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryLookupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CountryLookupDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryLookupDTO[]>(null as any);
    }

    documentTypes(signal?: AbortSignal): Promise<DocumentTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDocumentTypes(_response));
        });
    }

    protected processDocumentTypes(response: AxiosResponse): Promise<DocumentTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentTypeDTO[]>(null as any);
    }

    states(signal?: AbortSignal): Promise<StateLookupDTO[]> {
        let url_ = this.baseUrl + "/Lookup/States";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStates(_response));
        });
    }

    protected processStates(response: AxiosResponse): Promise<StateLookupDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateLookupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StateLookupDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StateLookupDTO[]>(null as any);
    }

    settings(signal?: AbortSignal): Promise<SettingDTO> {
        let url_ = this.baseUrl + "/Lookup/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSettings(_response));
        });
    }

    protected processSettings(response: AxiosResponse): Promise<SettingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingDTO.fromJS(resultData200);
            return Promise.resolve<SettingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingDTO>(null as any);
    }

    dealerSettings(signal?: AbortSignal): Promise<DealerSettingDTO> {
        let url_ = this.baseUrl + "/Lookup/DealerSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerSettings(_response));
        });
    }

    protected processDealerSettings(response: AxiosResponse): Promise<DealerSettingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerSettingDTO.fromJS(resultData200);
            return Promise.resolve<DealerSettingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerSettingDTO>(null as any);
    }

    termsAndConditions(companyType?: CompanyTypes | undefined, signal?: AbortSignal): Promise<TermsAndConditionDTO> {
        let url_ = this.baseUrl + "/Lookup/TermsAndConditions?";
        if (companyType === null)
            throw new Error("The parameter 'companyType' cannot be null.");
        else if (companyType !== undefined)
            url_ += "companyType=" + encodeURIComponent("" + companyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTermsAndConditions(_response));
        });
    }

    protected processTermsAndConditions(response: AxiosResponse): Promise<TermsAndConditionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsAndConditionDTO.fromJS(resultData200);
            return Promise.resolve<TermsAndConditionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsAndConditionDTO>(null as any);
    }

    roles(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRoles(_response));
        });
    }

    protected processRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    dealerUserRoles(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DealerUserRoles?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerUserRoles(_response));
        });
    }

    protected processDealerUserRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    dealerAdminRoles(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DealerAdminRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerAdminRoles(_response));
        });
    }

    protected processDealerAdminRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    permissions(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPermissions(_response));
        });
    }

    protected processPermissions(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    postalCodeInfo(countryCode?: string | null | undefined, postalCode?: string | null | undefined, signal?: AbortSignal): Promise<PostalCodeInfoDTO[]> {
        let url_ = this.baseUrl + "/Lookup/PostalCodeInfo?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostalCodeInfo(_response));
        });
    }

    protected processPostalCodeInfo(response: AxiosResponse): Promise<PostalCodeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostalCodeInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PostalCodeInfoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeInfoDTO[]>(null as any);
    }

    dynamicsCountries(signal?: AbortSignal): Promise<DynamicsCountryDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DynamicsCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDynamicsCountries(_response));
        });
    }

    protected processDynamicsCountries(response: AxiosResponse): Promise<DynamicsCountryDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicsCountryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DynamicsCountryDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicsCountryDTO[]>(null as any);
    }

    claimStatusTypes(signal?: AbortSignal): Promise<ClaimStatusTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/ClaimStatusTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClaimStatusTypes(_response));
        });
    }

    protected processClaimStatusTypes(response: AxiosResponse): Promise<ClaimStatusTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimStatusTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClaimStatusTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimStatusTypeDTO[]>(null as any);
    }

    warrantyClassCodes(signal?: AbortSignal): Promise<WarrantyClassCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyClassCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyClassCodes(_response));
        });
    }

    protected processWarrantyClassCodes(response: AxiosResponse): Promise<WarrantyClassCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyClassCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyClassCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyClassCodeDTO[]>(null as any);
    }

    warrantyRemedyCodes(signal?: AbortSignal): Promise<WarrantyRemedyCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyRemedyCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRemedyCodes(_response));
        });
    }

    protected processWarrantyRemedyCodes(response: AxiosResponse): Promise<WarrantyRemedyCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyRemedyCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyRemedyCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyRemedyCodeDTO[]>(null as any);
    }

    warrantyFailureCodes(signal?: AbortSignal): Promise<WarrantyFailureCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyFailureCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyFailureCodes(_response));
        });
    }

    protected processWarrantyFailureCodes(response: AxiosResponse): Promise<WarrantyFailureCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyFailureCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyFailureCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyFailureCodeDTO[]>(null as any);
    }

    warrantyMiscChargeCodes(signal?: AbortSignal): Promise<WarrantyMiscChargeCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyMiscChargeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyMiscChargeCodes(_response));
        });
    }

    protected processWarrantyMiscChargeCodes(response: AxiosResponse): Promise<WarrantyMiscChargeCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyMiscChargeCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyMiscChargeCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyMiscChargeCodeDTO[]>(null as any);
    }

    exportWarrantyClassCodes(signal?: AbortSignal): Promise<ExportDTO> {
        let url_ = this.baseUrl + "/Lookup/ExportWarrantyClassCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportWarrantyClassCodes(_response));
        });
    }

    protected processExportWarrantyClassCodes(response: AxiosResponse): Promise<ExportDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDTO.fromJS(resultData200);
            return Promise.resolve<ExportDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDTO>(null as any);
    }
}

export class NotificationClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    registerToken(dto: NotificationRegistrationDTO, signal?: AbortSignal): Promise<NotificationRegistrationDTO> {
        let url_ = this.baseUrl + "/Notification/RegisterToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterToken(_response));
        });
    }

    protected processRegisterToken(response: AxiosResponse): Promise<NotificationRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<NotificationRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = NotificationRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRegistrationDTO>(null as any);
    }

    send(dto: NotificationDTO, signal?: AbortSignal): Promise<NotificationDTO> {
        let url_ = this.baseUrl + "/Notification/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSend(_response));
        });
    }

    protected processSend(response: AxiosResponse): Promise<NotificationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationDTO.fromJS(resultData200);
            return Promise.resolve<NotificationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = NotificationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDTO>(null as any);
    }

    userNotifications(signal?: AbortSignal): Promise<UserNotificationDTO[]> {
        let url_ = this.baseUrl + "/Notification/UserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserNotifications(_response));
        });
    }

    protected processUserNotifications(response: AxiosResponse): Promise<UserNotificationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserNotificationDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(UserNotificationDTO.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDTO[]>(null as any);
    }

    notificationRead(userNotifcationId?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Notification/NotificationRead?";
        if (userNotifcationId === null)
            throw new Error("The parameter 'userNotifcationId' cannot be null.");
        else if (userNotifcationId !== undefined)
            url_ += "userNotifcationId=" + encodeURIComponent("" + userNotifcationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNotificationRead(_response));
        });
    }

    protected processNotificationRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteNotification(userNotifcationId?: string | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Notification/DeleteNotification?";
        if (userNotifcationId === null)
            throw new Error("The parameter 'userNotifcationId' cannot be null.");
        else if (userNotifcationId !== undefined)
            url_ += "userNotifcationId=" + encodeURIComponent("" + userNotifcationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteNotification(_response));
        });
    }

    protected processDeleteNotification(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }
}

export class ProductClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    productItems(dto: ProductItemSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<ProductItemDTO[]> {
        let url_ = this.baseUrl + "/Product/ProductItems?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProductItems(_response));
        });
    }

    protected processProductItems(response: AxiosResponse): Promise<ProductItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductItemDTO[]>(null as any);
    }

    topProductItems(dealerAccountUid?: string | null | undefined, page?: number | undefined, pageTake?: number | undefined, signal?: AbortSignal): Promise<ProductItemDTO[]> {
        let url_ = this.baseUrl + "/Product/TopProductItems?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageTake === null)
            throw new Error("The parameter 'pageTake' cannot be null.");
        else if (pageTake !== undefined)
            url_ += "pageTake=" + encodeURIComponent("" + pageTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTopProductItems(_response));
        });
    }

    protected processTopProductItems(response: AxiosResponse): Promise<ProductItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductItemDTO[]>(null as any);
    }

    recentlyOrderedItems(dealerAccountUid?: string | null | undefined, vin?: string | null | undefined, signal?: AbortSignal): Promise<ProductItemDTO[]> {
        let url_ = this.baseUrl + "/Product/RecentlyOrderedItems?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRecentlyOrderedItems(_response));
        });
    }

    protected processRecentlyOrderedItems(response: AxiosResponse): Promise<ProductItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductItemDTO[]>(null as any);
    }

    alternateItem(dealerAccountUid?: string | null | undefined, itemId?: string | null | undefined, quantity?: number | undefined, signal?: AbortSignal): Promise<ProductItemDTO> {
        let url_ = this.baseUrl + "/Product/AlternateItem?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAlternateItem(_response));
        });
    }

    protected processAlternateItem(response: AxiosResponse): Promise<ProductItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductItemDTO.fromJS(resultData200);
            return Promise.resolve<ProductItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductItemDTO>(null as any);
    }

    itemSubcomponents(dealerAccountUid?: string | null | undefined, itemId?: string | null | undefined, signal?: AbortSignal): Promise<ProductItemDTO[]> {
        let url_ = this.baseUrl + "/Product/ItemSubcomponents?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processItemSubcomponents(_response));
        });
    }

    protected processItemSubcomponents(response: AxiosResponse): Promise<ProductItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductItemDTO[]>(null as any);
    }

    createSalesOrder(dto: CreateSalesOrderDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<DealerSalesOrderDTO> {
        let url_ = this.baseUrl + "/Product/CreateSalesOrder?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateSalesOrder(_response));
        });
    }

    protected processCreateSalesOrder(response: AxiosResponse): Promise<DealerSalesOrderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerSalesOrderDTO.fromJS(resultData200);
            return Promise.resolve<DealerSalesOrderDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = DealerSalesOrderDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerSalesOrderDTO>(null as any);
    }
}

export class SpiffClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSpiffs(dto: SpiffSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<SpiffDTO[]> {
        let url_ = this.baseUrl + "/Spiff/GetSpiffs?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSpiffs(_response));
        });
    }

    protected processGetSpiffs(response: AxiosResponse): Promise<SpiffDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiffDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SpiffDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpiffDTO[]>(null as any);
    }

    dynamicsVinInfo(dealerAccountUid?: string | null | undefined, vin?: string | null | undefined, signal?: AbortSignal): Promise<VinDTO> {
        let url_ = this.baseUrl + "/Spiff/DynamicsVinInfo?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDynamicsVinInfo(_response));
        });
    }

    protected processDynamicsVinInfo(response: AxiosResponse): Promise<VinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinDTO.fromJS(resultData200);
            return Promise.resolve<VinDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinDTO>(null as any);
    }

    requestSpiff(dto: CreateSpiffRequestDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<CreateSpiffRequestDTO> {
        let url_ = this.baseUrl + "/Spiff/RequestSpiff?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRequestSpiff(_response));
        });
    }

    protected processRequestSpiff(response: AxiosResponse): Promise<CreateSpiffRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateSpiffRequestDTO.fromJS(resultData200);
            return Promise.resolve<CreateSpiffRequestDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = CreateSpiffRequestDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSpiffRequestDTO>(null as any);
    }

    getSpiffSalesmen(dto: W9RequestSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<SpiffSalesmanDTO[]> {
        let url_ = this.baseUrl + "/Spiff/GetSpiffSalesmen?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSpiffSalesmen(_response));
        });
    }

    protected processGetSpiffSalesmen(response: AxiosResponse): Promise<SpiffSalesmanDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiffSalesmanDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SpiffSalesmanDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpiffSalesmanDTO[]>(null as any);
    }
}

export class VinClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    userVinRegistrations(signal?: AbortSignal): Promise<ViewVinRegistrationDTO[]> {
        let url_ = this.baseUrl + "/Vin/UserVinRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserVinRegistrations(_response));
        });
    }

    protected processUserVinRegistrations(response: AxiosResponse): Promise<ViewVinRegistrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewVinRegistrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ViewVinRegistrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewVinRegistrationDTO[]>(null as any);
    }

    userVinRegistration(vinRegistrationUid: string, signal?: AbortSignal): Promise<VinRegistrationDTO> {
        let url_ = this.baseUrl + "/Vin/{vinRegistrationUid}/UserVinRegistration";
        if (vinRegistrationUid === undefined || vinRegistrationUid === null)
            throw new Error("The parameter 'vinRegistrationUid' must be defined.");
        url_ = url_.replace("{vinRegistrationUid}", encodeURIComponent("" + vinRegistrationUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserVinRegistration(_response));
        });
    }

    protected processUserVinRegistration(response: AxiosResponse): Promise<VinRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<VinRegistrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinRegistrationDTO>(null as any);
    }

    getByUid(vehicleUid: string, signal?: AbortSignal): Promise<VinDTO> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByUid(_response));
        });
    }

    protected processGetByUid(response: AxiosResponse): Promise<VinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinDTO.fromJS(resultData200);
            return Promise.resolve<VinDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = VinDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinDTO>(null as any);
    }

    getImageByUid(vehicleUid: string, signal?: AbortSignal): Promise<ImageDTO> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/image";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetImageByUid(_response));
        });
    }

    protected processGetImageByUid(response: AxiosResponse): Promise<ImageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDTO.fromJS(resultData200);
            return Promise.resolve<ImageDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDTO>(null as any);
    }

    getVinUsers(vehicleUid: string, signal?: AbortSignal): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/users";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVinUsers(_response));
        });
    }

    protected processGetVinUsers(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    getClaims(vehicleUid: string, signal?: AbortSignal): Promise<ClaimDTO[]> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/claims";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClaims(_response));
        });
    }

    protected processGetClaims(response: AxiosResponse): Promise<ClaimDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClaimDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimDTO[]>(null as any);
    }

    getRecalls(vehicleUid: string, signal?: AbortSignal): Promise<RecallDTO[]> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/recalls";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRecalls(_response));
        });
    }

    protected processGetRecalls(response: AxiosResponse): Promise<RecallDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecallDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RecallDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecallDTO[]>(null as any);
    }

    inviteConsumerUser(vehicleUid: string, dto: InviteConsumerUserDTO, signal?: AbortSignal): Promise<InviteConsumerUserDTO> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/user";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInviteConsumerUser(_response));
        });
    }

    protected processInviteConsumerUser(response: AxiosResponse): Promise<InviteConsumerUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteConsumerUserDTO.fromJS(resultData200);
            return Promise.resolve<InviteConsumerUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = InviteConsumerUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteConsumerUserDTO>(null as any);
    }

    removeConsumerUser(vehicleUid: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/user/{userId}";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveConsumerUser(_response));
        });
    }

    protected processRemoveConsumerUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeConsumerVinRegistration(vehicleUid?: string | undefined, userId?: string | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Vin/RemoveConsumerVinRegistration?";
        if (vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' cannot be null.");
        else if (vehicleUid !== undefined)
            url_ += "vehicleUid=" + encodeURIComponent("" + vehicleUid) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveConsumerVinRegistration(_response));
        });
    }

    protected processRemoveConsumerVinRegistration(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ApiResultDTO.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    sendConsumerUserInvitation(vehicleUid: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/SendConsumerInvitation/{userId}";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendConsumerUserInvitation(_response));
        });
    }

    protected processSendConsumerUserInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    registerOwner(dto: VinOwnerRegistrationDTO, signal?: AbortSignal): Promise<VinOwnerRegistrationDTO> {
        let url_ = this.baseUrl + "/Vin/RegisterOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterOwner(_response));
        });
    }

    protected processRegisterOwner(response: AxiosResponse): Promise<VinOwnerRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinOwnerRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<VinOwnerRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = VinOwnerRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinOwnerRegistrationDTO>(null as any);
    }

    registrationStatus(dto: VinRegistrationStatusDTO, signal?: AbortSignal): Promise<VinRegistrationStatusDTO> {
        let url_ = this.baseUrl + "/Vin/RegistrationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegistrationStatus(_response));
        });
    }

    protected processRegistrationStatus(response: AxiosResponse): Promise<VinRegistrationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinRegistrationStatusDTO.fromJS(resultData200);
            return Promise.resolve<VinRegistrationStatusDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = VinRegistrationStatusDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinRegistrationStatusDTO>(null as any);
    }

    register(dto: UpdateVinRegistrationDTO, vehicleUid: string, signal?: AbortSignal): Promise<UpdateVinRegistrationDTO> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/Register";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<UpdateVinRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateVinRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<UpdateVinRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = UpdateVinRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateVinRegistrationDTO>(null as any);
    }

    deactivateRegistration(vehicleUid: string, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/DeactivateRegistration";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivateRegistration(_response));
        });
    }

    protected processDeactivateRegistration(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }

    getSalesOrders(vehicleUid: string, signal?: AbortSignal): Promise<SalesOrderDTO[]> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/salesOrders";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSalesOrders(_response));
        });
    }

    protected processGetSalesOrders(response: AxiosResponse): Promise<SalesOrderDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOrderDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOrderDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOrderDTO[]>(null as any);
    }

    ownersManual(vehicleUid: string, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/Vin/{vehicleUid}/OwnersManual";
        if (vehicleUid === undefined || vehicleUid === null)
            throw new Error("The parameter 'vehicleUid' must be defined.");
        url_ = url_.replace("{vehicleUid}", encodeURIComponent("" + vehicleUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOwnersManual(_response));
        });
    }

    protected processOwnersManual(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    userVehicleBrands(signal?: AbortSignal): Promise<BrandDTO[]> {
        let url_ = this.baseUrl + "/Vin/UserVehicleBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserVehicleBrands(_response));
        });
    }

    protected processUserVehicleBrands(response: AxiosResponse): Promise<BrandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrandDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandDTO[]>(null as any);
    }
}

export class W9RequestClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    w9Requests(dto: W9RequestSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<W9RequestDTO[]> {
        let url_ = this.baseUrl + "/W9Request/W9Requests?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processW9Requests(_response));
        });
    }

    protected processW9Requests(response: AxiosResponse): Promise<W9RequestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(W9RequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<W9RequestDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<W9RequestDTO[]>(null as any);
    }

    createW9Request(dto: W9RequestDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<VinWarrantyRegistrationDTO> {
        let url_ = this.baseUrl + "/W9Request/CreateW9Request?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateW9Request(_response));
        });
    }

    protected processCreateW9Request(response: AxiosResponse): Promise<VinWarrantyRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinWarrantyRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<VinWarrantyRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = VinWarrantyRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinWarrantyRegistrationDTO>(null as any);
    }
}

export class WarrantyRegistrationClient_V1 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    warrantyRegistrations(dto: WarrantyRegistrationSearchDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<WarrantyRegistrationDTO[]> {
        let url_ = this.baseUrl + "/WarrantyRegistration/WarrantyRegistrations?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRegistrations(_response));
        });
    }

    protected processWarrantyRegistrations(response: AxiosResponse): Promise<WarrantyRegistrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyRegistrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyRegistrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyRegistrationDTO[]>(null as any);
    }

    vinOwnerHistories(dealerAccountUid?: string | null | undefined, vin?: string | null | undefined, signal?: AbortSignal): Promise<VinOwnerHistoryDTO[]> {
        let url_ = this.baseUrl + "/WarrantyRegistration/VinOwnerHistories?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processVinOwnerHistories(_response));
        });
    }

    protected processVinOwnerHistories(response: AxiosResponse): Promise<VinOwnerHistoryDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VinOwnerHistoryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VinOwnerHistoryDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinOwnerHistoryDTO[]>(null as any);
    }

    dynamicsVinInfo(dealerAccountUid?: string | null | undefined, vin?: string | null | undefined, signal?: AbortSignal): Promise<VinDTO> {
        let url_ = this.baseUrl + "/WarrantyRegistration/DynamicsVinInfo?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDynamicsVinInfo(_response));
        });
    }

    protected processDynamicsVinInfo(response: AxiosResponse): Promise<VinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinDTO.fromJS(resultData200);
            return Promise.resolve<VinDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinDTO>(null as any);
    }

    warrantyRegistrationReport(dealerAccountUid?: string | null | undefined, vin?: string | null | undefined, signal?: AbortSignal): Promise<AttachmentInfoDTO> {
        let url_ = this.baseUrl + "/WarrantyRegistration/WarrantyRegistrationReport?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        if (vin !== undefined && vin !== null)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRegistrationReport(_response));
        });
    }

    protected processWarrantyRegistrationReport(response: AxiosResponse): Promise<AttachmentInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentInfoDTO.fromJS(resultData200);
            return Promise.resolve<AttachmentInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentInfoDTO>(null as any);
    }

    registerVinWarranty(dto: VinWarrantyRegistrationDTO, dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<VinWarrantyRegistrationDTO> {
        let url_ = this.baseUrl + "/WarrantyRegistration/RegisterVinWarranty?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterVinWarranty(_response));
        });
    }

    protected processRegisterVinWarranty(response: AxiosResponse): Promise<VinWarrantyRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VinWarrantyRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<VinWarrantyRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = VinWarrantyRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VinWarrantyRegistrationDTO>(null as any);
    }
}

export class InformationalVideoDTO implements IInformationalVideoDTO {
    videoId?: string | null;
    title?: string | null;
    description?: string | null;
    videoUrl?: string | null;
    previewImageUrl?: string | null;
    brandIds?: string[] | null;
    companies?: string[] | null;
    createdDate?: moment.Moment;

    constructor(data?: IInformationalVideoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"] !== undefined ? _data["videoId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.videoUrl = _data["videoUrl"] !== undefined ? _data["videoUrl"] : <any>null;
            this.previewImageUrl = _data["previewImageUrl"] !== undefined ? _data["previewImageUrl"] : <any>null;
            if (Array.isArray(_data["brandIds"])) {
                this.brandIds = [] as any;
                for (let item of _data["brandIds"])
                    this.brandIds!.push(item);
            }
            else {
                this.brandIds = <any>null;
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            else {
                this.companies = <any>null;
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): InformationalVideoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InformationalVideoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId !== undefined ? this.videoId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["videoUrl"] = this.videoUrl !== undefined ? this.videoUrl : <any>null;
        data["previewImageUrl"] = this.previewImageUrl !== undefined ? this.previewImageUrl : <any>null;
        if (Array.isArray(this.brandIds)) {
            data["brandIds"] = [];
            for (let item of this.brandIds)
                data["brandIds"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }

    clone(): InformationalVideoDTO {
        const json = this.toJSON();
        let result = new InformationalVideoDTO();
        result.init(json);
        return result;
    }
}

export interface IInformationalVideoDTO {
    videoId?: string | null;
    title?: string | null;
    description?: string | null;
    videoUrl?: string | null;
    previewImageUrl?: string | null;
    brandIds?: string[] | null;
    companies?: string[] | null;
    createdDate?: moment.Moment;
}

export class ChecklistDTO implements IChecklistDTO {
    uid?: string;
    name?: string | null;
    checklistType?: ChecklistTypes;

    constructor(data?: IChecklistDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.checklistType = _data["checklistType"] !== undefined ? _data["checklistType"] : <any>null;
        }
    }

    static fromJS(data: any): ChecklistDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["checklistType"] = this.checklistType !== undefined ? this.checklistType : <any>null;
        return data;
    }

    clone(): ChecklistDTO {
        const json = this.toJSON();
        let result = new ChecklistDTO();
        result.init(json);
        return result;
    }
}

export interface IChecklistDTO {
    uid?: string;
    name?: string | null;
    checklistType?: ChecklistTypes;
}

export enum ChecklistTypes {
    Unknown = 0,
    Trip = 1,
    Maintenance = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ValidationBaseDTO implements IValidationBaseDTO {
    isValid?: boolean;
    errors?: string[] | null;

    constructor(data?: IValidationBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): ValidationBaseDTO {
        const json = this.toJSON();
        let result = new ValidationBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IValidationBaseDTO {
    isValid?: boolean;
    errors?: string[] | null;
}

export class WebsiteContentLinkDTO extends ValidationBaseDTO implements IWebsiteContentLinkDTO {
    companyType?: CompanyTypes;
    blogPostsLink?: string | null;
    podcastLink?: string | null;
    frequentlyAskedQuestionsLink?: string | null;
    ownersClubLink?: string | null;
    ownersForumLink?: string | null;
    solarUrl?: string | null;
    retailStoreUrl?: string | null;

    constructor(data?: IWebsiteContentLinkDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.blogPostsLink = _data["blogPostsLink"] !== undefined ? _data["blogPostsLink"] : <any>null;
            this.podcastLink = _data["podcastLink"] !== undefined ? _data["podcastLink"] : <any>null;
            this.frequentlyAskedQuestionsLink = _data["frequentlyAskedQuestionsLink"] !== undefined ? _data["frequentlyAskedQuestionsLink"] : <any>null;
            this.ownersClubLink = _data["ownersClubLink"] !== undefined ? _data["ownersClubLink"] : <any>null;
            this.ownersForumLink = _data["ownersForumLink"] !== undefined ? _data["ownersForumLink"] : <any>null;
            this.solarUrl = _data["solarUrl"] !== undefined ? _data["solarUrl"] : <any>null;
            this.retailStoreUrl = _data["retailStoreUrl"] !== undefined ? _data["retailStoreUrl"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteContentLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteContentLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["blogPostsLink"] = this.blogPostsLink !== undefined ? this.blogPostsLink : <any>null;
        data["podcastLink"] = this.podcastLink !== undefined ? this.podcastLink : <any>null;
        data["frequentlyAskedQuestionsLink"] = this.frequentlyAskedQuestionsLink !== undefined ? this.frequentlyAskedQuestionsLink : <any>null;
        data["ownersClubLink"] = this.ownersClubLink !== undefined ? this.ownersClubLink : <any>null;
        data["ownersForumLink"] = this.ownersForumLink !== undefined ? this.ownersForumLink : <any>null;
        data["solarUrl"] = this.solarUrl !== undefined ? this.solarUrl : <any>null;
        data["retailStoreUrl"] = this.retailStoreUrl !== undefined ? this.retailStoreUrl : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): WebsiteContentLinkDTO {
        const json = this.toJSON();
        let result = new WebsiteContentLinkDTO();
        result.init(json);
        return result;
    }
}

export interface IWebsiteContentLinkDTO extends IValidationBaseDTO {
    companyType?: CompanyTypes;
    blogPostsLink?: string | null;
    podcastLink?: string | null;
    frequentlyAskedQuestionsLink?: string | null;
    ownersClubLink?: string | null;
    ownersForumLink?: string | null;
    solarUrl?: string | null;
    retailStoreUrl?: string | null;
}

export enum CompanyTypes {
    Unknown = 0,
    HRV = 1,
    CRV = 2,
    DRV = 3,
    Dealer = 4,
}

export class WebsitePostCategoryDTO extends ValidationBaseDTO implements IWebsitePostCategoryDTO {
    companyType?: CompanyTypes;
    categoryName?: string | null;
    categoryId?: number;

    constructor(data?: IWebsitePostCategoryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
        }
    }

    static fromJS(data: any): WebsitePostCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePostCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): WebsitePostCategoryDTO {
        const json = this.toJSON();
        let result = new WebsitePostCategoryDTO();
        result.init(json);
        return result;
    }
}

export interface IWebsitePostCategoryDTO extends IValidationBaseDTO {
    companyType?: CompanyTypes;
    categoryName?: string | null;
    categoryId?: number;
}

export class DealerAnnouncementDTO extends ValidationBaseDTO implements IDealerAnnouncementDTO {
    announcementUid?: string | null;
    title?: string | null;
    content?: string | null;
    isHtml?: boolean;
    expirationDateTime?: moment.Moment | null;
    sentDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment | null;
    updatedDateTime?: moment.Moment | null;
    hasAttachments?: boolean;

    constructor(data?: IDealerAnnouncementDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.announcementUid = _data["announcementUid"] !== undefined ? _data["announcementUid"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isHtml = _data["isHtml"] !== undefined ? _data["isHtml"] : <any>null;
            this.expirationDateTime = _data["expirationDateTime"] ? moment(_data["expirationDateTime"].toString()) : <any>null;
            this.sentDateTime = _data["sentDateTime"] ? moment(_data["sentDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.updatedDateTime = _data["updatedDateTime"] ? moment(_data["updatedDateTime"].toString()) : <any>null;
            this.hasAttachments = _data["hasAttachments"] !== undefined ? _data["hasAttachments"] : <any>null;
        }
    }

    static fromJS(data: any): DealerAnnouncementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerAnnouncementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementUid"] = this.announcementUid !== undefined ? this.announcementUid : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isHtml"] = this.isHtml !== undefined ? this.isHtml : <any>null;
        data["expirationDateTime"] = this.expirationDateTime ? this.expirationDateTime.toISOString() : <any>null;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["updatedDateTime"] = this.updatedDateTime ? this.updatedDateTime.toISOString() : <any>null;
        data["hasAttachments"] = this.hasAttachments !== undefined ? this.hasAttachments : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerAnnouncementDTO {
        const json = this.toJSON();
        let result = new DealerAnnouncementDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerAnnouncementDTO extends IValidationBaseDTO {
    announcementUid?: string | null;
    title?: string | null;
    content?: string | null;
    isHtml?: boolean;
    expirationDateTime?: moment.Moment | null;
    sentDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment | null;
    updatedDateTime?: moment.Moment | null;
    hasAttachments?: boolean;
}

export class CreateDealerAnnouncementDTO extends ValidationBaseDTO implements ICreateDealerAnnouncementDTO {
    title?: string | null;
    content?: string | null;
    isHtml?: boolean;
    expirationDate?: moment.Moment | null;
    attachmentUids?: string[] | null;

    constructor(data?: ICreateDealerAnnouncementDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isHtml = _data["isHtml"] !== undefined ? _data["isHtml"] : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            if (Array.isArray(_data["attachmentUids"])) {
                this.attachmentUids = [] as any;
                for (let item of _data["attachmentUids"])
                    this.attachmentUids!.push(item);
            }
            else {
                this.attachmentUids = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateDealerAnnouncementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealerAnnouncementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isHtml"] = this.isHtml !== undefined ? this.isHtml : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        if (Array.isArray(this.attachmentUids)) {
            data["attachmentUids"] = [];
            for (let item of this.attachmentUids)
                data["attachmentUids"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CreateDealerAnnouncementDTO {
        const json = this.toJSON();
        let result = new CreateDealerAnnouncementDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateDealerAnnouncementDTO extends IValidationBaseDTO {
    title?: string | null;
    content?: string | null;
    isHtml?: boolean;
    expirationDate?: moment.Moment | null;
    attachmentUids?: string[] | null;
}

export class DocumentDTO extends ValidationBaseDTO implements IDocumentDTO {
    documentUid?: string;
    documentType?: DocumentTypes;
    originalDocumentName?: string | null;
    storedDocumentName?: string | null;
    contentType?: string | null;
    uploadedBy?: string;
    uploadedDate?: moment.Moment;
    bytes?: string | null;

    constructor(data?: IDocumentDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentUid = _data["documentUid"] !== undefined ? _data["documentUid"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.originalDocumentName = _data["originalDocumentName"] !== undefined ? _data["originalDocumentName"] : <any>null;
            this.storedDocumentName = _data["storedDocumentName"] !== undefined ? _data["storedDocumentName"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.uploadedBy = _data["uploadedBy"] !== undefined ? _data["uploadedBy"] : <any>null;
            this.uploadedDate = _data["uploadedDate"] ? moment(_data["uploadedDate"].toString()) : <any>null;
            this.bytes = _data["bytes"] !== undefined ? _data["bytes"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentUid"] = this.documentUid !== undefined ? this.documentUid : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["originalDocumentName"] = this.originalDocumentName !== undefined ? this.originalDocumentName : <any>null;
        data["storedDocumentName"] = this.storedDocumentName !== undefined ? this.storedDocumentName : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["uploadedBy"] = this.uploadedBy !== undefined ? this.uploadedBy : <any>null;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>null;
        data["bytes"] = this.bytes !== undefined ? this.bytes : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentDTO {
        const json = this.toJSON();
        let result = new DocumentDTO();
        result.init(json);
        return result;
    }
}

export interface IDocumentDTO extends IValidationBaseDTO {
    documentUid?: string;
    documentType?: DocumentTypes;
    originalDocumentName?: string | null;
    storedDocumentName?: string | null;
    contentType?: string | null;
    uploadedBy?: string;
    uploadedDate?: moment.Moment;
    bytes?: string | null;
}

export enum DocumentTypes {
    Unknown = 0,
    BillOfSale = 1,
    ValidRVRegistration = 2,
    ValidTitle = 3,
    CustomRVImage = 4,
    W9Form = 5,
    ClaimLineAttachment = 6,
    Announcement = 7,
}

export class DealerAnnouncementDocumentDTO extends ValidationBaseDTO implements IDealerAnnouncementDocumentDTO {
    announcementUid?: string | null;
    announcementDocuments?: string[] | null;

    constructor(data?: IDealerAnnouncementDocumentDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.announcementUid = _data["announcementUid"] !== undefined ? _data["announcementUid"] : <any>null;
            if (Array.isArray(_data["announcementDocuments"])) {
                this.announcementDocuments = [] as any;
                for (let item of _data["announcementDocuments"])
                    this.announcementDocuments!.push(item);
            }
            else {
                this.announcementDocuments = <any>null;
            }
        }
    }

    static fromJS(data: any): DealerAnnouncementDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerAnnouncementDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementUid"] = this.announcementUid !== undefined ? this.announcementUid : <any>null;
        if (Array.isArray(this.announcementDocuments)) {
            data["announcementDocuments"] = [];
            for (let item of this.announcementDocuments)
                data["announcementDocuments"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DealerAnnouncementDocumentDTO {
        const json = this.toJSON();
        let result = new DealerAnnouncementDocumentDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerAnnouncementDocumentDTO extends IValidationBaseDTO {
    announcementUid?: string | null;
    announcementDocuments?: string[] | null;
}

export class DeleteDealerAnnouncementDocDTO extends ValidationBaseDTO implements IDeleteDealerAnnouncementDocDTO {
    announcementUid?: string | null;
    documentUid?: string | null;
    userId?: string;

    constructor(data?: IDeleteDealerAnnouncementDocDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.announcementUid = _data["announcementUid"] !== undefined ? _data["announcementUid"] : <any>null;
            this.documentUid = _data["documentUid"] !== undefined ? _data["documentUid"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteDealerAnnouncementDocDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDealerAnnouncementDocDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementUid"] = this.announcementUid !== undefined ? this.announcementUid : <any>null;
        data["documentUid"] = this.documentUid !== undefined ? this.documentUid : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeleteDealerAnnouncementDocDTO {
        const json = this.toJSON();
        let result = new DeleteDealerAnnouncementDocDTO();
        result.init(json);
        return result;
    }
}

export interface IDeleteDealerAnnouncementDocDTO extends IValidationBaseDTO {
    announcementUid?: string | null;
    documentUid?: string | null;
    userId?: string;
}

export class DealerClaimDTO extends ValidationBaseDTO implements IDealerClaimDTO {
    dealerUserId?: string | null;
    custAccount?: string | null;
    claimNumber?: string | null;
    vin?: string | null;
    status?: string | null;
    inServiceDate?: moment.Moment;
    dateOutOfService?: moment.Moment | null;
    updated?: moment.Moment;
    workOrderNumber?: string | null;
    checkNumber?: string | null;
    total?: number;
    vendorChargeback?: boolean;
    recallID?: string | null;
    totalItems?: number;
    brand?: string | null;
    model?: string | null;
    year?: string | null;
    claimType?: string | null;
    workCompleted?: boolean;
    partsMiscCostSubmitted?: boolean;
    submittedForPayment?: boolean;
    claimTotal?: number;
    laborTotal?: number;
    ownerName?: string | null;
    ownerAddress?: string | null;
    lines?: DealerClaimLineDTO[] | null;
    doUpdate?: boolean;
    autoDenied?: boolean;

    constructor(data?: IDealerClaimDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.custAccount = _data["custAccount"] !== undefined ? _data["custAccount"] : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.inServiceDate = _data["inServiceDate"] ? moment(_data["inServiceDate"].toString()) : <any>null;
            this.dateOutOfService = _data["dateOutOfService"] ? moment(_data["dateOutOfService"].toString()) : <any>null;
            this.updated = _data["updated"] ? moment(_data["updated"].toString()) : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.checkNumber = _data["checkNumber"] !== undefined ? _data["checkNumber"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.vendorChargeback = _data["vendorChargeback"] !== undefined ? _data["vendorChargeback"] : <any>null;
            this.recallID = _data["recallID"] !== undefined ? _data["recallID"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.claimType = _data["claimType"] !== undefined ? _data["claimType"] : <any>null;
            this.workCompleted = _data["workCompleted"] !== undefined ? _data["workCompleted"] : <any>null;
            this.partsMiscCostSubmitted = _data["partsMiscCostSubmitted"] !== undefined ? _data["partsMiscCostSubmitted"] : <any>null;
            this.submittedForPayment = _data["submittedForPayment"] !== undefined ? _data["submittedForPayment"] : <any>null;
            this.claimTotal = _data["claimTotal"] !== undefined ? _data["claimTotal"] : <any>null;
            this.laborTotal = _data["laborTotal"] !== undefined ? _data["laborTotal"] : <any>null;
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : <any>null;
            this.ownerAddress = _data["ownerAddress"] !== undefined ? _data["ownerAddress"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DealerClaimLineDTO.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
            this.autoDenied = _data["autoDenied"] !== undefined ? _data["autoDenied"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["custAccount"] = this.custAccount !== undefined ? this.custAccount : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["inServiceDate"] = this.inServiceDate ? this.inServiceDate.toISOString() : <any>null;
        data["dateOutOfService"] = this.dateOutOfService ? this.dateOutOfService.toISOString() : <any>null;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["checkNumber"] = this.checkNumber !== undefined ? this.checkNumber : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["vendorChargeback"] = this.vendorChargeback !== undefined ? this.vendorChargeback : <any>null;
        data["recallID"] = this.recallID !== undefined ? this.recallID : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["claimType"] = this.claimType !== undefined ? this.claimType : <any>null;
        data["workCompleted"] = this.workCompleted !== undefined ? this.workCompleted : <any>null;
        data["partsMiscCostSubmitted"] = this.partsMiscCostSubmitted !== undefined ? this.partsMiscCostSubmitted : <any>null;
        data["submittedForPayment"] = this.submittedForPayment !== undefined ? this.submittedForPayment : <any>null;
        data["claimTotal"] = this.claimTotal !== undefined ? this.claimTotal : <any>null;
        data["laborTotal"] = this.laborTotal !== undefined ? this.laborTotal : <any>null;
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : <any>null;
        data["ownerAddress"] = this.ownerAddress !== undefined ? this.ownerAddress : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        data["autoDenied"] = this.autoDenied !== undefined ? this.autoDenied : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerClaimDTO {
        const json = this.toJSON();
        let result = new DealerClaimDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimDTO extends IValidationBaseDTO {
    dealerUserId?: string | null;
    custAccount?: string | null;
    claimNumber?: string | null;
    vin?: string | null;
    status?: string | null;
    inServiceDate?: moment.Moment;
    dateOutOfService?: moment.Moment | null;
    updated?: moment.Moment;
    workOrderNumber?: string | null;
    checkNumber?: string | null;
    total?: number;
    vendorChargeback?: boolean;
    recallID?: string | null;
    totalItems?: number;
    brand?: string | null;
    model?: string | null;
    year?: string | null;
    claimType?: string | null;
    workCompleted?: boolean;
    partsMiscCostSubmitted?: boolean;
    submittedForPayment?: boolean;
    claimTotal?: number;
    laborTotal?: number;
    ownerName?: string | null;
    ownerAddress?: string | null;
    lines?: DealerClaimLineDTO[] | null;
    doUpdate?: boolean;
    autoDenied?: boolean;
}

export class DealerClaimLineDTO implements IDealerClaimLineDTO {
    id?: number;
    warrantyClassCode?: string | null;
    description?: string | null;
    remedyCode?: string | null;
    failureCode?: string | null;
    status?: string | null;
    subletAmount?: number;
    laborRate?: number;
    frcHours?: number;
    hoursRequested?: number;
    hoursApproved?: number;
    awaitingPartsReturn?: boolean;
    awaitingPhoto?: boolean;
    workCompleted?: boolean;
    dealerCanceledDenied?: string | null;
    dealerCanceledDeniedReason?: string | null;
    items?: DealerClaimLineItemDTO[] | null;
    miscCharges?: DealerClaimLineMiscChargeDTO[] | null;
    notes?: DealerClaimLineNoteDTO[] | null;
    attachments?: DealerClaimLineAttachmentDTO[] | null;
    doUpdate?: boolean;

    constructor(data?: IDealerClaimLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.warrantyClassCode = _data["warrantyClassCode"] !== undefined ? _data["warrantyClassCode"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.remedyCode = _data["remedyCode"] !== undefined ? _data["remedyCode"] : <any>null;
            this.failureCode = _data["failureCode"] !== undefined ? _data["failureCode"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.subletAmount = _data["subletAmount"] !== undefined ? _data["subletAmount"] : <any>null;
            this.laborRate = _data["laborRate"] !== undefined ? _data["laborRate"] : <any>null;
            this.frcHours = _data["frcHours"] !== undefined ? _data["frcHours"] : <any>null;
            this.hoursRequested = _data["hoursRequested"] !== undefined ? _data["hoursRequested"] : <any>null;
            this.hoursApproved = _data["hoursApproved"] !== undefined ? _data["hoursApproved"] : <any>null;
            this.awaitingPartsReturn = _data["awaitingPartsReturn"] !== undefined ? _data["awaitingPartsReturn"] : <any>null;
            this.awaitingPhoto = _data["awaitingPhoto"] !== undefined ? _data["awaitingPhoto"] : <any>null;
            this.workCompleted = _data["workCompleted"] !== undefined ? _data["workCompleted"] : <any>null;
            this.dealerCanceledDenied = _data["dealerCanceledDenied"] !== undefined ? _data["dealerCanceledDenied"] : <any>null;
            this.dealerCanceledDeniedReason = _data["dealerCanceledDeniedReason"] !== undefined ? _data["dealerCanceledDeniedReason"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DealerClaimLineItemDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            if (Array.isArray(_data["miscCharges"])) {
                this.miscCharges = [] as any;
                for (let item of _data["miscCharges"])
                    this.miscCharges!.push(DealerClaimLineMiscChargeDTO.fromJS(item));
            }
            else {
                this.miscCharges = <any>null;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(DealerClaimLineNoteDTO.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DealerClaimLineAttachmentDTO.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["warrantyClassCode"] = this.warrantyClassCode !== undefined ? this.warrantyClassCode : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["remedyCode"] = this.remedyCode !== undefined ? this.remedyCode : <any>null;
        data["failureCode"] = this.failureCode !== undefined ? this.failureCode : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["subletAmount"] = this.subletAmount !== undefined ? this.subletAmount : <any>null;
        data["laborRate"] = this.laborRate !== undefined ? this.laborRate : <any>null;
        data["frcHours"] = this.frcHours !== undefined ? this.frcHours : <any>null;
        data["hoursRequested"] = this.hoursRequested !== undefined ? this.hoursRequested : <any>null;
        data["hoursApproved"] = this.hoursApproved !== undefined ? this.hoursApproved : <any>null;
        data["awaitingPartsReturn"] = this.awaitingPartsReturn !== undefined ? this.awaitingPartsReturn : <any>null;
        data["awaitingPhoto"] = this.awaitingPhoto !== undefined ? this.awaitingPhoto : <any>null;
        data["workCompleted"] = this.workCompleted !== undefined ? this.workCompleted : <any>null;
        data["dealerCanceledDenied"] = this.dealerCanceledDenied !== undefined ? this.dealerCanceledDenied : <any>null;
        data["dealerCanceledDeniedReason"] = this.dealerCanceledDeniedReason !== undefined ? this.dealerCanceledDeniedReason : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.miscCharges)) {
            data["miscCharges"] = [];
            for (let item of this.miscCharges)
                data["miscCharges"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        return data;
    }

    clone(): DealerClaimLineDTO {
        const json = this.toJSON();
        let result = new DealerClaimLineDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimLineDTO {
    id?: number;
    warrantyClassCode?: string | null;
    description?: string | null;
    remedyCode?: string | null;
    failureCode?: string | null;
    status?: string | null;
    subletAmount?: number;
    laborRate?: number;
    frcHours?: number;
    hoursRequested?: number;
    hoursApproved?: number;
    awaitingPartsReturn?: boolean;
    awaitingPhoto?: boolean;
    workCompleted?: boolean;
    dealerCanceledDenied?: string | null;
    dealerCanceledDeniedReason?: string | null;
    items?: DealerClaimLineItemDTO[] | null;
    miscCharges?: DealerClaimLineMiscChargeDTO[] | null;
    notes?: DealerClaimLineNoteDTO[] | null;
    attachments?: DealerClaimLineAttachmentDTO[] | null;
    doUpdate?: boolean;
}

export class DealerClaimLineItemDTO implements IDealerClaimLineItemDTO {
    id?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    quantity?: number;
    price?: number;
    status?: string | null;
    declineReason?: string | null;
    doUpdate?: boolean;

    constructor(data?: IDealerClaimLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.itemDescription = _data["itemDescription"] !== undefined ? _data["itemDescription"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.declineReason = _data["declineReason"] !== undefined ? _data["declineReason"] : <any>null;
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["itemDescription"] = this.itemDescription !== undefined ? this.itemDescription : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["declineReason"] = this.declineReason !== undefined ? this.declineReason : <any>null;
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        return data;
    }

    clone(): DealerClaimLineItemDTO {
        const json = this.toJSON();
        let result = new DealerClaimLineItemDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimLineItemDTO {
    id?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    quantity?: number;
    price?: number;
    status?: string | null;
    declineReason?: string | null;
    doUpdate?: boolean;
}

export class DealerClaimLineMiscChargeDTO extends ValidationBaseDTO implements IDealerClaimLineMiscChargeDTO {
    id?: number;
    markupCode?: string | null;
    amount?: number;
    description?: string | null;
    status?: string | null;
    declineReason?: string | null;
    doUpdate?: boolean;

    constructor(data?: IDealerClaimLineMiscChargeDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.markupCode = _data["markupCode"] !== undefined ? _data["markupCode"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.declineReason = _data["declineReason"] !== undefined ? _data["declineReason"] : <any>null;
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimLineMiscChargeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimLineMiscChargeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["markupCode"] = this.markupCode !== undefined ? this.markupCode : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["declineReason"] = this.declineReason !== undefined ? this.declineReason : <any>null;
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerClaimLineMiscChargeDTO {
        const json = this.toJSON();
        let result = new DealerClaimLineMiscChargeDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimLineMiscChargeDTO extends IValidationBaseDTO {
    id?: number;
    markupCode?: string | null;
    amount?: number;
    description?: string | null;
    status?: string | null;
    declineReason?: string | null;
    doUpdate?: boolean;
}

export class DealerClaimLineNoteDTO implements IDealerClaimLineNoteDTO {
    id?: number;
    name?: string | null;
    userId?: string | null;
    note?: string | null;
    created?: moment.Moment;
    doUpdate?: boolean;

    constructor(data?: IDealerClaimLineNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>null;
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimLineNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimLineNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        return data;
    }

    clone(): DealerClaimLineNoteDTO {
        const json = this.toJSON();
        let result = new DealerClaimLineNoteDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimLineNoteDTO {
    id?: number;
    name?: string | null;
    userId?: string | null;
    note?: string | null;
    created?: moment.Moment;
    doUpdate?: boolean;
}

export class DealerClaimLineAttachmentDTO implements IDealerClaimLineAttachmentDTO {
    id?: number;
    type?: string | null;
    description?: string | null;
    fileName?: string | null;
    url?: string | null;
    created?: moment.Moment;
    createdBy?: string | null;
    doUpdate?: boolean;

    constructor(data?: IDealerClaimLineAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimLineAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimLineAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        return data;
    }

    clone(): DealerClaimLineAttachmentDTO {
        const json = this.toJSON();
        let result = new DealerClaimLineAttachmentDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimLineAttachmentDTO {
    id?: number;
    type?: string | null;
    description?: string | null;
    fileName?: string | null;
    url?: string | null;
    created?: moment.Moment;
    createdBy?: string | null;
    doUpdate?: boolean;
}

export class PaginationBaseRequestDTO implements IPaginationBaseRequestDTO {
    dealerUserUid?: string | null;
    page?: number | null;
    pageTake?: number | null;
    searchInput?: string | null;

    constructor(data?: IPaginationBaseRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerUserUid = _data["dealerUserUid"] !== undefined ? _data["dealerUserUid"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageTake = _data["pageTake"] !== undefined ? _data["pageTake"] : <any>null;
            this.searchInput = _data["searchInput"] !== undefined ? _data["searchInput"] : <any>null;
        }
    }

    static fromJS(data: any): PaginationBaseRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationBaseRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserUid"] = this.dealerUserUid !== undefined ? this.dealerUserUid : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageTake"] = this.pageTake !== undefined ? this.pageTake : <any>null;
        data["searchInput"] = this.searchInput !== undefined ? this.searchInput : <any>null;
        return data;
    }

    clone(): PaginationBaseRequestDTO {
        const json = this.toJSON();
        let result = new PaginationBaseRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IPaginationBaseRequestDTO {
    dealerUserUid?: string | null;
    page?: number | null;
    pageTake?: number | null;
    searchInput?: string | null;
}

export class DealerClaimSearchDTO extends PaginationBaseRequestDTO implements IDealerClaimSearchDTO {
    autoDenied?: boolean;
    vin?: string | null;
    statusType?: string | null;
    claimNumber?: string | null;
    recallId?: string | null;
    workOrderNumber?: string | null;
    agingRange?: boolean;
    hideClosed?: boolean;

    constructor(data?: IDealerClaimSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.autoDenied = _data["autoDenied"] !== undefined ? _data["autoDenied"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.statusType = _data["statusType"] !== undefined ? _data["statusType"] : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.agingRange = _data["agingRange"] !== undefined ? _data["agingRange"] : <any>null;
            this.hideClosed = _data["hideClosed"] !== undefined ? _data["hideClosed"] : <any>null;
        }
    }

    static fromJS(data: any): DealerClaimSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerClaimSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoDenied"] = this.autoDenied !== undefined ? this.autoDenied : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["statusType"] = this.statusType !== undefined ? this.statusType : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["agingRange"] = this.agingRange !== undefined ? this.agingRange : <any>null;
        data["hideClosed"] = this.hideClosed !== undefined ? this.hideClosed : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerClaimSearchDTO {
        const json = this.toJSON();
        let result = new DealerClaimSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerClaimSearchDTO extends IPaginationBaseRequestDTO {
    autoDenied?: boolean;
    vin?: string | null;
    statusType?: string | null;
    claimNumber?: string | null;
    recallId?: string | null;
    workOrderNumber?: string | null;
    agingRange?: boolean;
    hideClosed?: boolean;
}

export class CreateClaimDTO implements ICreateClaimDTO {
    userId?: string | null;
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    workOrderNumber?: string | null;
    inServiceDate?: moment.Moment;
    recallId?: string | null;
    remedyCode?: string | null;

    constructor(data?: ICreateClaimDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.dealerLocationDynamicsId = _data["dealerLocationDynamicsId"] !== undefined ? _data["dealerLocationDynamicsId"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.inServiceDate = _data["inServiceDate"] ? moment(_data["inServiceDate"].toString()) : <any>null;
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.remedyCode = _data["remedyCode"] !== undefined ? _data["remedyCode"] : <any>null;
        }
    }

    static fromJS(data: any): CreateClaimDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaimDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["dealerLocationDynamicsId"] = this.dealerLocationDynamicsId !== undefined ? this.dealerLocationDynamicsId : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["inServiceDate"] = this.inServiceDate ? this.inServiceDate.toISOString() : <any>null;
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["remedyCode"] = this.remedyCode !== undefined ? this.remedyCode : <any>null;
        return data;
    }

    clone(): CreateClaimDTO {
        const json = this.toJSON();
        let result = new CreateClaimDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateClaimDTO {
    userId?: string | null;
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    workOrderNumber?: string | null;
    inServiceDate?: moment.Moment;
    recallId?: string | null;
    remedyCode?: string | null;
}

export class CreateClaimLineDTO implements ICreateClaimLineDTO {
    dealerUserId?: string | null;
    claimNumber?: string | null;
    warrantyClassCode?: string | null;
    remedyCode?: string | null;
    failureCode?: string | null;

    constructor(data?: ICreateClaimLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.warrantyClassCode = _data["warrantyClassCode"] !== undefined ? _data["warrantyClassCode"] : <any>null;
            this.remedyCode = _data["remedyCode"] !== undefined ? _data["remedyCode"] : <any>null;
            this.failureCode = _data["failureCode"] !== undefined ? _data["failureCode"] : <any>null;
        }
    }

    static fromJS(data: any): CreateClaimLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaimLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["warrantyClassCode"] = this.warrantyClassCode !== undefined ? this.warrantyClassCode : <any>null;
        data["remedyCode"] = this.remedyCode !== undefined ? this.remedyCode : <any>null;
        data["failureCode"] = this.failureCode !== undefined ? this.failureCode : <any>null;
        return data;
    }

    clone(): CreateClaimLineDTO {
        const json = this.toJSON();
        let result = new CreateClaimLineDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateClaimLineDTO {
    dealerUserId?: string | null;
    claimNumber?: string | null;
    warrantyClassCode?: string | null;
    remedyCode?: string | null;
    failureCode?: string | null;
}

export class CreateClaimLineItemDTO implements ICreateClaimLineItemDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    itemNumber?: string | null;
    quantity?: number;

    constructor(data?: ICreateClaimLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.claimLineId = _data["claimLineId"] !== undefined ? _data["claimLineId"] : <any>null;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): CreateClaimLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaimLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["claimLineId"] = this.claimLineId !== undefined ? this.claimLineId : <any>null;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data;
    }

    clone(): CreateClaimLineItemDTO {
        const json = this.toJSON();
        let result = new CreateClaimLineItemDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateClaimLineItemDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    itemNumber?: string | null;
    quantity?: number;
}

export class CreateClaimLineMiscChargeDTO implements ICreateClaimLineMiscChargeDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    markupCode?: string | null;
    amount?: number;
    description?: string | null;

    constructor(data?: ICreateClaimLineMiscChargeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.claimLineId = _data["claimLineId"] !== undefined ? _data["claimLineId"] : <any>null;
            this.markupCode = _data["markupCode"] !== undefined ? _data["markupCode"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): CreateClaimLineMiscChargeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaimLineMiscChargeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["claimLineId"] = this.claimLineId !== undefined ? this.claimLineId : <any>null;
        data["markupCode"] = this.markupCode !== undefined ? this.markupCode : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): CreateClaimLineMiscChargeDTO {
        const json = this.toJSON();
        let result = new CreateClaimLineMiscChargeDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateClaimLineMiscChargeDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    markupCode?: string | null;
    amount?: number;
    description?: string | null;
}

export class CreateClaimLineAttachmentDTO implements ICreateClaimLineAttachmentDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    documentUids?: string[] | null;

    constructor(data?: ICreateClaimLineAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.claimLineId = _data["claimLineId"] !== undefined ? _data["claimLineId"] : <any>null;
            if (Array.isArray(_data["documentUids"])) {
                this.documentUids = [] as any;
                for (let item of _data["documentUids"])
                    this.documentUids!.push(item);
            }
            else {
                this.documentUids = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateClaimLineAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaimLineAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["claimLineId"] = this.claimLineId !== undefined ? this.claimLineId : <any>null;
        if (Array.isArray(this.documentUids)) {
            data["documentUids"] = [];
            for (let item of this.documentUids)
                data["documentUids"].push(item);
        }
        return data;
    }

    clone(): CreateClaimLineAttachmentDTO {
        const json = this.toJSON();
        let result = new CreateClaimLineAttachmentDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateClaimLineAttachmentDTO {
    dealerUserId?: string | null;
    claimLineId?: number;
    documentUids?: string[] | null;
}

export class CreateaClaimLineNoteDTO implements ICreateaClaimLineNoteDTO {
    claimLineId?: number;
    note?: string | null;
    dealerUserId?: string | null;

    constructor(data?: ICreateaClaimLineNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimLineId = _data["claimLineId"] !== undefined ? _data["claimLineId"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateaClaimLineNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateaClaimLineNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimLineId"] = this.claimLineId !== undefined ? this.claimLineId : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        return data;
    }

    clone(): CreateaClaimLineNoteDTO {
        const json = this.toJSON();
        let result = new CreateaClaimLineNoteDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateaClaimLineNoteDTO {
    claimLineId?: number;
    note?: string | null;
    dealerUserId?: string | null;
}

export class ReturnLabelDTO extends ValidationBaseDTO implements IReturnLabelDTO {
    claimId?: string | null;
    email?: string | null;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;

    constructor(data?: IReturnLabelDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): ReturnLabelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnLabelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimId"] = this.claimId !== undefined ? this.claimId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ReturnLabelDTO {
        const json = this.toJSON();
        let result = new ReturnLabelDTO();
        result.init(json);
        return result;
    }
}

export interface IReturnLabelDTO extends IValidationBaseDTO {
    claimId?: string | null;
    email?: string | null;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
}

export class ExportDTO implements IExportDTO {
    contentType?: string | null;
    base64?: string | null;
    fileName?: string | null;

    constructor(data?: IExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.base64 = _data["base64"] !== undefined ? _data["base64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): ExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["base64"] = this.base64 !== undefined ? this.base64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }

    clone(): ExportDTO {
        const json = this.toJSON();
        let result = new ExportDTO();
        result.init(json);
        return result;
    }
}

export interface IExportDTO {
    contentType?: string | null;
    base64?: string | null;
    fileName?: string | null;
}

export class AttachmentInfoDTO implements IAttachmentInfoDTO {
    id?: number;
    type?: string | null;
    description?: string | null;
    fileName?: string | null;
    url?: string | null;
    created?: moment.Moment;
    createdBy?: string | null;
    doUpdate?: boolean;

    constructor(data?: IAttachmentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.doUpdate = _data["doUpdate"] !== undefined ? _data["doUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): AttachmentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["doUpdate"] = this.doUpdate !== undefined ? this.doUpdate : <any>null;
        return data;
    }

    clone(): AttachmentInfoDTO {
        const json = this.toJSON();
        let result = new AttachmentInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IAttachmentInfoDTO {
    id?: number;
    type?: string | null;
    description?: string | null;
    fileName?: string | null;
    url?: string | null;
    created?: moment.Moment;
    createdBy?: string | null;
    doUpdate?: boolean;
}

export class DealerLocationDTO implements IDealerLocationDTO {
    id?: number;
    dealerId?: string | null;
    name?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    dealerURL?: string | null;
    latitude?: number;
    longitude?: number;
    brands?: string[] | null;
    serviceOnly?: boolean;
    companies?: string[] | null;
    companyTypes?: CompanyTypes[] | null;

    constructor(data?: IDealerLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dealerId = _data["dealerId"] !== undefined ? _data["dealerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.dealerURL = _data["dealerURL"] !== undefined ? _data["dealerURL"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            else {
                this.brands = <any>null;
            }
            this.serviceOnly = _data["serviceOnly"] !== undefined ? _data["serviceOnly"] : <any>null;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            else {
                this.companies = <any>null;
            }
            if (Array.isArray(_data["companyTypes"])) {
                this.companyTypes = [] as any;
                for (let item of _data["companyTypes"])
                    this.companyTypes!.push(item);
            }
            else {
                this.companyTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): DealerLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dealerId"] = this.dealerId !== undefined ? this.dealerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["dealerURL"] = this.dealerURL !== undefined ? this.dealerURL : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        data["serviceOnly"] = this.serviceOnly !== undefined ? this.serviceOnly : <any>null;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        if (Array.isArray(this.companyTypes)) {
            data["companyTypes"] = [];
            for (let item of this.companyTypes)
                data["companyTypes"].push(item);
        }
        return data;
    }

    clone(): DealerLocationDTO {
        const json = this.toJSON();
        let result = new DealerLocationDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerLocationDTO {
    id?: number;
    dealerId?: string | null;
    name?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    dealerURL?: string | null;
    latitude?: number;
    longitude?: number;
    brands?: string[] | null;
    serviceOnly?: boolean;
    companies?: string[] | null;
    companyTypes?: CompanyTypes[] | null;
}

export class DealerChainGroupDTO implements IDealerChainGroupDTO {
    id?: number;
    dynamicsId?: string | null;
    description?: string | null;

    constructor(data?: IDealerChainGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dynamicsId = _data["dynamicsId"] !== undefined ? _data["dynamicsId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): DealerChainGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerChainGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dynamicsId"] = this.dynamicsId !== undefined ? this.dynamicsId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): DealerChainGroupDTO {
        const json = this.toJSON();
        let result = new DealerChainGroupDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerChainGroupDTO {
    id?: number;
    dynamicsId?: string | null;
    description?: string | null;
}

export class DealerAddressInfoDTO implements IDealerAddressInfoDTO {
    address?: string | null;
    locationId?: number;
    name?: string | null;

    constructor(data?: IDealerAddressInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): DealerAddressInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerAddressInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): DealerAddressInfoDTO {
        const json = this.toJSON();
        let result = new DealerAddressInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerAddressInfoDTO {
    address?: string | null;
    locationId?: number;
    name?: string | null;
}

export class UserDealerLocationsDTO implements IUserDealerLocationsDTO {
    dealerLocationsFlat?: DealerLocationDTO[] | null;
    dealerLocations?: DealerLocationDTO[] | null;
    dealerChainGroups?: DealerChainGroupDTO[] | null;

    constructor(data?: IUserDealerLocationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dealerLocationsFlat"])) {
                this.dealerLocationsFlat = [] as any;
                for (let item of _data["dealerLocationsFlat"])
                    this.dealerLocationsFlat!.push(DealerLocationDTO.fromJS(item));
            }
            else {
                this.dealerLocationsFlat = <any>null;
            }
            if (Array.isArray(_data["dealerLocations"])) {
                this.dealerLocations = [] as any;
                for (let item of _data["dealerLocations"])
                    this.dealerLocations!.push(DealerLocationDTO.fromJS(item));
            }
            else {
                this.dealerLocations = <any>null;
            }
            if (Array.isArray(_data["dealerChainGroups"])) {
                this.dealerChainGroups = [] as any;
                for (let item of _data["dealerChainGroups"])
                    this.dealerChainGroups!.push(DealerChainGroupDTO.fromJS(item));
            }
            else {
                this.dealerChainGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): UserDealerLocationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDealerLocationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dealerLocationsFlat)) {
            data["dealerLocationsFlat"] = [];
            for (let item of this.dealerLocationsFlat)
                data["dealerLocationsFlat"].push(item.toJSON());
        }
        if (Array.isArray(this.dealerLocations)) {
            data["dealerLocations"] = [];
            for (let item of this.dealerLocations)
                data["dealerLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.dealerChainGroups)) {
            data["dealerChainGroups"] = [];
            for (let item of this.dealerChainGroups)
                data["dealerChainGroups"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDealerLocationsDTO {
        const json = this.toJSON();
        let result = new UserDealerLocationsDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDealerLocationsDTO {
    dealerLocationsFlat?: DealerLocationDTO[] | null;
    dealerLocations?: DealerLocationDTO[] | null;
    dealerChainGroups?: DealerChainGroupDTO[] | null;
}

export class InviteDealerUserDTO extends ValidationBaseDTO implements IInviteDealerUserDTO {
    firstName!: string;
    lastName!: string;
    email!: string;
    currentTitle?: string | null;
    roles?: string[] | null;
    multipleInviteDealer?: InviteDealerDTO[] | null;
    dealerAccountUid?: string | null;
    isNewUser?: boolean | null;

    constructor(data?: IInviteDealerUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.currentTitle = _data["currentTitle"] !== undefined ? _data["currentTitle"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            if (Array.isArray(_data["multipleInviteDealer"])) {
                this.multipleInviteDealer = [] as any;
                for (let item of _data["multipleInviteDealer"])
                    this.multipleInviteDealer!.push(InviteDealerDTO.fromJS(item));
            }
            else {
                this.multipleInviteDealer = <any>null;
            }
            this.dealerAccountUid = _data["dealerAccountUid"] !== undefined ? _data["dealerAccountUid"] : <any>null;
            this.isNewUser = _data["isNewUser"] !== undefined ? _data["isNewUser"] : <any>null;
        }
    }

    static fromJS(data: any): InviteDealerUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InviteDealerUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["currentTitle"] = this.currentTitle !== undefined ? this.currentTitle : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.multipleInviteDealer)) {
            data["multipleInviteDealer"] = [];
            for (let item of this.multipleInviteDealer)
                data["multipleInviteDealer"].push(item.toJSON());
        }
        data["dealerAccountUid"] = this.dealerAccountUid !== undefined ? this.dealerAccountUid : <any>null;
        data["isNewUser"] = this.isNewUser !== undefined ? this.isNewUser : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): InviteDealerUserDTO {
        const json = this.toJSON();
        let result = new InviteDealerUserDTO();
        result.init(json);
        return result;
    }
}

export interface IInviteDealerUserDTO extends IValidationBaseDTO {
    firstName: string;
    lastName: string;
    email: string;
    currentTitle?: string | null;
    roles?: string[] | null;
    multipleInviteDealer?: InviteDealerDTO[] | null;
    dealerAccountUid?: string | null;
    isNewUser?: boolean | null;
}

export class InviteDealerDTO implements IInviteDealerDTO {
    isChainGroup?: boolean;
    dealerLocationId?: number | null;
    dealerChainGroupId?: number | null;
    dealerName?: string | null;
    dynamicsId?: string | null;

    constructor(data?: IInviteDealerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChainGroup = _data["isChainGroup"] !== undefined ? _data["isChainGroup"] : <any>null;
            this.dealerLocationId = _data["dealerLocationId"] !== undefined ? _data["dealerLocationId"] : <any>null;
            this.dealerChainGroupId = _data["dealerChainGroupId"] !== undefined ? _data["dealerChainGroupId"] : <any>null;
            this.dealerName = _data["dealerName"] !== undefined ? _data["dealerName"] : <any>null;
            this.dynamicsId = _data["dynamicsId"] !== undefined ? _data["dynamicsId"] : <any>null;
        }
    }

    static fromJS(data: any): InviteDealerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InviteDealerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChainGroup"] = this.isChainGroup !== undefined ? this.isChainGroup : <any>null;
        data["dealerLocationId"] = this.dealerLocationId !== undefined ? this.dealerLocationId : <any>null;
        data["dealerChainGroupId"] = this.dealerChainGroupId !== undefined ? this.dealerChainGroupId : <any>null;
        data["dealerName"] = this.dealerName !== undefined ? this.dealerName : <any>null;
        data["dynamicsId"] = this.dynamicsId !== undefined ? this.dynamicsId : <any>null;
        return data;
    }

    clone(): InviteDealerDTO {
        const json = this.toJSON();
        let result = new InviteDealerDTO();
        result.init(json);
        return result;
    }
}

export interface IInviteDealerDTO {
    isChainGroup?: boolean;
    dealerLocationId?: number | null;
    dealerChainGroupId?: number | null;
    dealerName?: string | null;
    dynamicsId?: string | null;
}

export class CompleteDealerRegistrationDTO extends ValidationBaseDTO implements ICompleteDealerRegistrationDTO {
    firstName!: string;
    lastName!: string;
    email!: string;
    code!: string;
    userId!: string;
    password!: string;
    confirmPassword!: string;
    phoneNumber!: string;

    constructor(data?: ICompleteDealerRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): CompleteDealerRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteDealerRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CompleteDealerRegistrationDTO {
        const json = this.toJSON();
        let result = new CompleteDealerRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface ICompleteDealerRegistrationDTO extends IValidationBaseDTO {
    firstName: string;
    lastName: string;
    email: string;
    code: string;
    userId: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
}

export class UserDTO extends ValidationBaseDTO implements IUserDTO {
    userId?: string;
    userName?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    currentTitle?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    lockoutEnd?: moment.Moment | null;
    emailConfirmed?: boolean;
    roles?: string[] | null;
    lastLoginDate?: moment.Moment | null;
    createdDate?: moment.Moment;

    constructor(data?: IUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.currentTitle = _data["currentTitle"] !== undefined ? _data["currentTitle"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.lockoutEnd = _data["lockoutEnd"] ? moment(_data["lockoutEnd"].toString()) : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.lastLoginDate = _data["lastLoginDate"] ? moment(_data["lastLoginDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["currentTitle"] = this.currentTitle !== undefined ? this.currentTitle : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserDTO {
        const json = this.toJSON();
        let result = new UserDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDTO extends IValidationBaseDTO {
    userId?: string;
    userName?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    currentTitle?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    lockoutEnd?: moment.Moment | null;
    emailConfirmed?: boolean;
    roles?: string[] | null;
    lastLoginDate?: moment.Moment | null;
    createdDate?: moment.Moment;
}

export class DealerUserDTO extends UserDTO implements IDealerUserDTO {
    dealerAccounts?: DealerAccountDTO[] | null;
    totalCount?: number;

    constructor(data?: IDealerUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dealerAccounts"])) {
                this.dealerAccounts = [] as any;
                for (let item of _data["dealerAccounts"])
                    this.dealerAccounts!.push(DealerAccountDTO.fromJS(item));
            }
            else {
                this.dealerAccounts = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): DealerUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dealerAccounts)) {
            data["dealerAccounts"] = [];
            for (let item of this.dealerAccounts)
                data["dealerAccounts"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerUserDTO {
        const json = this.toJSON();
        let result = new DealerUserDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerUserDTO extends IUserDTO {
    dealerAccounts?: DealerAccountDTO[] | null;
    totalCount?: number;
}

export class DealerAccountDTO extends ValidationBaseDTO implements IDealerAccountDTO {
    id?: number | null;
    dynamicsId?: string | null;
    uid?: string | null;
    dealerName?: string | null;
    dealerChainGroupId?: number | null;
    dealerLocationId?: number | null;

    constructor(data?: IDealerAccountDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dynamicsId = _data["dynamicsId"] !== undefined ? _data["dynamicsId"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.dealerName = _data["dealerName"] !== undefined ? _data["dealerName"] : <any>null;
            this.dealerChainGroupId = _data["dealerChainGroupId"] !== undefined ? _data["dealerChainGroupId"] : <any>null;
            this.dealerLocationId = _data["dealerLocationId"] !== undefined ? _data["dealerLocationId"] : <any>null;
        }
    }

    static fromJS(data: any): DealerAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dynamicsId"] = this.dynamicsId !== undefined ? this.dynamicsId : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["dealerName"] = this.dealerName !== undefined ? this.dealerName : <any>null;
        data["dealerChainGroupId"] = this.dealerChainGroupId !== undefined ? this.dealerChainGroupId : <any>null;
        data["dealerLocationId"] = this.dealerLocationId !== undefined ? this.dealerLocationId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerAccountDTO {
        const json = this.toJSON();
        let result = new DealerAccountDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerAccountDTO extends IValidationBaseDTO {
    id?: number | null;
    dynamicsId?: string | null;
    uid?: string | null;
    dealerName?: string | null;
    dealerChainGroupId?: number | null;
    dealerLocationId?: number | null;
}

export class ApiResultDTO extends ValidationBaseDTO implements IApiResultDTO {

    constructor(data?: IApiResultDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ApiResultDTO {
        const json = this.toJSON();
        let result = new ApiResultDTO();
        result.init(json);
        return result;
    }
}

export interface IApiResultDTO extends IValidationBaseDTO {
}

export class EditDealerUserDTO extends ValidationBaseDTO implements IEditDealerUserDTO {
    userId?: string | null;
    editMultipleLocations?: DealerAccountDTO[] | null;
    roleName?: string | null;

    constructor(data?: IEditDealerUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["editMultipleLocations"])) {
                this.editMultipleLocations = [] as any;
                for (let item of _data["editMultipleLocations"])
                    this.editMultipleLocations!.push(DealerAccountDTO.fromJS(item));
            }
            else {
                this.editMultipleLocations = <any>null;
            }
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : <any>null;
        }
    }

    static fromJS(data: any): EditDealerUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditDealerUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.editMultipleLocations)) {
            data["editMultipleLocations"] = [];
            for (let item of this.editMultipleLocations)
                data["editMultipleLocations"].push(item.toJSON());
        }
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): EditDealerUserDTO {
        const json = this.toJSON();
        let result = new EditDealerUserDTO();
        result.init(json);
        return result;
    }
}

export interface IEditDealerUserDTO extends IValidationBaseDTO {
    userId?: string | null;
    editMultipleLocations?: DealerAccountDTO[] | null;
    roleName?: string | null;
}

export class ForgotPasswordDTO extends ValidationBaseDTO implements IForgotPasswordDTO {
    email!: string;
    companyType!: CompanyTypes;

    constructor(data?: IForgotPasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ForgotPasswordDTO {
        const json = this.toJSON();
        let result = new ForgotPasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDTO extends IValidationBaseDTO {
    email: string;
    companyType: CompanyTypes;
}

export class DealerDashboardDTO extends ValidationBaseDTO implements IDealerDashboardDTO {
    claims91To120Day?: number;
    claimsAwaitingPaymentApproval?: number;
    claimsAwaitingVendorApproval?: number;
    claimsAwaitPartReturn?: number;
    claimsAwaitWorkComplete?: number;
    claimsClosed?: number;
    claimsDealerFeedbackReq?: number;
    claimsNew?: number;
    claimsOEMFeedbackReq?: number;
    claimsOpen?: number;
    claimsPaymentApproved?: number;
    claimsPreAuthRequired?: number;
    claimsUnfinished?: number;
    salesCanceled?: number;
    salesDelivered?: number;
    salesInvoiced?: number;
    salesOpenOrder?: number;
    vinRegistered?: number;
    vinUnregistered?: number;
    vinRetailSold?: number;

    constructor(data?: IDealerDashboardDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.claims91To120Day = _data["claims91To120Day"] !== undefined ? _data["claims91To120Day"] : <any>null;
            this.claimsAwaitingPaymentApproval = _data["claimsAwaitingPaymentApproval"] !== undefined ? _data["claimsAwaitingPaymentApproval"] : <any>null;
            this.claimsAwaitingVendorApproval = _data["claimsAwaitingVendorApproval"] !== undefined ? _data["claimsAwaitingVendorApproval"] : <any>null;
            this.claimsAwaitPartReturn = _data["claimsAwaitPartReturn"] !== undefined ? _data["claimsAwaitPartReturn"] : <any>null;
            this.claimsAwaitWorkComplete = _data["claimsAwaitWorkComplete"] !== undefined ? _data["claimsAwaitWorkComplete"] : <any>null;
            this.claimsClosed = _data["claimsClosed"] !== undefined ? _data["claimsClosed"] : <any>null;
            this.claimsDealerFeedbackReq = _data["claimsDealerFeedbackReq"] !== undefined ? _data["claimsDealerFeedbackReq"] : <any>null;
            this.claimsNew = _data["claimsNew"] !== undefined ? _data["claimsNew"] : <any>null;
            this.claimsOEMFeedbackReq = _data["claimsOEMFeedbackReq"] !== undefined ? _data["claimsOEMFeedbackReq"] : <any>null;
            this.claimsOpen = _data["claimsOpen"] !== undefined ? _data["claimsOpen"] : <any>null;
            this.claimsPaymentApproved = _data["claimsPaymentApproved"] !== undefined ? _data["claimsPaymentApproved"] : <any>null;
            this.claimsPreAuthRequired = _data["claimsPreAuthRequired"] !== undefined ? _data["claimsPreAuthRequired"] : <any>null;
            this.claimsUnfinished = _data["claimsUnfinished"] !== undefined ? _data["claimsUnfinished"] : <any>null;
            this.salesCanceled = _data["salesCanceled"] !== undefined ? _data["salesCanceled"] : <any>null;
            this.salesDelivered = _data["salesDelivered"] !== undefined ? _data["salesDelivered"] : <any>null;
            this.salesInvoiced = _data["salesInvoiced"] !== undefined ? _data["salesInvoiced"] : <any>null;
            this.salesOpenOrder = _data["salesOpenOrder"] !== undefined ? _data["salesOpenOrder"] : <any>null;
            this.vinRegistered = _data["vinRegistered"] !== undefined ? _data["vinRegistered"] : <any>null;
            this.vinUnregistered = _data["vinUnregistered"] !== undefined ? _data["vinUnregistered"] : <any>null;
            this.vinRetailSold = _data["vinRetailSold"] !== undefined ? _data["vinRetailSold"] : <any>null;
        }
    }

    static fromJS(data: any): DealerDashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claims91To120Day"] = this.claims91To120Day !== undefined ? this.claims91To120Day : <any>null;
        data["claimsAwaitingPaymentApproval"] = this.claimsAwaitingPaymentApproval !== undefined ? this.claimsAwaitingPaymentApproval : <any>null;
        data["claimsAwaitingVendorApproval"] = this.claimsAwaitingVendorApproval !== undefined ? this.claimsAwaitingVendorApproval : <any>null;
        data["claimsAwaitPartReturn"] = this.claimsAwaitPartReturn !== undefined ? this.claimsAwaitPartReturn : <any>null;
        data["claimsAwaitWorkComplete"] = this.claimsAwaitWorkComplete !== undefined ? this.claimsAwaitWorkComplete : <any>null;
        data["claimsClosed"] = this.claimsClosed !== undefined ? this.claimsClosed : <any>null;
        data["claimsDealerFeedbackReq"] = this.claimsDealerFeedbackReq !== undefined ? this.claimsDealerFeedbackReq : <any>null;
        data["claimsNew"] = this.claimsNew !== undefined ? this.claimsNew : <any>null;
        data["claimsOEMFeedbackReq"] = this.claimsOEMFeedbackReq !== undefined ? this.claimsOEMFeedbackReq : <any>null;
        data["claimsOpen"] = this.claimsOpen !== undefined ? this.claimsOpen : <any>null;
        data["claimsPaymentApproved"] = this.claimsPaymentApproved !== undefined ? this.claimsPaymentApproved : <any>null;
        data["claimsPreAuthRequired"] = this.claimsPreAuthRequired !== undefined ? this.claimsPreAuthRequired : <any>null;
        data["claimsUnfinished"] = this.claimsUnfinished !== undefined ? this.claimsUnfinished : <any>null;
        data["salesCanceled"] = this.salesCanceled !== undefined ? this.salesCanceled : <any>null;
        data["salesDelivered"] = this.salesDelivered !== undefined ? this.salesDelivered : <any>null;
        data["salesInvoiced"] = this.salesInvoiced !== undefined ? this.salesInvoiced : <any>null;
        data["salesOpenOrder"] = this.salesOpenOrder !== undefined ? this.salesOpenOrder : <any>null;
        data["vinRegistered"] = this.vinRegistered !== undefined ? this.vinRegistered : <any>null;
        data["vinUnregistered"] = this.vinUnregistered !== undefined ? this.vinUnregistered : <any>null;
        data["vinRetailSold"] = this.vinRetailSold !== undefined ? this.vinRetailSold : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerDashboardDTO {
        const json = this.toJSON();
        let result = new DealerDashboardDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerDashboardDTO extends IValidationBaseDTO {
    claims91To120Day?: number;
    claimsAwaitingPaymentApproval?: number;
    claimsAwaitingVendorApproval?: number;
    claimsAwaitPartReturn?: number;
    claimsAwaitWorkComplete?: number;
    claimsClosed?: number;
    claimsDealerFeedbackReq?: number;
    claimsNew?: number;
    claimsOEMFeedbackReq?: number;
    claimsOpen?: number;
    claimsPaymentApproved?: number;
    claimsPreAuthRequired?: number;
    claimsUnfinished?: number;
    salesCanceled?: number;
    salesDelivered?: number;
    salesInvoiced?: number;
    salesOpenOrder?: number;
    vinRegistered?: number;
    vinUnregistered?: number;
    vinRetailSold?: number;
}

export class DealerRecallDTO implements IDealerRecallDTO {
    recallId?: string | null;
    recallName?: string | null;
    recallDescription?: string | null;
    recallType?: string | null;
    claimNumber?: string | null;
    warrantyClassCode?: string | null;
    warrantyClassDescription?: string | null;
    productionStartDate?: string | null;
    productionEndDate?: string | null;
    isAssociated?: boolean;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;
    attachments?: AXDocumentDTO[] | null;
    totalItems?: number;

    constructor(data?: IDealerRecallDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.recallName = _data["recallName"] !== undefined ? _data["recallName"] : <any>null;
            this.recallDescription = _data["recallDescription"] !== undefined ? _data["recallDescription"] : <any>null;
            this.recallType = _data["recallType"] !== undefined ? _data["recallType"] : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.warrantyClassCode = _data["warrantyClassCode"] !== undefined ? _data["warrantyClassCode"] : <any>null;
            this.warrantyClassDescription = _data["warrantyClassDescription"] !== undefined ? _data["warrantyClassDescription"] : <any>null;
            this.productionStartDate = _data["productionStartDate"] !== undefined ? _data["productionStartDate"] : <any>null;
            this.productionEndDate = _data["productionEndDate"] !== undefined ? _data["productionEndDate"] : <any>null;
            this.isAssociated = _data["isAssociated"] !== undefined ? _data["isAssociated"] : <any>null;
            if (Array.isArray(_data["remedyCodes"])) {
                this.remedyCodes = [] as any;
                for (let item of _data["remedyCodes"])
                    this.remedyCodes!.push(WarrantyRemedyCodeDTO.fromJS(item));
            }
            else {
                this.remedyCodes = <any>null;
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AXDocumentDTO.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): DealerRecallDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerRecallDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["recallName"] = this.recallName !== undefined ? this.recallName : <any>null;
        data["recallDescription"] = this.recallDescription !== undefined ? this.recallDescription : <any>null;
        data["recallType"] = this.recallType !== undefined ? this.recallType : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["warrantyClassCode"] = this.warrantyClassCode !== undefined ? this.warrantyClassCode : <any>null;
        data["warrantyClassDescription"] = this.warrantyClassDescription !== undefined ? this.warrantyClassDescription : <any>null;
        data["productionStartDate"] = this.productionStartDate !== undefined ? this.productionStartDate : <any>null;
        data["productionEndDate"] = this.productionEndDate !== undefined ? this.productionEndDate : <any>null;
        data["isAssociated"] = this.isAssociated !== undefined ? this.isAssociated : <any>null;
        if (Array.isArray(this.remedyCodes)) {
            data["remedyCodes"] = [];
            for (let item of this.remedyCodes)
                data["remedyCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        return data;
    }

    clone(): DealerRecallDTO {
        const json = this.toJSON();
        let result = new DealerRecallDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerRecallDTO {
    recallId?: string | null;
    recallName?: string | null;
    recallDescription?: string | null;
    recallType?: string | null;
    claimNumber?: string | null;
    warrantyClassCode?: string | null;
    warrantyClassDescription?: string | null;
    productionStartDate?: string | null;
    productionEndDate?: string | null;
    isAssociated?: boolean;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;
    attachments?: AXDocumentDTO[] | null;
    totalItems?: number;
}

export class WarrantyRemedyCodeDTO implements IWarrantyRemedyCodeDTO {
    description?: string | null;
    hours?: number;
    partReturn?: boolean;
    photoRequired?: boolean;
    preAuthorization?: boolean;
    remedyCode?: string | null;

    constructor(data?: IWarrantyRemedyCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.hours = _data["hours"] !== undefined ? _data["hours"] : <any>null;
            this.partReturn = _data["partReturn"] !== undefined ? _data["partReturn"] : <any>null;
            this.photoRequired = _data["photoRequired"] !== undefined ? _data["photoRequired"] : <any>null;
            this.preAuthorization = _data["preAuthorization"] !== undefined ? _data["preAuthorization"] : <any>null;
            this.remedyCode = _data["remedyCode"] !== undefined ? _data["remedyCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyRemedyCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyRemedyCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["hours"] = this.hours !== undefined ? this.hours : <any>null;
        data["partReturn"] = this.partReturn !== undefined ? this.partReturn : <any>null;
        data["photoRequired"] = this.photoRequired !== undefined ? this.photoRequired : <any>null;
        data["preAuthorization"] = this.preAuthorization !== undefined ? this.preAuthorization : <any>null;
        data["remedyCode"] = this.remedyCode !== undefined ? this.remedyCode : <any>null;
        return data;
    }

    clone(): WarrantyRemedyCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyRemedyCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyRemedyCodeDTO {
    description?: string | null;
    hours?: number;
    partReturn?: boolean;
    photoRequired?: boolean;
    preAuthorization?: boolean;
    remedyCode?: string | null;
}

export class AXDocumentDTO implements IAXDocumentDTO {
    fileType?: string | null;
    fileName?: string | null;
    description?: string | null;
    createdDateTime?: string | null;
    createdBy?: string | null;
    attachment?: string | null;
    dynamicsRecId?: number;

    constructor(data?: IAXDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] !== undefined ? _data["createdDateTime"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : <any>null;
            this.dynamicsRecId = _data["dynamicsRecId"] !== undefined ? _data["dynamicsRecId"] : <any>null;
        }
    }

    static fromJS(data: any): AXDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdDateTime"] = this.createdDateTime !== undefined ? this.createdDateTime : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["attachment"] = this.attachment !== undefined ? this.attachment : <any>null;
        data["dynamicsRecId"] = this.dynamicsRecId !== undefined ? this.dynamicsRecId : <any>null;
        return data;
    }

    clone(): AXDocumentDTO {
        const json = this.toJSON();
        let result = new AXDocumentDTO();
        result.init(json);
        return result;
    }
}

export interface IAXDocumentDTO {
    fileType?: string | null;
    fileName?: string | null;
    description?: string | null;
    createdDateTime?: string | null;
    createdBy?: string | null;
    attachment?: string | null;
    dynamicsRecId?: number;
}

export class DealerRecallSearchDTO extends PaginationBaseRequestDTO implements IDealerRecallSearchDTO {
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    recallId?: string | null;
    description?: string | null;
    isGlobalSearch?: boolean;
    hideClosed?: boolean | null;

    constructor(data?: IDealerRecallSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dealerLocationDynamicsId = _data["dealerLocationDynamicsId"] !== undefined ? _data["dealerLocationDynamicsId"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isGlobalSearch = _data["isGlobalSearch"] !== undefined ? _data["isGlobalSearch"] : <any>null;
            this.hideClosed = _data["hideClosed"] !== undefined ? _data["hideClosed"] : <any>null;
        }
    }

    static fromJS(data: any): DealerRecallSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerRecallSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerLocationDynamicsId"] = this.dealerLocationDynamicsId !== undefined ? this.dealerLocationDynamicsId : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isGlobalSearch"] = this.isGlobalSearch !== undefined ? this.isGlobalSearch : <any>null;
        data["hideClosed"] = this.hideClosed !== undefined ? this.hideClosed : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerRecallSearchDTO {
        const json = this.toJSON();
        let result = new DealerRecallSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerRecallSearchDTO extends IPaginationBaseRequestDTO {
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    recallId?: string | null;
    description?: string | null;
    isGlobalSearch?: boolean;
    hideClosed?: boolean | null;
}

export class DealerRecallVinDTO implements IDealerRecallVinDTO {
    accountNumber?: string | null;
    recallId?: string | null;
    vin?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    model?: string | null;
    year?: string | null;
    claimNumber?: string | null;
    isAssociated?: boolean;
    isClaimAssociated?: boolean;
    isProcessed?: boolean;
    totalItems?: number;

    constructor(data?: IDealerRecallVinDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.brandName = _data["brandName"] !== undefined ? _data["brandName"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.isAssociated = _data["isAssociated"] !== undefined ? _data["isAssociated"] : <any>null;
            this.isClaimAssociated = _data["isClaimAssociated"] !== undefined ? _data["isClaimAssociated"] : <any>null;
            this.isProcessed = _data["isProcessed"] !== undefined ? _data["isProcessed"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): DealerRecallVinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerRecallVinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["brandName"] = this.brandName !== undefined ? this.brandName : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["isAssociated"] = this.isAssociated !== undefined ? this.isAssociated : <any>null;
        data["isClaimAssociated"] = this.isClaimAssociated !== undefined ? this.isClaimAssociated : <any>null;
        data["isProcessed"] = this.isProcessed !== undefined ? this.isProcessed : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        return data;
    }

    clone(): DealerRecallVinDTO {
        const json = this.toJSON();
        let result = new DealerRecallVinDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerRecallVinDTO {
    accountNumber?: string | null;
    recallId?: string | null;
    vin?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    model?: string | null;
    year?: string | null;
    claimNumber?: string | null;
    isAssociated?: boolean;
    isClaimAssociated?: boolean;
    isProcessed?: boolean;
    totalItems?: number;
}

export class DealerSalesOrderDTO extends ValidationBaseDTO implements IDealerSalesOrderDTO {
    salesOrderNumber?: string | null;
    vin?: string | null;
    status?: string | null;
    createdDate?: moment.Moment;
    latestStatusUpdate?: moment.Moment;
    customerRequisition?: string | null;
    modeOfDelivery?: string | null;
    doNotProcess?: boolean;
    paidUnit?: boolean;
    dealerSold?: boolean;
    totalItems?: number;
    model?: string | null;
    brand?: string | null;
    year?: number;
    accountName?: string | null;
    customerAccount?: string | null;
    invoiceAccount?: string | null;
    contact?: string | null;
    requestedShipDate?: moment.Moment;
    documentStatus?: string | null;
    customerReference?: string | null;
    pool?: string | null;
    site?: string | null;
    warehouse?: string | null;
    salesOrderLineItems?: DealerSalesOrderLineItemDTO[] | null;
    deliveryName?: string | null;
    address?: string | null;
    shipmentVoided?: boolean;
    salesOrderTrackingItems?: DealerSalesOrderTrackingItemDTO[] | null;
    leadTrackingNumber?: string | null;
    trackingNumber?: string | null;
    actualShipDate?: moment.Moment;

    constructor(data?: IDealerSalesOrderDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.salesOrderNumber = _data["salesOrderNumber"] !== undefined ? _data["salesOrderNumber"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.latestStatusUpdate = _data["latestStatusUpdate"] ? moment(_data["latestStatusUpdate"].toString()) : <any>null;
            this.customerRequisition = _data["customerRequisition"] !== undefined ? _data["customerRequisition"] : <any>null;
            this.modeOfDelivery = _data["modeOfDelivery"] !== undefined ? _data["modeOfDelivery"] : <any>null;
            this.doNotProcess = _data["doNotProcess"] !== undefined ? _data["doNotProcess"] : <any>null;
            this.paidUnit = _data["paidUnit"] !== undefined ? _data["paidUnit"] : <any>null;
            this.dealerSold = _data["dealerSold"] !== undefined ? _data["dealerSold"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : <any>null;
            this.customerAccount = _data["customerAccount"] !== undefined ? _data["customerAccount"] : <any>null;
            this.invoiceAccount = _data["invoiceAccount"] !== undefined ? _data["invoiceAccount"] : <any>null;
            this.contact = _data["contact"] !== undefined ? _data["contact"] : <any>null;
            this.requestedShipDate = _data["requestedShipDate"] ? moment(_data["requestedShipDate"].toString()) : <any>null;
            this.documentStatus = _data["documentStatus"] !== undefined ? _data["documentStatus"] : <any>null;
            this.customerReference = _data["customerReference"] !== undefined ? _data["customerReference"] : <any>null;
            this.pool = _data["pool"] !== undefined ? _data["pool"] : <any>null;
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.warehouse = _data["warehouse"] !== undefined ? _data["warehouse"] : <any>null;
            if (Array.isArray(_data["salesOrderLineItems"])) {
                this.salesOrderLineItems = [] as any;
                for (let item of _data["salesOrderLineItems"])
                    this.salesOrderLineItems!.push(DealerSalesOrderLineItemDTO.fromJS(item));
            }
            else {
                this.salesOrderLineItems = <any>null;
            }
            this.deliveryName = _data["deliveryName"] !== undefined ? _data["deliveryName"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.shipmentVoided = _data["shipmentVoided"] !== undefined ? _data["shipmentVoided"] : <any>null;
            if (Array.isArray(_data["salesOrderTrackingItems"])) {
                this.salesOrderTrackingItems = [] as any;
                for (let item of _data["salesOrderTrackingItems"])
                    this.salesOrderTrackingItems!.push(DealerSalesOrderTrackingItemDTO.fromJS(item));
            }
            else {
                this.salesOrderTrackingItems = <any>null;
            }
            this.leadTrackingNumber = _data["leadTrackingNumber"] !== undefined ? _data["leadTrackingNumber"] : <any>null;
            this.trackingNumber = _data["trackingNumber"] !== undefined ? _data["trackingNumber"] : <any>null;
            this.actualShipDate = _data["actualShipDate"] ? moment(_data["actualShipDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DealerSalesOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSalesOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesOrderNumber"] = this.salesOrderNumber !== undefined ? this.salesOrderNumber : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["latestStatusUpdate"] = this.latestStatusUpdate ? this.latestStatusUpdate.toISOString() : <any>null;
        data["customerRequisition"] = this.customerRequisition !== undefined ? this.customerRequisition : <any>null;
        data["modeOfDelivery"] = this.modeOfDelivery !== undefined ? this.modeOfDelivery : <any>null;
        data["doNotProcess"] = this.doNotProcess !== undefined ? this.doNotProcess : <any>null;
        data["paidUnit"] = this.paidUnit !== undefined ? this.paidUnit : <any>null;
        data["dealerSold"] = this.dealerSold !== undefined ? this.dealerSold : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["customerAccount"] = this.customerAccount !== undefined ? this.customerAccount : <any>null;
        data["invoiceAccount"] = this.invoiceAccount !== undefined ? this.invoiceAccount : <any>null;
        data["contact"] = this.contact !== undefined ? this.contact : <any>null;
        data["requestedShipDate"] = this.requestedShipDate ? this.requestedShipDate.toISOString() : <any>null;
        data["documentStatus"] = this.documentStatus !== undefined ? this.documentStatus : <any>null;
        data["customerReference"] = this.customerReference !== undefined ? this.customerReference : <any>null;
        data["pool"] = this.pool !== undefined ? this.pool : <any>null;
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["warehouse"] = this.warehouse !== undefined ? this.warehouse : <any>null;
        if (Array.isArray(this.salesOrderLineItems)) {
            data["salesOrderLineItems"] = [];
            for (let item of this.salesOrderLineItems)
                data["salesOrderLineItems"].push(item.toJSON());
        }
        data["deliveryName"] = this.deliveryName !== undefined ? this.deliveryName : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["shipmentVoided"] = this.shipmentVoided !== undefined ? this.shipmentVoided : <any>null;
        if (Array.isArray(this.salesOrderTrackingItems)) {
            data["salesOrderTrackingItems"] = [];
            for (let item of this.salesOrderTrackingItems)
                data["salesOrderTrackingItems"].push(item.toJSON());
        }
        data["leadTrackingNumber"] = this.leadTrackingNumber !== undefined ? this.leadTrackingNumber : <any>null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : <any>null;
        data["actualShipDate"] = this.actualShipDate ? this.actualShipDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerSalesOrderDTO {
        const json = this.toJSON();
        let result = new DealerSalesOrderDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSalesOrderDTO extends IValidationBaseDTO {
    salesOrderNumber?: string | null;
    vin?: string | null;
    status?: string | null;
    createdDate?: moment.Moment;
    latestStatusUpdate?: moment.Moment;
    customerRequisition?: string | null;
    modeOfDelivery?: string | null;
    doNotProcess?: boolean;
    paidUnit?: boolean;
    dealerSold?: boolean;
    totalItems?: number;
    model?: string | null;
    brand?: string | null;
    year?: number;
    accountName?: string | null;
    customerAccount?: string | null;
    invoiceAccount?: string | null;
    contact?: string | null;
    requestedShipDate?: moment.Moment;
    documentStatus?: string | null;
    customerReference?: string | null;
    pool?: string | null;
    site?: string | null;
    warehouse?: string | null;
    salesOrderLineItems?: DealerSalesOrderLineItemDTO[] | null;
    deliveryName?: string | null;
    address?: string | null;
    shipmentVoided?: boolean;
    salesOrderTrackingItems?: DealerSalesOrderTrackingItemDTO[] | null;
    leadTrackingNumber?: string | null;
    trackingNumber?: string | null;
    actualShipDate?: moment.Moment;
}

export class DealerSalesOrderLineItemDTO implements IDealerSalesOrderLineItemDTO {
    itemNumber?: string | null;
    productName?: string | null;
    quantity?: number;
    unitOfMeasure?: string | null;
    netAmount?: number;
    readyForPickUp?: boolean;
    readyForPickUpDate?: moment.Moment;

    constructor(data?: IDealerSalesOrderLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.unitOfMeasure = _data["unitOfMeasure"] !== undefined ? _data["unitOfMeasure"] : <any>null;
            this.netAmount = _data["netAmount"] !== undefined ? _data["netAmount"] : <any>null;
            this.readyForPickUp = _data["readyForPickUp"] !== undefined ? _data["readyForPickUp"] : <any>null;
            this.readyForPickUpDate = _data["readyForPickUpDate"] ? moment(_data["readyForPickUpDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DealerSalesOrderLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSalesOrderLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["unitOfMeasure"] = this.unitOfMeasure !== undefined ? this.unitOfMeasure : <any>null;
        data["netAmount"] = this.netAmount !== undefined ? this.netAmount : <any>null;
        data["readyForPickUp"] = this.readyForPickUp !== undefined ? this.readyForPickUp : <any>null;
        data["readyForPickUpDate"] = this.readyForPickUpDate ? this.readyForPickUpDate.toISOString() : <any>null;
        return data;
    }

    clone(): DealerSalesOrderLineItemDTO {
        const json = this.toJSON();
        let result = new DealerSalesOrderLineItemDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSalesOrderLineItemDTO {
    itemNumber?: string | null;
    productName?: string | null;
    quantity?: number;
    unitOfMeasure?: string | null;
    netAmount?: number;
    readyForPickUp?: boolean;
    readyForPickUpDate?: moment.Moment;
}

export class DealerSalesOrderTrackingItemDTO implements IDealerSalesOrderTrackingItemDTO {
    shipmentVoided?: boolean;
    leadTrackingNumber?: string | null;
    trackingNumber?: string | null;
    modeOfDelivery?: string | null;
    actualShipDate?: moment.Moment;

    constructor(data?: IDealerSalesOrderTrackingItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentVoided = _data["shipmentVoided"] !== undefined ? _data["shipmentVoided"] : <any>null;
            this.leadTrackingNumber = _data["leadTrackingNumber"] !== undefined ? _data["leadTrackingNumber"] : <any>null;
            this.trackingNumber = _data["trackingNumber"] !== undefined ? _data["trackingNumber"] : <any>null;
            this.modeOfDelivery = _data["modeOfDelivery"] !== undefined ? _data["modeOfDelivery"] : <any>null;
            this.actualShipDate = _data["actualShipDate"] ? moment(_data["actualShipDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DealerSalesOrderTrackingItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSalesOrderTrackingItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentVoided"] = this.shipmentVoided !== undefined ? this.shipmentVoided : <any>null;
        data["leadTrackingNumber"] = this.leadTrackingNumber !== undefined ? this.leadTrackingNumber : <any>null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : <any>null;
        data["modeOfDelivery"] = this.modeOfDelivery !== undefined ? this.modeOfDelivery : <any>null;
        data["actualShipDate"] = this.actualShipDate ? this.actualShipDate.toISOString() : <any>null;
        return data;
    }

    clone(): DealerSalesOrderTrackingItemDTO {
        const json = this.toJSON();
        let result = new DealerSalesOrderTrackingItemDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSalesOrderTrackingItemDTO {
    shipmentVoided?: boolean;
    leadTrackingNumber?: string | null;
    trackingNumber?: string | null;
    modeOfDelivery?: string | null;
    actualShipDate?: moment.Moment;
}

export class DealerSalesOrderSearchDTO extends PaginationBaseRequestDTO implements IDealerSalesOrderSearchDTO {
    vin?: string | null;
    salesOrderNumber?: string | null;
    status?: string | null;
    custAccount?: number;
    requisition?: string | null;
    rvOrdersOnly?: boolean | null;

    constructor(data?: IDealerSalesOrderSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.salesOrderNumber = _data["salesOrderNumber"] !== undefined ? _data["salesOrderNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.custAccount = _data["custAccount"] !== undefined ? _data["custAccount"] : <any>null;
            this.requisition = _data["requisition"] !== undefined ? _data["requisition"] : <any>null;
            this.rvOrdersOnly = _data["rvOrdersOnly"] !== undefined ? _data["rvOrdersOnly"] : <any>null;
        }
    }

    static fromJS(data: any): DealerSalesOrderSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSalesOrderSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["salesOrderNumber"] = this.salesOrderNumber !== undefined ? this.salesOrderNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["custAccount"] = this.custAccount !== undefined ? this.custAccount : <any>null;
        data["requisition"] = this.requisition !== undefined ? this.requisition : <any>null;
        data["rvOrdersOnly"] = this.rvOrdersOnly !== undefined ? this.rvOrdersOnly : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DealerSalesOrderSearchDTO {
        const json = this.toJSON();
        let result = new DealerSalesOrderSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSalesOrderSearchDTO extends IPaginationBaseRequestDTO {
    vin?: string | null;
    salesOrderNumber?: string | null;
    status?: string | null;
    custAccount?: number;
    requisition?: string | null;
    rvOrdersOnly?: boolean | null;
}

export class AuthenticationResultDTO extends ValidationBaseDTO implements IAuthenticationResultDTO {
    succeeded?: boolean;
    isLockedOut?: boolean;
    accessToken?: string | null;
    refreshToken?: string | null;
    claims?: Claim[] | null;

    constructor(data?: IAuthenticationResultDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : <any>null;
            this.isLockedOut = _data["isLockedOut"] !== undefined ? _data["isLockedOut"] : <any>null;
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
        }
    }

    static fromJS(data: any): AuthenticationResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : <any>null;
        data["isLockedOut"] = this.isLockedOut !== undefined ? this.isLockedOut : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): AuthenticationResultDTO {
        const json = this.toJSON();
        let result = new AuthenticationResultDTO();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationResultDTO extends IValidationBaseDTO {
    succeeded?: boolean;
    isLockedOut?: boolean;
    accessToken?: string | null;
    refreshToken?: string | null;
    claims?: Claim[] | null;
}

export class Claim implements IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"] !== undefined ? _data["issuer"] : <any>null;
            this.originalIssuer = _data["originalIssuer"] !== undefined ? _data["originalIssuer"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.valueType = _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer !== undefined ? this.issuer : <any>null;
        data["originalIssuer"] = this.originalIssuer !== undefined ? this.originalIssuer : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["valueType"] = this.valueType !== undefined ? this.valueType : <any>null;
        return data;
    }

    clone(): Claim {
        const json = this.toJSON();
        let result = new Claim();
        result.init(json);
        return result;
    }
}

export interface IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"] !== undefined ? _data["authenticationType"] : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : <any>null;
            this.bootstrapContext = _data["bootstrapContext"] !== undefined ? _data["bootstrapContext"] : <any>null;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameClaimType = _data["nameClaimType"] !== undefined ? _data["nameClaimType"] : <any>null;
            this.roleClaimType = _data["roleClaimType"] !== undefined ? _data["roleClaimType"] : <any>null;
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType !== undefined ? this.authenticationType : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>null;
        data["bootstrapContext"] = this.bootstrapContext !== undefined ? this.bootstrapContext : <any>null;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameClaimType"] = this.nameClaimType !== undefined ? this.nameClaimType : <any>null;
        data["roleClaimType"] = this.roleClaimType !== undefined ? this.roleClaimType : <any>null;
        return data;
    }

    clone(): ClaimsIdentity {
        const json = this.toJSON();
        let result = new ClaimsIdentity();
        result.init(json);
        return result;
    }
}

export interface IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;
}

export class AuthenticationRequestDTO implements IAuthenticationRequestDTO {
    userName!: string;
    password!: string;
    companyType?: CompanyTypes;

    constructor(data?: IAuthenticationRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticationRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        return data;
    }

    clone(): AuthenticationRequestDTO {
        const json = this.toJSON();
        let result = new AuthenticationRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationRequestDTO {
    userName: string;
    password: string;
    companyType?: CompanyTypes;
}

export class RefreshTokenDTO implements IRefreshTokenDTO {
    refreshToken!: string;
    expiredAccessToken?: string | null;

    constructor(data?: IRefreshTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            this.expiredAccessToken = _data["expiredAccessToken"] !== undefined ? _data["expiredAccessToken"] : <any>null;
        }
    }

    static fromJS(data: any): RefreshTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        data["expiredAccessToken"] = this.expiredAccessToken !== undefined ? this.expiredAccessToken : <any>null;
        return data;
    }

    clone(): RefreshTokenDTO {
        const json = this.toJSON();
        let result = new RefreshTokenDTO();
        result.init(json);
        return result;
    }
}

export interface IRefreshTokenDTO {
    refreshToken: string;
    expiredAccessToken?: string | null;
}

export class ResetPasswordDTO extends ValidationBaseDTO implements IResetPasswordDTO {
    token!: string;
    email!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ResetPasswordDTO {
        const json = this.toJSON();
        let result = new ResetPasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDTO extends IValidationBaseDTO {
    token: string;
    email: string;
    password: string;
    confirmPassword: string;
}

export class RegisterDTO extends ValidationBaseDTO implements IRegisterDTO {
    userId?: string | null;
    firstName!: string;
    lastName!: string;
    email!: string;
    phoneNumber!: string;
    streetAddress!: string;
    city!: string;
    stateId!: number;
    zipCode!: string;
    countryId!: number;
    password!: string;
    confirmPassword!: string;
    invitationCode?: string | null;
    invitationId?: string | null;
    companyType?: CompanyTypes;

    constructor(data?: IRegisterDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
            this.invitationCode = _data["invitationCode"] !== undefined ? _data["invitationCode"] : <any>null;
            this.invitationId = _data["invitationId"] !== undefined ? _data["invitationId"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateId"] = this.stateId !== undefined ? this.stateId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        data["invitationCode"] = this.invitationCode !== undefined ? this.invitationCode : <any>null;
        data["invitationId"] = this.invitationId !== undefined ? this.invitationId : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): RegisterDTO {
        const json = this.toJSON();
        let result = new RegisterDTO();
        result.init(json);
        return result;
    }
}

export interface IRegisterDTO extends IValidationBaseDTO {
    userId?: string | null;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    stateId: number;
    zipCode: string;
    countryId: number;
    password: string;
    confirmPassword: string;
    invitationCode?: string | null;
    invitationId?: string | null;
    companyType?: CompanyTypes;
}

export class EmailConfirmationDTO extends ValidationBaseDTO implements IEmailConfirmationDTO {
    id?: string | null;
    code?: string | null;
    companyType?: number;

    constructor(data?: IEmailConfirmationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): EmailConfirmationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): EmailConfirmationDTO {
        const json = this.toJSON();
        let result = new EmailConfirmationDTO();
        result.init(json);
        return result;
    }
}

export interface IEmailConfirmationDTO extends IValidationBaseDTO {
    id?: string | null;
    code?: string | null;
    companyType?: number;
}

export class ChangePasswordDTO extends ValidationBaseDTO implements IChangePasswordDTO {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ChangePasswordDTO {
        const json = this.toJSON();
        let result = new ChangePasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDTO extends IValidationBaseDTO {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class ProfileDTO extends ValidationBaseDTO implements IProfileDTO {
    userId?: string;
    firstName!: string;
    lastName!: string;
    phoneNumber!: string;
    streetAddress!: string;
    city!: string;
    stateId!: number;
    zipCode!: string;
    countryId!: number;
    allowEmailNotifications!: boolean;
    allowPushNotifications!: boolean;

    constructor(data?: IProfileDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.allowEmailNotifications = _data["allowEmailNotifications"] !== undefined ? _data["allowEmailNotifications"] : <any>null;
            this.allowPushNotifications = _data["allowPushNotifications"] !== undefined ? _data["allowPushNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateId"] = this.stateId !== undefined ? this.stateId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["allowEmailNotifications"] = this.allowEmailNotifications !== undefined ? this.allowEmailNotifications : <any>null;
        data["allowPushNotifications"] = this.allowPushNotifications !== undefined ? this.allowPushNotifications : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ProfileDTO {
        const json = this.toJSON();
        let result = new ProfileDTO();
        result.init(json);
        return result;
    }
}

export interface IProfileDTO extends IValidationBaseDTO {
    userId?: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    stateId: number;
    zipCode: string;
    countryId: number;
    allowEmailNotifications: boolean;
    allowPushNotifications: boolean;
}

export class VehicleDTO implements IVehicleDTO {
    vehicleId?: number;
    vehicleUid?: string;
    vin?: string | null;
    name?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number;
    brandName?: string | null;

    constructor(data?: IVehicleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"] !== undefined ? _data["vehicleId"] : <any>null;
            this.vehicleUid = _data["vehicleUid"] !== undefined ? _data["vehicleUid"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.make = _data["make"] !== undefined ? _data["make"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.brandName = _data["brandName"] !== undefined ? _data["brandName"] : <any>null;
        }
    }

    static fromJS(data: any): VehicleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId !== undefined ? this.vehicleId : <any>null;
        data["vehicleUid"] = this.vehicleUid !== undefined ? this.vehicleUid : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["make"] = this.make !== undefined ? this.make : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["brandName"] = this.brandName !== undefined ? this.brandName : <any>null;
        return data;
    }

    clone(): VehicleDTO {
        const json = this.toJSON();
        let result = new VehicleDTO();
        result.init(json);
        return result;
    }
}

export interface IVehicleDTO {
    vehicleId?: number;
    vehicleUid?: string;
    vin?: string | null;
    name?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number;
    brandName?: string | null;
}

export class UpdateUserDTO extends ValidationBaseDTO implements IUpdateUserDTO {
    userId?: string;
    firstName!: string;
    lastName!: string;
    roles?: string[] | null;

    constructor(data?: IUpdateUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UpdateUserDTO {
        const json = this.toJSON();
        let result = new UpdateUserDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDTO extends IValidationBaseDTO {
    userId?: string;
    firstName: string;
    lastName: string;
    roles?: string[] | null;
}

export class RoleDTO extends ValidationBaseDTO implements IRoleDTO {
    id?: string | null;
    name!: string;
    isSystemRole?: boolean;
    permissions?: PermissionDTO[] | null;

    constructor(data?: IRoleDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isSystemRole = _data["isSystemRole"] !== undefined ? _data["isSystemRole"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDTO.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): RoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isSystemRole"] = this.isSystemRole !== undefined ? this.isSystemRole : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RoleDTO {
        const json = this.toJSON();
        let result = new RoleDTO();
        result.init(json);
        return result;
    }
}

export interface IRoleDTO extends IValidationBaseDTO {
    id?: string | null;
    name: string;
    isSystemRole?: boolean;
    permissions?: PermissionDTO[] | null;
}

export class PermissionDTO implements IPermissionDTO {
    id?: string;
    name?: string | null;
    description?: string | null;

    constructor(data?: IPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): PermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): PermissionDTO {
        const json = this.toJSON();
        let result = new PermissionDTO();
        result.init(json);
        return result;
    }
}

export interface IPermissionDTO {
    id?: string;
    name?: string | null;
    description?: string | null;
}

export class InvoiceDTO implements IInvoiceDTO {
    invoiceNumber?: string | null;
    salesOrderNumber?: string | null;
    vin?: string | null;
    accountNumber?: string | null;
    date?: moment.Moment;
    dueDate?: moment.Moment;
    currency?: string | null;
    amount?: number;
    referenceNumber?: string | null;
    totalItems?: number;
    totalCharges?: number;
    requisition?: string | null;
    totalDiscount?: number;
    balance?: number;
    paymentTerms?: string | null;
    salesTax?: number;
    deliveryName?: string | null;
    deliveryAddress?: string | null;
    recipientName?: string | null;
    modeOfDelivery?: string | null;
    invoiceLines?: InvoiceLineItemDTO[] | null;

    constructor(data?: IInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : <any>null;
            this.salesOrderNumber = _data["salesOrderNumber"] !== undefined ? _data["salesOrderNumber"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
            this.totalCharges = _data["totalCharges"] !== undefined ? _data["totalCharges"] : <any>null;
            this.requisition = _data["requisition"] !== undefined ? _data["requisition"] : <any>null;
            this.totalDiscount = _data["totalDiscount"] !== undefined ? _data["totalDiscount"] : <any>null;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : <any>null;
            this.paymentTerms = _data["paymentTerms"] !== undefined ? _data["paymentTerms"] : <any>null;
            this.salesTax = _data["salesTax"] !== undefined ? _data["salesTax"] : <any>null;
            this.deliveryName = _data["deliveryName"] !== undefined ? _data["deliveryName"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.recipientName = _data["recipientName"] !== undefined ? _data["recipientName"] : <any>null;
            this.modeOfDelivery = _data["modeOfDelivery"] !== undefined ? _data["modeOfDelivery"] : <any>null;
            if (Array.isArray(_data["invoiceLines"])) {
                this.invoiceLines = [] as any;
                for (let item of _data["invoiceLines"])
                    this.invoiceLines!.push(InvoiceLineItemDTO.fromJS(item));
            }
            else {
                this.invoiceLines = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : <any>null;
        data["salesOrderNumber"] = this.salesOrderNumber !== undefined ? this.salesOrderNumber : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        data["totalCharges"] = this.totalCharges !== undefined ? this.totalCharges : <any>null;
        data["requisition"] = this.requisition !== undefined ? this.requisition : <any>null;
        data["totalDiscount"] = this.totalDiscount !== undefined ? this.totalDiscount : <any>null;
        data["balance"] = this.balance !== undefined ? this.balance : <any>null;
        data["paymentTerms"] = this.paymentTerms !== undefined ? this.paymentTerms : <any>null;
        data["salesTax"] = this.salesTax !== undefined ? this.salesTax : <any>null;
        data["deliveryName"] = this.deliveryName !== undefined ? this.deliveryName : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["recipientName"] = this.recipientName !== undefined ? this.recipientName : <any>null;
        data["modeOfDelivery"] = this.modeOfDelivery !== undefined ? this.modeOfDelivery : <any>null;
        if (Array.isArray(this.invoiceLines)) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item.toJSON());
        }
        return data;
    }

    clone(): InvoiceDTO {
        const json = this.toJSON();
        let result = new InvoiceDTO();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDTO {
    invoiceNumber?: string | null;
    salesOrderNumber?: string | null;
    vin?: string | null;
    accountNumber?: string | null;
    date?: moment.Moment;
    dueDate?: moment.Moment;
    currency?: string | null;
    amount?: number;
    referenceNumber?: string | null;
    totalItems?: number;
    totalCharges?: number;
    requisition?: string | null;
    totalDiscount?: number;
    balance?: number;
    paymentTerms?: string | null;
    salesTax?: number;
    deliveryName?: string | null;
    deliveryAddress?: string | null;
    recipientName?: string | null;
    modeOfDelivery?: string | null;
    invoiceLines?: InvoiceLineItemDTO[] | null;
}

export class InvoiceLineItemDTO implements IInvoiceLineItemDTO {
    salesId?: string | null;
    itemNumber?: string | null;
    itemDescription?: string | null;
    qty?: number;
    unitPrice?: number;
    discountPercent?: number;
    amount?: number;

    constructor(data?: IInvoiceLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesId = _data["salesId"] !== undefined ? _data["salesId"] : <any>null;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.itemDescription = _data["itemDescription"] !== undefined ? _data["itemDescription"] : <any>null;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : <any>null;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesId"] = this.salesId !== undefined ? this.salesId : <any>null;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["itemDescription"] = this.itemDescription !== undefined ? this.itemDescription : <any>null;
        data["qty"] = this.qty !== undefined ? this.qty : <any>null;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }

    clone(): InvoiceLineItemDTO {
        const json = this.toJSON();
        let result = new InvoiceLineItemDTO();
        result.init(json);
        return result;
    }
}

export interface IInvoiceLineItemDTO {
    salesId?: string | null;
    itemNumber?: string | null;
    itemDescription?: string | null;
    qty?: number;
    unitPrice?: number;
    discountPercent?: number;
    amount?: number;
}

export class InvoiceSearchDTO extends PaginationBaseRequestDTO implements IInvoiceSearchDTO {
    invoiceSearch?: string | null;
    salesOrderSearch?: string | null;
    vin?: string | null;
    showOpenOnly?: boolean | null;
    custAccount?: number;

    constructor(data?: IInvoiceSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceSearch = _data["invoiceSearch"] !== undefined ? _data["invoiceSearch"] : <any>null;
            this.salesOrderSearch = _data["salesOrderSearch"] !== undefined ? _data["salesOrderSearch"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.showOpenOnly = _data["showOpenOnly"] !== undefined ? _data["showOpenOnly"] : <any>null;
            this.custAccount = _data["custAccount"] !== undefined ? _data["custAccount"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceSearch"] = this.invoiceSearch !== undefined ? this.invoiceSearch : <any>null;
        data["salesOrderSearch"] = this.salesOrderSearch !== undefined ? this.salesOrderSearch : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["showOpenOnly"] = this.showOpenOnly !== undefined ? this.showOpenOnly : <any>null;
        data["custAccount"] = this.custAccount !== undefined ? this.custAccount : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): InvoiceSearchDTO {
        const json = this.toJSON();
        let result = new InvoiceSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IInvoiceSearchDTO extends IPaginationBaseRequestDTO {
    invoiceSearch?: string | null;
    salesOrderSearch?: string | null;
    vin?: string | null;
    showOpenOnly?: boolean | null;
    custAccount?: number;
}

export class InvoiceStatementDTO implements IInvoiceStatementDTO {
    aged120?: number;
    aged120Plus?: number;
    aged30?: number;
    aged60?: number;
    aged90?: number;
    current?: number;
    totalBalance?: number;

    constructor(data?: IInvoiceStatementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aged120 = _data["aged120"] !== undefined ? _data["aged120"] : <any>null;
            this.aged120Plus = _data["aged120Plus"] !== undefined ? _data["aged120Plus"] : <any>null;
            this.aged30 = _data["aged30"] !== undefined ? _data["aged30"] : <any>null;
            this.aged60 = _data["aged60"] !== undefined ? _data["aged60"] : <any>null;
            this.aged90 = _data["aged90"] !== undefined ? _data["aged90"] : <any>null;
            this.current = _data["current"] !== undefined ? _data["current"] : <any>null;
            this.totalBalance = _data["totalBalance"] !== undefined ? _data["totalBalance"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceStatementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aged120"] = this.aged120 !== undefined ? this.aged120 : <any>null;
        data["aged120Plus"] = this.aged120Plus !== undefined ? this.aged120Plus : <any>null;
        data["aged30"] = this.aged30 !== undefined ? this.aged30 : <any>null;
        data["aged60"] = this.aged60 !== undefined ? this.aged60 : <any>null;
        data["aged90"] = this.aged90 !== undefined ? this.aged90 : <any>null;
        data["current"] = this.current !== undefined ? this.current : <any>null;
        data["totalBalance"] = this.totalBalance !== undefined ? this.totalBalance : <any>null;
        return data;
    }

    clone(): InvoiceStatementDTO {
        const json = this.toJSON();
        let result = new InvoiceStatementDTO();
        result.init(json);
        return result;
    }
}

export interface IInvoiceStatementDTO {
    aged120?: number;
    aged120Plus?: number;
    aged30?: number;
    aged60?: number;
    aged90?: number;
    current?: number;
    totalBalance?: number;
}

export class SpiffTypeDTO implements ISpiffTypeDTO {
    label?: string | null;
    value?: number;

    constructor(data?: ISpiffTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SpiffTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpiffTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): SpiffTypeDTO {
        const json = this.toJSON();
        let result = new SpiffTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ISpiffTypeDTO {
    label?: string | null;
    value?: number;
}

export class BrandDTO implements IBrandDTO {
    brandId?: string | null;
    name?: string | null;
    company?: string | null;
    supportEmail?: string | null;

    constructor(data?: IBrandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.company = _data["company"] !== undefined ? _data["company"] : <any>null;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : <any>null;
        }
    }

    static fromJS(data: any): BrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : <any>null;
        return data;
    }

    clone(): BrandDTO {
        const json = this.toJSON();
        let result = new BrandDTO();
        result.init(json);
        return result;
    }
}

export interface IBrandDTO {
    brandId?: string | null;
    name?: string | null;
    company?: string | null;
    supportEmail?: string | null;
}

export class CatalogBrandDTO extends BrandDTO implements ICatalogBrandDTO {

    constructor(data?: ICatalogBrandDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CatalogBrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogBrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CatalogBrandDTO {
        const json = this.toJSON();
        let result = new CatalogBrandDTO();
        result.init(json);
        return result;
    }
}

export interface ICatalogBrandDTO extends IBrandDTO {
}

export class DeliveryModeDTO implements IDeliveryModeDTO {
    id?: string | null;
    description?: string | null;

    constructor(data?: IDeliveryModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): DeliveryModeDTO {
        const json = this.toJSON();
        let result = new DeliveryModeDTO();
        result.init(json);
        return result;
    }
}

export interface IDeliveryModeDTO {
    id?: string | null;
    description?: string | null;
}

export class ChecklistTypeDTO implements IChecklistTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;

    constructor(data?: IChecklistTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ChecklistTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): ChecklistTypeDTO {
        const json = this.toJSON();
        let result = new ChecklistTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IChecklistTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
}

export class CompanyTypeDTO implements ICompanyTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
    companyType?: CompanyTypes;
    companyAbbreviation?: string | null;
    webPortalBaseUrl?: string | null;
    fromEmailName?: string | null;
    fromEmailAddress?: string | null;
    appName?: string | null;
    supportEmailAddress?: string | null;
    partsEmailAddress?: string | null;
    serviceEmailAddress?: string | null;
    supportPhoneNumber?: string | null;
    logoPath?: string | null;
    companyAddress?: string | null;

    constructor(data?: ICompanyTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.companyAbbreviation = _data["companyAbbreviation"] !== undefined ? _data["companyAbbreviation"] : <any>null;
            this.webPortalBaseUrl = _data["webPortalBaseUrl"] !== undefined ? _data["webPortalBaseUrl"] : <any>null;
            this.fromEmailName = _data["fromEmailName"] !== undefined ? _data["fromEmailName"] : <any>null;
            this.fromEmailAddress = _data["fromEmailAddress"] !== undefined ? _data["fromEmailAddress"] : <any>null;
            this.appName = _data["appName"] !== undefined ? _data["appName"] : <any>null;
            this.supportEmailAddress = _data["supportEmailAddress"] !== undefined ? _data["supportEmailAddress"] : <any>null;
            this.partsEmailAddress = _data["partsEmailAddress"] !== undefined ? _data["partsEmailAddress"] : <any>null;
            this.serviceEmailAddress = _data["serviceEmailAddress"] !== undefined ? _data["serviceEmailAddress"] : <any>null;
            this.supportPhoneNumber = _data["supportPhoneNumber"] !== undefined ? _data["supportPhoneNumber"] : <any>null;
            this.logoPath = _data["logoPath"] !== undefined ? _data["logoPath"] : <any>null;
            this.companyAddress = _data["companyAddress"] !== undefined ? _data["companyAddress"] : <any>null;
        }
    }

    static fromJS(data: any): CompanyTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["companyAbbreviation"] = this.companyAbbreviation !== undefined ? this.companyAbbreviation : <any>null;
        data["webPortalBaseUrl"] = this.webPortalBaseUrl !== undefined ? this.webPortalBaseUrl : <any>null;
        data["fromEmailName"] = this.fromEmailName !== undefined ? this.fromEmailName : <any>null;
        data["fromEmailAddress"] = this.fromEmailAddress !== undefined ? this.fromEmailAddress : <any>null;
        data["appName"] = this.appName !== undefined ? this.appName : <any>null;
        data["supportEmailAddress"] = this.supportEmailAddress !== undefined ? this.supportEmailAddress : <any>null;
        data["partsEmailAddress"] = this.partsEmailAddress !== undefined ? this.partsEmailAddress : <any>null;
        data["serviceEmailAddress"] = this.serviceEmailAddress !== undefined ? this.serviceEmailAddress : <any>null;
        data["supportPhoneNumber"] = this.supportPhoneNumber !== undefined ? this.supportPhoneNumber : <any>null;
        data["logoPath"] = this.logoPath !== undefined ? this.logoPath : <any>null;
        data["companyAddress"] = this.companyAddress !== undefined ? this.companyAddress : <any>null;
        return data;
    }

    clone(): CompanyTypeDTO {
        const json = this.toJSON();
        let result = new CompanyTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ICompanyTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
    companyType?: CompanyTypes;
    companyAbbreviation?: string | null;
    webPortalBaseUrl?: string | null;
    fromEmailName?: string | null;
    fromEmailAddress?: string | null;
    appName?: string | null;
    supportEmailAddress?: string | null;
    partsEmailAddress?: string | null;
    serviceEmailAddress?: string | null;
    supportPhoneNumber?: string | null;
    logoPath?: string | null;
    companyAddress?: string | null;
}

export class LookupTypeDTO implements ILookupTypeDTO {
    id?: number;
    uid?: string | null;
    name?: string | null;
    description?: string | null;
    sortOrder?: number;

    constructor(data?: ILookupTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): LookupTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LookupTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): LookupTypeDTO {
        const json = this.toJSON();
        let result = new LookupTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ILookupTypeDTO {
    id?: number;
    uid?: string | null;
    name?: string | null;
    description?: string | null;
    sortOrder?: number;
}

export class CountryLookupDTO extends LookupTypeDTO implements ICountryLookupDTO {
    code?: string | null;

    constructor(data?: ICountryLookupDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): CountryLookupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CountryLookupDTO {
        const json = this.toJSON();
        let result = new CountryLookupDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryLookupDTO extends ILookupTypeDTO {
    code?: string | null;
}

export class DocumentTypeDTO extends LookupTypeDTO implements IDocumentTypeDTO {
    portalType?: PortalTypes;

    constructor(data?: IDocumentTypeDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.portalType = _data["portalType"] !== undefined ? _data["portalType"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalType"] = this.portalType !== undefined ? this.portalType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentTypeDTO {
        const json = this.toJSON();
        let result = new DocumentTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDTO extends ILookupTypeDTO {
    portalType?: PortalTypes;
}

export enum PortalTypes {
    Unknown = 0,
    Consumer = 1,
    Dealer = 2,
}

export class StateLookupDTO extends LookupTypeDTO implements IStateLookupDTO {
    code?: string | null;
    countryId?: number;

    constructor(data?: IStateLookupDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): StateLookupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StateLookupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): StateLookupDTO {
        const json = this.toJSON();
        let result = new StateLookupDTO();
        result.init(json);
        return result;
    }
}

export interface IStateLookupDTO extends ILookupTypeDTO {
    code?: string | null;
    countryId?: number;
}

export class SettingDTO implements ISettingDTO {
    googleMapsApiKey?: string | null;
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    maxAdditionalConsumerUsers?: number;
    fullAccessCountryCodes?: string | null;
    companyAddress?: string | null;
    mondayThruThursdaySupportHours?: string | null;
    fridaySupportHours?: string | null;

    constructor(data?: ISettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleMapsApiKey = _data["googleMapsApiKey"] !== undefined ? _data["googleMapsApiKey"] : <any>null;
            this.allowedFileUploadExtensions = _data["allowedFileUploadExtensions"] !== undefined ? _data["allowedFileUploadExtensions"] : <any>null;
            this.maxFileUploadSizeInMegaBytes = _data["maxFileUploadSizeInMegaBytes"] !== undefined ? _data["maxFileUploadSizeInMegaBytes"] : <any>null;
            this.maxAdditionalConsumerUsers = _data["maxAdditionalConsumerUsers"] !== undefined ? _data["maxAdditionalConsumerUsers"] : <any>null;
            this.fullAccessCountryCodes = _data["fullAccessCountryCodes"] !== undefined ? _data["fullAccessCountryCodes"] : <any>null;
            this.companyAddress = _data["companyAddress"] !== undefined ? _data["companyAddress"] : <any>null;
            this.mondayThruThursdaySupportHours = _data["mondayThruThursdaySupportHours"] !== undefined ? _data["mondayThruThursdaySupportHours"] : <any>null;
            this.fridaySupportHours = _data["fridaySupportHours"] !== undefined ? _data["fridaySupportHours"] : <any>null;
        }
    }

    static fromJS(data: any): SettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleMapsApiKey"] = this.googleMapsApiKey !== undefined ? this.googleMapsApiKey : <any>null;
        data["allowedFileUploadExtensions"] = this.allowedFileUploadExtensions !== undefined ? this.allowedFileUploadExtensions : <any>null;
        data["maxFileUploadSizeInMegaBytes"] = this.maxFileUploadSizeInMegaBytes !== undefined ? this.maxFileUploadSizeInMegaBytes : <any>null;
        data["maxAdditionalConsumerUsers"] = this.maxAdditionalConsumerUsers !== undefined ? this.maxAdditionalConsumerUsers : <any>null;
        data["fullAccessCountryCodes"] = this.fullAccessCountryCodes !== undefined ? this.fullAccessCountryCodes : <any>null;
        data["companyAddress"] = this.companyAddress !== undefined ? this.companyAddress : <any>null;
        data["mondayThruThursdaySupportHours"] = this.mondayThruThursdaySupportHours !== undefined ? this.mondayThruThursdaySupportHours : <any>null;
        data["fridaySupportHours"] = this.fridaySupportHours !== undefined ? this.fridaySupportHours : <any>null;
        return data;
    }

    clone(): SettingDTO {
        const json = this.toJSON();
        let result = new SettingDTO();
        result.init(json);
        return result;
    }
}

export interface ISettingDTO {
    googleMapsApiKey?: string | null;
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    maxAdditionalConsumerUsers?: number;
    fullAccessCountryCodes?: string | null;
    companyAddress?: string | null;
    mondayThruThursdaySupportHours?: string | null;
    fridaySupportHours?: string | null;
}

export class DealerSettingDTO implements IDealerSettingDTO {
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    dealerStoreURL?: string | null;
    hrvRegistrationsEmail?: string | null;
    dcrvRegistrationsEmail?: string | null;

    constructor(data?: IDealerSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedFileUploadExtensions = _data["allowedFileUploadExtensions"] !== undefined ? _data["allowedFileUploadExtensions"] : <any>null;
            this.maxFileUploadSizeInMegaBytes = _data["maxFileUploadSizeInMegaBytes"] !== undefined ? _data["maxFileUploadSizeInMegaBytes"] : <any>null;
            this.dealerStoreURL = _data["dealerStoreURL"] !== undefined ? _data["dealerStoreURL"] : <any>null;
            this.hrvRegistrationsEmail = _data["hrvRegistrationsEmail"] !== undefined ? _data["hrvRegistrationsEmail"] : <any>null;
            this.dcrvRegistrationsEmail = _data["dcrvRegistrationsEmail"] !== undefined ? _data["dcrvRegistrationsEmail"] : <any>null;
        }
    }

    static fromJS(data: any): DealerSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedFileUploadExtensions"] = this.allowedFileUploadExtensions !== undefined ? this.allowedFileUploadExtensions : <any>null;
        data["maxFileUploadSizeInMegaBytes"] = this.maxFileUploadSizeInMegaBytes !== undefined ? this.maxFileUploadSizeInMegaBytes : <any>null;
        data["dealerStoreURL"] = this.dealerStoreURL !== undefined ? this.dealerStoreURL : <any>null;
        data["hrvRegistrationsEmail"] = this.hrvRegistrationsEmail !== undefined ? this.hrvRegistrationsEmail : <any>null;
        data["dcrvRegistrationsEmail"] = this.dcrvRegistrationsEmail !== undefined ? this.dcrvRegistrationsEmail : <any>null;
        return data;
    }

    clone(): DealerSettingDTO {
        const json = this.toJSON();
        let result = new DealerSettingDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSettingDTO {
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    dealerStoreURL?: string | null;
    hrvRegistrationsEmail?: string | null;
    dcrvRegistrationsEmail?: string | null;
}

export class TermsAndConditionDTO implements ITermsAndConditionDTO {
    id?: number;
    uid?: string;
    version?: string | null;
    name?: string | null;
    content?: string | null;
    isActiveVersion?: boolean;
    isHtml?: boolean;
    companyType?: CompanyTypes;

    constructor(data?: ITermsAndConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isActiveVersion = _data["isActiveVersion"] !== undefined ? _data["isActiveVersion"] : <any>null;
            this.isHtml = _data["isHtml"] !== undefined ? _data["isHtml"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): TermsAndConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isActiveVersion"] = this.isActiveVersion !== undefined ? this.isActiveVersion : <any>null;
        data["isHtml"] = this.isHtml !== undefined ? this.isHtml : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        return data;
    }

    clone(): TermsAndConditionDTO {
        const json = this.toJSON();
        let result = new TermsAndConditionDTO();
        result.init(json);
        return result;
    }
}

export interface ITermsAndConditionDTO {
    id?: number;
    uid?: string;
    version?: string | null;
    name?: string | null;
    content?: string | null;
    isActiveVersion?: boolean;
    isHtml?: boolean;
    companyType?: CompanyTypes;
}

export class PostalCodeInfoDTO implements IPostalCodeInfoDTO {
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;

    constructor(data?: IPostalCodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
        }
    }

    static fromJS(data: any): PostalCodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PostalCodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        return data;
    }

    clone(): PostalCodeInfoDTO {
        const json = this.toJSON();
        let result = new PostalCodeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IPostalCodeInfoDTO {
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;
}

export class DynamicsCountryDTO implements IDynamicsCountryDTO {
    id?: string | null;
    isoCode?: string | null;
    name?: string | null;

    constructor(data?: IDynamicsCountryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isoCode = _data["isoCode"] !== undefined ? _data["isoCode"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): DynamicsCountryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicsCountryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isoCode"] = this.isoCode !== undefined ? this.isoCode : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): DynamicsCountryDTO {
        const json = this.toJSON();
        let result = new DynamicsCountryDTO();
        result.init(json);
        return result;
    }
}

export interface IDynamicsCountryDTO {
    id?: string | null;
    isoCode?: string | null;
    name?: string | null;
}

export class ClaimStatusTypeDTO extends LookupTypeDTO implements IClaimStatusTypeDTO {

    constructor(data?: IClaimStatusTypeDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ClaimStatusTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimStatusTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ClaimStatusTypeDTO {
        const json = this.toJSON();
        let result = new ClaimStatusTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IClaimStatusTypeDTO extends ILookupTypeDTO {
}

export class WarrantyClassCodeDTO implements IWarrantyClassCodeDTO {
    description?: string | null;
    parentCode?: string | null;
    classCode?: string | null;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;

    constructor(data?: IWarrantyClassCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.parentCode = _data["parentCode"] !== undefined ? _data["parentCode"] : <any>null;
            this.classCode = _data["classCode"] !== undefined ? _data["classCode"] : <any>null;
            if (Array.isArray(_data["remedyCodes"])) {
                this.remedyCodes = [] as any;
                for (let item of _data["remedyCodes"])
                    this.remedyCodes!.push(WarrantyRemedyCodeDTO.fromJS(item));
            }
            else {
                this.remedyCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): WarrantyClassCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyClassCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["parentCode"] = this.parentCode !== undefined ? this.parentCode : <any>null;
        data["classCode"] = this.classCode !== undefined ? this.classCode : <any>null;
        if (Array.isArray(this.remedyCodes)) {
            data["remedyCodes"] = [];
            for (let item of this.remedyCodes)
                data["remedyCodes"].push(item.toJSON());
        }
        return data;
    }

    clone(): WarrantyClassCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyClassCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyClassCodeDTO {
    description?: string | null;
    parentCode?: string | null;
    classCode?: string | null;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;
}

export class WarrantyFailureCodeDTO implements IWarrantyFailureCodeDTO {
    description?: string | null;
    failureCode?: string | null;

    constructor(data?: IWarrantyFailureCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.failureCode = _data["failureCode"] !== undefined ? _data["failureCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyFailureCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyFailureCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["failureCode"] = this.failureCode !== undefined ? this.failureCode : <any>null;
        return data;
    }

    clone(): WarrantyFailureCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyFailureCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyFailureCodeDTO {
    description?: string | null;
    failureCode?: string | null;
}

export class WarrantyMiscChargeCodeDTO implements IWarrantyMiscChargeCodeDTO {
    description?: string | null;
    limitAmount?: number;
    miscChargeCode?: string | null;

    constructor(data?: IWarrantyMiscChargeCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.limitAmount = _data["limitAmount"] !== undefined ? _data["limitAmount"] : <any>null;
            this.miscChargeCode = _data["miscChargeCode"] !== undefined ? _data["miscChargeCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyMiscChargeCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyMiscChargeCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["limitAmount"] = this.limitAmount !== undefined ? this.limitAmount : <any>null;
        data["miscChargeCode"] = this.miscChargeCode !== undefined ? this.miscChargeCode : <any>null;
        return data;
    }

    clone(): WarrantyMiscChargeCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyMiscChargeCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyMiscChargeCodeDTO {
    description?: string | null;
    limitAmount?: number;
    miscChargeCode?: string | null;
}

export class NotificationRegistrationDTO extends ValidationBaseDTO implements INotificationRegistrationDTO {
    userId?: string;
    pushToken?: string | null;
    firebaseToken?: string | null;
    devicePlatformType?: DevicePlatformTypes;
    companyType?: CompanyTypes;

    constructor(data?: INotificationRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.pushToken = _data["pushToken"] !== undefined ? _data["pushToken"] : <any>null;
            this.firebaseToken = _data["firebaseToken"] !== undefined ? _data["firebaseToken"] : <any>null;
            this.devicePlatformType = _data["devicePlatformType"] !== undefined ? _data["devicePlatformType"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["pushToken"] = this.pushToken !== undefined ? this.pushToken : <any>null;
        data["firebaseToken"] = this.firebaseToken !== undefined ? this.firebaseToken : <any>null;
        data["devicePlatformType"] = this.devicePlatformType !== undefined ? this.devicePlatformType : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): NotificationRegistrationDTO {
        const json = this.toJSON();
        let result = new NotificationRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface INotificationRegistrationDTO extends IValidationBaseDTO {
    userId?: string;
    pushToken?: string | null;
    firebaseToken?: string | null;
    devicePlatformType?: DevicePlatformTypes;
    companyType?: CompanyTypes;
}

export enum DevicePlatformTypes {
    Unknown = 0,
    Android = 1,
    Ios = 2,
    Web = 3,
}

export class NotificationDTO extends ValidationBaseDTO implements INotificationDTO {
    title!: string;
    body!: string;
    companyType!: CompanyTypes;
    notificationType!: NotificationTypes;
    vehicleId?: number | null;
    viNs?: string[] | null;
    brandIds?: string[] | null;

    constructor(data?: INotificationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.vehicleId = _data["vehicleId"] !== undefined ? _data["vehicleId"] : <any>null;
            if (Array.isArray(_data["viNs"])) {
                this.viNs = [] as any;
                for (let item of _data["viNs"])
                    this.viNs!.push(item);
            }
            else {
                this.viNs = <any>null;
            }
            if (Array.isArray(_data["brandIds"])) {
                this.brandIds = [] as any;
                for (let item of _data["brandIds"])
                    this.brandIds!.push(item);
            }
            else {
                this.brandIds = <any>null;
            }
        }
    }

    static fromJS(data: any): NotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["vehicleId"] = this.vehicleId !== undefined ? this.vehicleId : <any>null;
        if (Array.isArray(this.viNs)) {
            data["viNs"] = [];
            for (let item of this.viNs)
                data["viNs"].push(item);
        }
        if (Array.isArray(this.brandIds)) {
            data["brandIds"] = [];
            for (let item of this.brandIds)
                data["brandIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): NotificationDTO {
        const json = this.toJSON();
        let result = new NotificationDTO();
        result.init(json);
        return result;
    }
}

export interface INotificationDTO extends IValidationBaseDTO {
    title: string;
    body: string;
    companyType: CompanyTypes;
    notificationType: NotificationTypes;
    vehicleId?: number | null;
    viNs?: string[] | null;
    brandIds?: string[] | null;
}

export enum NotificationTypes {
    Unknown = 0,
    MaintenanceThreeMonth = 1,
    MaintenanceSixMonth = 2,
    Recall = 3,
    TechnicalServiceBulletin = 4,
    InformationalVideo = 5,
    NewsMaterial = 6,
    Custom = 7,
    VehicleRegistrationStatus = 8,
}

export class UserNotificationDTO extends ValidationBaseDTO implements IUserNotificationDTO {
    userNotificationUid?: string;
    notificationType?: NotificationTypes;
    title?: string | null;
    content?: string | null;
    isRead?: boolean;
    sentDateTime?: moment.Moment;
    companyType?: CompanyTypes;

    constructor(data?: IUserNotificationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userNotificationUid = _data["userNotificationUid"] !== undefined ? _data["userNotificationUid"] : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : <any>null;
            this.sentDateTime = _data["sentDateTime"] ? moment(_data["sentDateTime"].toString()) : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): UserNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationUid"] = this.userNotificationUid !== undefined ? this.userNotificationUid : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toISOString() : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserNotificationDTO {
        const json = this.toJSON();
        let result = new UserNotificationDTO();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationDTO extends IValidationBaseDTO {
    userNotificationUid?: string;
    notificationType?: NotificationTypes;
    title?: string | null;
    content?: string | null;
    isRead?: boolean;
    sentDateTime?: moment.Moment;
    companyType?: CompanyTypes;
}

export class ProductItemDTO implements IProductItemDTO {
    itemNumber?: string | null;
    productName?: string | null;
    salesPrice?: number;
    onHandQuantity?: number;
    warrantyClassCode?: string | null;
    imageBase64?: string | null;
    totalItems?: number;
    brand?: string | null;
    year?: number;
    category?: string | null;
    unitOfMeasure?: string | null;
    currency?: string | null;
    additionalInfoRequired?: boolean;
    hasSubcomponents?: boolean;
    hasAlternateItem?: boolean;
    additionalSalesPrices?: SalesPriceInfoDTO[] | null;
    externalIds?: string[] | null;

    constructor(data?: IProductItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : <any>null;
            this.onHandQuantity = _data["onHandQuantity"] !== undefined ? _data["onHandQuantity"] : <any>null;
            this.warrantyClassCode = _data["warrantyClassCode"] !== undefined ? _data["warrantyClassCode"] : <any>null;
            this.imageBase64 = _data["imageBase64"] !== undefined ? _data["imageBase64"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.unitOfMeasure = _data["unitOfMeasure"] !== undefined ? _data["unitOfMeasure"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.additionalInfoRequired = _data["additionalInfoRequired"] !== undefined ? _data["additionalInfoRequired"] : <any>null;
            this.hasSubcomponents = _data["hasSubcomponents"] !== undefined ? _data["hasSubcomponents"] : <any>null;
            this.hasAlternateItem = _data["hasAlternateItem"] !== undefined ? _data["hasAlternateItem"] : <any>null;
            if (Array.isArray(_data["additionalSalesPrices"])) {
                this.additionalSalesPrices = [] as any;
                for (let item of _data["additionalSalesPrices"])
                    this.additionalSalesPrices!.push(SalesPriceInfoDTO.fromJS(item));
            }
            else {
                this.additionalSalesPrices = <any>null;
            }
            if (Array.isArray(_data["externalIds"])) {
                this.externalIds = [] as any;
                for (let item of _data["externalIds"])
                    this.externalIds!.push(item);
            }
            else {
                this.externalIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : <any>null;
        data["onHandQuantity"] = this.onHandQuantity !== undefined ? this.onHandQuantity : <any>null;
        data["warrantyClassCode"] = this.warrantyClassCode !== undefined ? this.warrantyClassCode : <any>null;
        data["imageBase64"] = this.imageBase64 !== undefined ? this.imageBase64 : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["unitOfMeasure"] = this.unitOfMeasure !== undefined ? this.unitOfMeasure : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["additionalInfoRequired"] = this.additionalInfoRequired !== undefined ? this.additionalInfoRequired : <any>null;
        data["hasSubcomponents"] = this.hasSubcomponents !== undefined ? this.hasSubcomponents : <any>null;
        data["hasAlternateItem"] = this.hasAlternateItem !== undefined ? this.hasAlternateItem : <any>null;
        if (Array.isArray(this.additionalSalesPrices)) {
            data["additionalSalesPrices"] = [];
            for (let item of this.additionalSalesPrices)
                data["additionalSalesPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.externalIds)) {
            data["externalIds"] = [];
            for (let item of this.externalIds)
                data["externalIds"].push(item);
        }
        return data;
    }

    clone(): ProductItemDTO {
        const json = this.toJSON();
        let result = new ProductItemDTO();
        result.init(json);
        return result;
    }
}

export interface IProductItemDTO {
    itemNumber?: string | null;
    productName?: string | null;
    salesPrice?: number;
    onHandQuantity?: number;
    warrantyClassCode?: string | null;
    imageBase64?: string | null;
    totalItems?: number;
    brand?: string | null;
    year?: number;
    category?: string | null;
    unitOfMeasure?: string | null;
    currency?: string | null;
    additionalInfoRequired?: boolean;
    hasSubcomponents?: boolean;
    hasAlternateItem?: boolean;
    additionalSalesPrices?: SalesPriceInfoDTO[] | null;
    externalIds?: string[] | null;
}

export class SalesPriceInfoDTO implements ISalesPriceInfoDTO {
    unitOfMeasureId?: string | null;
    unitOfMeasureDescription?: string | null;
    price?: number;
    salesPrice?: number;

    constructor(data?: ISalesPriceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitOfMeasureId = _data["unitOfMeasureId"] !== undefined ? _data["unitOfMeasureId"] : <any>null;
            this.unitOfMeasureDescription = _data["unitOfMeasureDescription"] !== undefined ? _data["unitOfMeasureDescription"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : <any>null;
        }
    }

    static fromJS(data: any): SalesPriceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesPriceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOfMeasureId"] = this.unitOfMeasureId !== undefined ? this.unitOfMeasureId : <any>null;
        data["unitOfMeasureDescription"] = this.unitOfMeasureDescription !== undefined ? this.unitOfMeasureDescription : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : <any>null;
        return data;
    }

    clone(): SalesPriceInfoDTO {
        const json = this.toJSON();
        let result = new SalesPriceInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISalesPriceInfoDTO {
    unitOfMeasureId?: string | null;
    unitOfMeasureDescription?: string | null;
    price?: number;
    salesPrice?: number;
}

export class ProductItemSearchDTO extends PaginationBaseRequestDTO implements IProductItemSearchDTO {
    vin?: string | null;
    itemIdDescriptionSearch?: string | null;
    brandId?: string | null;
    year?: string | null;
    externalId?: string | null;

    constructor(data?: IProductItemSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.itemIdDescriptionSearch = _data["itemIdDescriptionSearch"] !== undefined ? _data["itemIdDescriptionSearch"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
        }
    }

    static fromJS(data: any): ProductItemSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductItemSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["itemIdDescriptionSearch"] = this.itemIdDescriptionSearch !== undefined ? this.itemIdDescriptionSearch : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ProductItemSearchDTO {
        const json = this.toJSON();
        let result = new ProductItemSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IProductItemSearchDTO extends IPaginationBaseRequestDTO {
    vin?: string | null;
    itemIdDescriptionSearch?: string | null;
    brandId?: string | null;
    year?: string | null;
    externalId?: string | null;
}

export class CreateSalesOrderDTO implements ICreateSalesOrderDTO {
    userId?: string | null;
    dealerLocationDynamicsId?: string | null;
    reference?: string | null;
    requisition?: string | null;
    modeOfDelivery?: DeliveryModeDTO | null;
    orderType?: string | null;
    vin?: string | null;
    contactName?: string | null;
    contanctEmail?: string | null;
    contactPhone?: string | null;
    deliveryName?: string | null;
    oneTimeDelivery?: boolean;
    dealerDeliveryAddress?: DealerAddressInfoDTO | null;
    oneTimeDeliveryAddress?: AddressDTO | null;
    shippingName?: string | null;
    shippingPhone?: string | null;
    cartItemLines?: SalesOrderLineItemDTO[] | null;

    constructor(data?: ICreateSalesOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.dealerLocationDynamicsId = _data["dealerLocationDynamicsId"] !== undefined ? _data["dealerLocationDynamicsId"] : <any>null;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : <any>null;
            this.requisition = _data["requisition"] !== undefined ? _data["requisition"] : <any>null;
            this.modeOfDelivery = _data["modeOfDelivery"] ? DeliveryModeDTO.fromJS(_data["modeOfDelivery"]) : <any>null;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contanctEmail = _data["contanctEmail"] !== undefined ? _data["contanctEmail"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.deliveryName = _data["deliveryName"] !== undefined ? _data["deliveryName"] : <any>null;
            this.oneTimeDelivery = _data["oneTimeDelivery"] !== undefined ? _data["oneTimeDelivery"] : <any>null;
            this.dealerDeliveryAddress = _data["dealerDeliveryAddress"] ? DealerAddressInfoDTO.fromJS(_data["dealerDeliveryAddress"]) : <any>null;
            this.oneTimeDeliveryAddress = _data["oneTimeDeliveryAddress"] ? AddressDTO.fromJS(_data["oneTimeDeliveryAddress"]) : <any>null;
            this.shippingName = _data["shippingName"] !== undefined ? _data["shippingName"] : <any>null;
            this.shippingPhone = _data["shippingPhone"] !== undefined ? _data["shippingPhone"] : <any>null;
            if (Array.isArray(_data["cartItemLines"])) {
                this.cartItemLines = [] as any;
                for (let item of _data["cartItemLines"])
                    this.cartItemLines!.push(SalesOrderLineItemDTO.fromJS(item));
            }
            else {
                this.cartItemLines = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateSalesOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalesOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["dealerLocationDynamicsId"] = this.dealerLocationDynamicsId !== undefined ? this.dealerLocationDynamicsId : <any>null;
        data["reference"] = this.reference !== undefined ? this.reference : <any>null;
        data["requisition"] = this.requisition !== undefined ? this.requisition : <any>null;
        data["modeOfDelivery"] = this.modeOfDelivery ? this.modeOfDelivery.toJSON() : <any>null;
        data["orderType"] = this.orderType !== undefined ? this.orderType : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contanctEmail"] = this.contanctEmail !== undefined ? this.contanctEmail : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["deliveryName"] = this.deliveryName !== undefined ? this.deliveryName : <any>null;
        data["oneTimeDelivery"] = this.oneTimeDelivery !== undefined ? this.oneTimeDelivery : <any>null;
        data["dealerDeliveryAddress"] = this.dealerDeliveryAddress ? this.dealerDeliveryAddress.toJSON() : <any>null;
        data["oneTimeDeliveryAddress"] = this.oneTimeDeliveryAddress ? this.oneTimeDeliveryAddress.toJSON() : <any>null;
        data["shippingName"] = this.shippingName !== undefined ? this.shippingName : <any>null;
        data["shippingPhone"] = this.shippingPhone !== undefined ? this.shippingPhone : <any>null;
        if (Array.isArray(this.cartItemLines)) {
            data["cartItemLines"] = [];
            for (let item of this.cartItemLines)
                data["cartItemLines"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateSalesOrderDTO {
        const json = this.toJSON();
        let result = new CreateSalesOrderDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateSalesOrderDTO {
    userId?: string | null;
    dealerLocationDynamicsId?: string | null;
    reference?: string | null;
    requisition?: string | null;
    modeOfDelivery?: DeliveryModeDTO | null;
    orderType?: string | null;
    vin?: string | null;
    contactName?: string | null;
    contanctEmail?: string | null;
    contactPhone?: string | null;
    deliveryName?: string | null;
    oneTimeDelivery?: boolean;
    dealerDeliveryAddress?: DealerAddressInfoDTO | null;
    oneTimeDeliveryAddress?: AddressDTO | null;
    shippingName?: string | null;
    shippingPhone?: string | null;
    cartItemLines?: SalesOrderLineItemDTO[] | null;
}

export class AddressDTO implements IAddressDTO {
    streetAddress?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;

    constructor(data?: IAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        return data;
    }

    clone(): AddressDTO {
        const json = this.toJSON();
        let result = new AddressDTO();
        result.init(json);
        return result;
    }
}

export interface IAddressDTO {
    streetAddress?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;
}

export class SalesOrderLineItemDTO implements ISalesOrderLineItemDTO {
    itemId?: string | null;
    quantity?: number;
    unitOfMeasure?: string | null;
    additionalNotes?: string | null;

    constructor(data?: ISalesOrderLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.unitOfMeasure = _data["unitOfMeasure"] !== undefined ? _data["unitOfMeasure"] : <any>null;
            this.additionalNotes = _data["additionalNotes"] !== undefined ? _data["additionalNotes"] : <any>null;
        }
    }

    static fromJS(data: any): SalesOrderLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["unitOfMeasure"] = this.unitOfMeasure !== undefined ? this.unitOfMeasure : <any>null;
        data["additionalNotes"] = this.additionalNotes !== undefined ? this.additionalNotes : <any>null;
        return data;
    }

    clone(): SalesOrderLineItemDTO {
        const json = this.toJSON();
        let result = new SalesOrderLineItemDTO();
        result.init(json);
        return result;
    }
}

export interface ISalesOrderLineItemDTO {
    itemId?: string | null;
    quantity?: number;
    unitOfMeasure?: string | null;
    additionalNotes?: string | null;
}

export class SpiffDTO implements ISpiffDTO {
    spiffId?: string | null;
    vin?: string | null;
    modelId?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    year?: string | null;
    amount?: number;
    status?: string | null;
    type?: string | null;
    custAccount?: string | null;
    custName?: string | null;
    vendAccount?: string | null;
    vendName?: string | null;
    company?: string | null;
    createdDate?: moment.Moment;
    checkNumber?: string | null;
    checkDate?: moment.Moment;
    recipientName?: string | null;
    recipientAddress?: string | null;
    totalRecords?: number;

    constructor(data?: ISpiffDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spiffId = _data["spiffId"] !== undefined ? _data["spiffId"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.brandName = _data["brandName"] !== undefined ? _data["brandName"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.custAccount = _data["custAccount"] !== undefined ? _data["custAccount"] : <any>null;
            this.custName = _data["custName"] !== undefined ? _data["custName"] : <any>null;
            this.vendAccount = _data["vendAccount"] !== undefined ? _data["vendAccount"] : <any>null;
            this.vendName = _data["vendName"] !== undefined ? _data["vendName"] : <any>null;
            this.company = _data["company"] !== undefined ? _data["company"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.checkNumber = _data["checkNumber"] !== undefined ? _data["checkNumber"] : <any>null;
            this.checkDate = _data["checkDate"] ? moment(_data["checkDate"].toString()) : <any>null;
            this.recipientName = _data["recipientName"] !== undefined ? _data["recipientName"] : <any>null;
            this.recipientAddress = _data["recipientAddress"] !== undefined ? _data["recipientAddress"] : <any>null;
            this.totalRecords = _data["totalRecords"] !== undefined ? _data["totalRecords"] : <any>null;
        }
    }

    static fromJS(data: any): SpiffDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpiffDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spiffId"] = this.spiffId !== undefined ? this.spiffId : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["modelId"] = this.modelId !== undefined ? this.modelId : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["brandName"] = this.brandName !== undefined ? this.brandName : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["custAccount"] = this.custAccount !== undefined ? this.custAccount : <any>null;
        data["custName"] = this.custName !== undefined ? this.custName : <any>null;
        data["vendAccount"] = this.vendAccount !== undefined ? this.vendAccount : <any>null;
        data["vendName"] = this.vendName !== undefined ? this.vendName : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["checkNumber"] = this.checkNumber !== undefined ? this.checkNumber : <any>null;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>null;
        data["recipientName"] = this.recipientName !== undefined ? this.recipientName : <any>null;
        data["recipientAddress"] = this.recipientAddress !== undefined ? this.recipientAddress : <any>null;
        data["totalRecords"] = this.totalRecords !== undefined ? this.totalRecords : <any>null;
        return data;
    }

    clone(): SpiffDTO {
        const json = this.toJSON();
        let result = new SpiffDTO();
        result.init(json);
        return result;
    }
}

export interface ISpiffDTO {
    spiffId?: string | null;
    vin?: string | null;
    modelId?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    year?: string | null;
    amount?: number;
    status?: string | null;
    type?: string | null;
    custAccount?: string | null;
    custName?: string | null;
    vendAccount?: string | null;
    vendName?: string | null;
    company?: string | null;
    createdDate?: moment.Moment;
    checkNumber?: string | null;
    checkDate?: moment.Moment;
    recipientName?: string | null;
    recipientAddress?: string | null;
    totalRecords?: number;
}

export class SpiffSearchDTO extends PaginationBaseRequestDTO implements ISpiffSearchDTO {
    activeDealerAccountId?: string | null;
    customerId?: string | null;
    spiffId?: string | null;
    status?: string | null;
    vin?: string | null;

    constructor(data?: ISpiffSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activeDealerAccountId = _data["activeDealerAccountId"] !== undefined ? _data["activeDealerAccountId"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.spiffId = _data["spiffId"] !== undefined ? _data["spiffId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
        }
    }

    static fromJS(data: any): SpiffSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpiffSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeDealerAccountId"] = this.activeDealerAccountId !== undefined ? this.activeDealerAccountId : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["spiffId"] = this.spiffId !== undefined ? this.spiffId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SpiffSearchDTO {
        const json = this.toJSON();
        let result = new SpiffSearchDTO();
        result.init(json);
        return result;
    }
}

export interface ISpiffSearchDTO extends IPaginationBaseRequestDTO {
    activeDealerAccountId?: string | null;
    customerId?: string | null;
    spiffId?: string | null;
    status?: string | null;
    vin?: string | null;
}

export class VinDTO extends ValidationBaseDTO implements IVinDTO {
    id?: number;
    uid?: string;
    company?: string | null;
    companyType?: CompanyTypes;
    vin?: string | null;
    name?: string | null;
    model?: string | null;
    brandId?: string | null;
    brand?: string | null;
    year?: number;
    warrantyStartDate?: moment.Moment;
    warrantyEndDate?: moment.Moment;
    serviceExpirationDate?: moment.Moment;
    partsExpirationDate?: moment.Moment;
    warrantyStatus?: string | null;
    isRegistered?: boolean;
    displayName?: string | null;
    vehicleType?: string | null;
    purchaseDate?: moment.Moment;
    itemNumber?: string | null;
    site?: string | null;
    hasLegalLetter?: boolean;
    contactID?: string | null;
    customerSignature?: boolean;

    constructor(data?: IVinDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.company = _data["company"] !== undefined ? _data["company"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.warrantyStartDate = _data["warrantyStartDate"] ? moment(_data["warrantyStartDate"].toString()) : <any>null;
            this.warrantyEndDate = _data["warrantyEndDate"] ? moment(_data["warrantyEndDate"].toString()) : <any>null;
            this.serviceExpirationDate = _data["serviceExpirationDate"] ? moment(_data["serviceExpirationDate"].toString()) : <any>null;
            this.partsExpirationDate = _data["partsExpirationDate"] ? moment(_data["partsExpirationDate"].toString()) : <any>null;
            this.warrantyStatus = _data["warrantyStatus"] !== undefined ? _data["warrantyStatus"] : <any>null;
            this.isRegistered = _data["isRegistered"] !== undefined ? _data["isRegistered"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.vehicleType = _data["vehicleType"] !== undefined ? _data["vehicleType"] : <any>null;
            this.purchaseDate = _data["purchaseDate"] ? moment(_data["purchaseDate"].toString()) : <any>null;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : <any>null;
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.hasLegalLetter = _data["hasLegalLetter"] !== undefined ? _data["hasLegalLetter"] : <any>null;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : <any>null;
            this.customerSignature = _data["customerSignature"] !== undefined ? _data["customerSignature"] : <any>null;
        }
    }

    static fromJS(data: any): VinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["warrantyStartDate"] = this.warrantyStartDate ? this.warrantyStartDate.toISOString() : <any>null;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toISOString() : <any>null;
        data["serviceExpirationDate"] = this.serviceExpirationDate ? this.serviceExpirationDate.toISOString() : <any>null;
        data["partsExpirationDate"] = this.partsExpirationDate ? this.partsExpirationDate.toISOString() : <any>null;
        data["warrantyStatus"] = this.warrantyStatus !== undefined ? this.warrantyStatus : <any>null;
        data["isRegistered"] = this.isRegistered !== undefined ? this.isRegistered : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["vehicleType"] = this.vehicleType !== undefined ? this.vehicleType : <any>null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>null;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : <any>null;
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["hasLegalLetter"] = this.hasLegalLetter !== undefined ? this.hasLegalLetter : <any>null;
        data["contactID"] = this.contactID !== undefined ? this.contactID : <any>null;
        data["customerSignature"] = this.customerSignature !== undefined ? this.customerSignature : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VinDTO {
        const json = this.toJSON();
        let result = new VinDTO();
        result.init(json);
        return result;
    }
}

export interface IVinDTO extends IValidationBaseDTO {
    id?: number;
    uid?: string;
    company?: string | null;
    companyType?: CompanyTypes;
    vin?: string | null;
    name?: string | null;
    model?: string | null;
    brandId?: string | null;
    brand?: string | null;
    year?: number;
    warrantyStartDate?: moment.Moment;
    warrantyEndDate?: moment.Moment;
    serviceExpirationDate?: moment.Moment;
    partsExpirationDate?: moment.Moment;
    warrantyStatus?: string | null;
    isRegistered?: boolean;
    displayName?: string | null;
    vehicleType?: string | null;
    purchaseDate?: moment.Moment;
    itemNumber?: string | null;
    site?: string | null;
    hasLegalLetter?: boolean;
    contactID?: string | null;
    customerSignature?: boolean;
}

export class CreateSpiffRequestDTO extends ValidationBaseDTO implements ICreateSpiffRequestDTO {
    salesmanId?: number;
    spiffId?: string | null;
    spiffType?: string | null;
    vin?: string | null;

    constructor(data?: ICreateSpiffRequestDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.salesmanId = _data["salesmanId"] !== undefined ? _data["salesmanId"] : <any>null;
            this.spiffId = _data["spiffId"] !== undefined ? _data["spiffId"] : <any>null;
            this.spiffType = _data["spiffType"] !== undefined ? _data["spiffType"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSpiffRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpiffRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanId"] = this.salesmanId !== undefined ? this.salesmanId : <any>null;
        data["spiffId"] = this.spiffId !== undefined ? this.spiffId : <any>null;
        data["spiffType"] = this.spiffType !== undefined ? this.spiffType : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CreateSpiffRequestDTO {
        const json = this.toJSON();
        let result = new CreateSpiffRequestDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateSpiffRequestDTO extends IValidationBaseDTO {
    salesmanId?: number;
    spiffId?: string | null;
    spiffType?: string | null;
    vin?: string | null;
}

export class SpiffSalesmanDTO implements ISpiffSalesmanDTO {
    salesmanId?: number;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: ISpiffSalesmanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesmanId = _data["salesmanId"] !== undefined ? _data["salesmanId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): SpiffSalesmanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpiffSalesmanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanId"] = this.salesmanId !== undefined ? this.salesmanId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }

    clone(): SpiffSalesmanDTO {
        const json = this.toJSON();
        let result = new SpiffSalesmanDTO();
        result.init(json);
        return result;
    }
}

export interface ISpiffSalesmanDTO {
    salesmanId?: number;
    firstName?: string | null;
    lastName?: string | null;
}

export class W9RequestSearchDTO extends PaginationBaseRequestDTO implements IW9RequestSearchDTO {
    dealerUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    status?: string | null;

    constructor(data?: IW9RequestSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dealerUserId = _data["dealerUserId"] !== undefined ? _data["dealerUserId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): W9RequestSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new W9RequestSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerUserId"] = this.dealerUserId !== undefined ? this.dealerUserId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): W9RequestSearchDTO {
        const json = this.toJSON();
        let result = new W9RequestSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IW9RequestSearchDTO extends IPaginationBaseRequestDTO {
    dealerUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    status?: string | null;
}

export class ViewVinRegistrationDTO implements IViewVinRegistrationDTO {
    vinUid?: string;
    vin?: string | null;
    brandId?: string | null;
    ownerUserId?: string;
    vinRegistrationStatus?: string | null;
    registeredDate?: moment.Moment;
    reviewedDate?: moment.Moment | null;
    reviewComments?: string | null;
    displayName?: string | null;
    nickname?: string | null;
    customImageId?: number | null;
    vinRegistrationUid?: string;

    constructor(data?: IViewVinRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vinUid = _data["vinUid"] !== undefined ? _data["vinUid"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.ownerUserId = _data["ownerUserId"] !== undefined ? _data["ownerUserId"] : <any>null;
            this.vinRegistrationStatus = _data["vinRegistrationStatus"] !== undefined ? _data["vinRegistrationStatus"] : <any>null;
            this.registeredDate = _data["registeredDate"] ? moment(_data["registeredDate"].toString()) : <any>null;
            this.reviewedDate = _data["reviewedDate"] ? moment(_data["reviewedDate"].toString()) : <any>null;
            this.reviewComments = _data["reviewComments"] !== undefined ? _data["reviewComments"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : <any>null;
            this.customImageId = _data["customImageId"] !== undefined ? _data["customImageId"] : <any>null;
            this.vinRegistrationUid = _data["vinRegistrationUid"] !== undefined ? _data["vinRegistrationUid"] : <any>null;
        }
    }

    static fromJS(data: any): ViewVinRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ViewVinRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vinUid"] = this.vinUid !== undefined ? this.vinUid : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : <any>null;
        data["vinRegistrationStatus"] = this.vinRegistrationStatus !== undefined ? this.vinRegistrationStatus : <any>null;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>null;
        data["reviewedDate"] = this.reviewedDate ? this.reviewedDate.toISOString() : <any>null;
        data["reviewComments"] = this.reviewComments !== undefined ? this.reviewComments : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["nickname"] = this.nickname !== undefined ? this.nickname : <any>null;
        data["customImageId"] = this.customImageId !== undefined ? this.customImageId : <any>null;
        data["vinRegistrationUid"] = this.vinRegistrationUid !== undefined ? this.vinRegistrationUid : <any>null;
        return data;
    }

    clone(): ViewVinRegistrationDTO {
        const json = this.toJSON();
        let result = new ViewVinRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IViewVinRegistrationDTO {
    vinUid?: string;
    vin?: string | null;
    brandId?: string | null;
    ownerUserId?: string;
    vinRegistrationStatus?: string | null;
    registeredDate?: moment.Moment;
    reviewedDate?: moment.Moment | null;
    reviewComments?: string | null;
    displayName?: string | null;
    nickname?: string | null;
    customImageId?: number | null;
    vinRegistrationUid?: string;
}

export class VinRegistrationDTO extends ValidationBaseDTO implements IVinRegistrationDTO {
    portalUserId?: string;
    firstName?: string | null;
    lastName?: string | null;
    purchaseDate?: moment.Moment;
    streetAddress?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    vin?: string | null;
    isOwnerTransfer?: boolean;
    transferDocumentUrl?: string | null;
    transferDocumentType?: string | null;
    nickname?: string | null;

    constructor(data?: IVinRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.portalUserId = _data["portalUserId"] !== undefined ? _data["portalUserId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.purchaseDate = _data["purchaseDate"] ? moment(_data["purchaseDate"].toString()) : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.isOwnerTransfer = _data["isOwnerTransfer"] !== undefined ? _data["isOwnerTransfer"] : <any>null;
            this.transferDocumentUrl = _data["transferDocumentUrl"] !== undefined ? _data["transferDocumentUrl"] : <any>null;
            this.transferDocumentType = _data["transferDocumentType"] !== undefined ? _data["transferDocumentType"] : <any>null;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : <any>null;
        }
    }

    static fromJS(data: any): VinRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalUserId"] = this.portalUserId !== undefined ? this.portalUserId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["isOwnerTransfer"] = this.isOwnerTransfer !== undefined ? this.isOwnerTransfer : <any>null;
        data["transferDocumentUrl"] = this.transferDocumentUrl !== undefined ? this.transferDocumentUrl : <any>null;
        data["transferDocumentType"] = this.transferDocumentType !== undefined ? this.transferDocumentType : <any>null;
        data["nickname"] = this.nickname !== undefined ? this.nickname : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VinRegistrationDTO {
        const json = this.toJSON();
        let result = new VinRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IVinRegistrationDTO extends IValidationBaseDTO {
    portalUserId?: string;
    firstName?: string | null;
    lastName?: string | null;
    purchaseDate?: moment.Moment;
    streetAddress?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    vin?: string | null;
    isOwnerTransfer?: boolean;
    transferDocumentUrl?: string | null;
    transferDocumentType?: string | null;
    nickname?: string | null;
}

export class ImageDTO implements IImageDTO {
    imageType?: string | null;
    base64?: string | null;

    constructor(data?: IImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageType = _data["imageType"] !== undefined ? _data["imageType"] : <any>null;
            this.base64 = _data["base64"] !== undefined ? _data["base64"] : <any>null;
        }
    }

    static fromJS(data: any): ImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageType"] = this.imageType !== undefined ? this.imageType : <any>null;
        data["base64"] = this.base64 !== undefined ? this.base64 : <any>null;
        return data;
    }

    clone(): ImageDTO {
        const json = this.toJSON();
        let result = new ImageDTO();
        result.init(json);
        return result;
    }
}

export interface IImageDTO {
    imageType?: string | null;
    base64?: string | null;
}

export class ClaimDTO implements IClaimDTO {
    claimNumber?: string | null;
    status?: string | null;
    statusDate?: moment.Moment;
    createdDate?: moment.Moment;

    constructor(data?: IClaimDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusDate = _data["statusDate"] ? moment(_data["statusDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ClaimDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }

    clone(): ClaimDTO {
        const json = this.toJSON();
        let result = new ClaimDTO();
        result.init(json);
        return result;
    }
}

export interface IClaimDTO {
    claimNumber?: string | null;
    status?: string | null;
    statusDate?: moment.Moment;
    createdDate?: moment.Moment;
}

export class RecallDTO implements IRecallDTO {
    recallId?: string | null;
    name?: string | null;
    type?: string | null;

    constructor(data?: IRecallDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recallId = _data["recallId"] !== undefined ? _data["recallId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): RecallDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecallDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recallId"] = this.recallId !== undefined ? this.recallId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): RecallDTO {
        const json = this.toJSON();
        let result = new RecallDTO();
        result.init(json);
        return result;
    }
}

export interface IRecallDTO {
    recallId?: string | null;
    name?: string | null;
    type?: string | null;
}

export class InviteConsumerUserDTO extends ValidationBaseDTO implements IInviteConsumerUserDTO {
    email!: string;
    vinUid?: string;
    isNewUser?: boolean | null;
    companyType?: CompanyTypes;

    constructor(data?: IInviteConsumerUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.vinUid = _data["vinUid"] !== undefined ? _data["vinUid"] : <any>null;
            this.isNewUser = _data["isNewUser"] !== undefined ? _data["isNewUser"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): InviteConsumerUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InviteConsumerUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["vinUid"] = this.vinUid !== undefined ? this.vinUid : <any>null;
        data["isNewUser"] = this.isNewUser !== undefined ? this.isNewUser : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): InviteConsumerUserDTO {
        const json = this.toJSON();
        let result = new InviteConsumerUserDTO();
        result.init(json);
        return result;
    }
}

export interface IInviteConsumerUserDTO extends IValidationBaseDTO {
    email: string;
    vinUid?: string;
    isNewUser?: boolean | null;
    companyType?: CompanyTypes;
}

export class VinOwnerRegistrationDTO extends ValidationBaseDTO implements IVinOwnerRegistrationDTO {
    lastName!: string;
    purchaseDate!: moment.Moment;
    zipCode!: string;
    vin!: string;
    isOriginalOwner?: boolean;
    isResubmitWithDoc?: boolean;
    ownerTransferDocumentUid?: string | null;
    nickname?: string | null;
    ownerTransferDocumentTypeId?: number | null;
    registrationErrorType?: RegistrationErrorTypes | null;

    constructor(data?: IVinOwnerRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.purchaseDate = _data["purchaseDate"] ? moment(_data["purchaseDate"].toString()) : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.isOriginalOwner = _data["isOriginalOwner"] !== undefined ? _data["isOriginalOwner"] : <any>null;
            this.isResubmitWithDoc = _data["isResubmitWithDoc"] !== undefined ? _data["isResubmitWithDoc"] : <any>null;
            this.ownerTransferDocumentUid = _data["ownerTransferDocumentUid"] !== undefined ? _data["ownerTransferDocumentUid"] : <any>null;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : <any>null;
            this.ownerTransferDocumentTypeId = _data["ownerTransferDocumentTypeId"] !== undefined ? _data["ownerTransferDocumentTypeId"] : <any>null;
            this.registrationErrorType = _data["registrationErrorType"] !== undefined ? _data["registrationErrorType"] : <any>null;
        }
    }

    static fromJS(data: any): VinOwnerRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinOwnerRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["isOriginalOwner"] = this.isOriginalOwner !== undefined ? this.isOriginalOwner : <any>null;
        data["isResubmitWithDoc"] = this.isResubmitWithDoc !== undefined ? this.isResubmitWithDoc : <any>null;
        data["ownerTransferDocumentUid"] = this.ownerTransferDocumentUid !== undefined ? this.ownerTransferDocumentUid : <any>null;
        data["nickname"] = this.nickname !== undefined ? this.nickname : <any>null;
        data["ownerTransferDocumentTypeId"] = this.ownerTransferDocumentTypeId !== undefined ? this.ownerTransferDocumentTypeId : <any>null;
        data["registrationErrorType"] = this.registrationErrorType !== undefined ? this.registrationErrorType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VinOwnerRegistrationDTO {
        const json = this.toJSON();
        let result = new VinOwnerRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IVinOwnerRegistrationDTO extends IValidationBaseDTO {
    lastName: string;
    purchaseDate: moment.Moment;
    zipCode: string;
    vin: string;
    isOriginalOwner?: boolean;
    isResubmitWithDoc?: boolean;
    ownerTransferDocumentUid?: string | null;
    nickname?: string | null;
    ownerTransferDocumentTypeId?: number | null;
    registrationErrorType?: RegistrationErrorTypes | null;
}

export enum RegistrationErrorTypes {
    Unknown = 0,
    VinNotFound = 1,
    InvalidOwnerInformation = 2,
}

export class VinRegistrationStatusDTO extends ValidationBaseDTO implements IVinRegistrationStatusDTO {
    vin!: string;
    portalUserId!: string;
    approved!: boolean;
    comments?: string | null;

    constructor(data?: IVinRegistrationStatusDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.portalUserId = _data["portalUserId"] !== undefined ? _data["portalUserId"] : <any>null;
            this.approved = _data["approved"] !== undefined ? _data["approved"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
        }
    }

    static fromJS(data: any): VinRegistrationStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinRegistrationStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["portalUserId"] = this.portalUserId !== undefined ? this.portalUserId : <any>null;
        data["approved"] = this.approved !== undefined ? this.approved : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VinRegistrationStatusDTO {
        const json = this.toJSON();
        let result = new VinRegistrationStatusDTO();
        result.init(json);
        return result;
    }
}

export interface IVinRegistrationStatusDTO extends IValidationBaseDTO {
    vin: string;
    portalUserId: string;
    approved: boolean;
    comments?: string | null;
}

export class UpdateVinRegistrationDTO extends ValidationBaseDTO implements IUpdateVinRegistrationDTO {
    vehicleUid?: string;
    nickname?: string | null;
    customImageDocumentUid?: string | null;

    constructor(data?: IUpdateVinRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicleUid = _data["vehicleUid"] !== undefined ? _data["vehicleUid"] : <any>null;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : <any>null;
            this.customImageDocumentUid = _data["customImageDocumentUid"] !== undefined ? _data["customImageDocumentUid"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVinRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVinRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleUid"] = this.vehicleUid !== undefined ? this.vehicleUid : <any>null;
        data["nickname"] = this.nickname !== undefined ? this.nickname : <any>null;
        data["customImageDocumentUid"] = this.customImageDocumentUid !== undefined ? this.customImageDocumentUid : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UpdateVinRegistrationDTO {
        const json = this.toJSON();
        let result = new UpdateVinRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateVinRegistrationDTO extends IValidationBaseDTO {
    vehicleUid?: string;
    nickname?: string | null;
    customImageDocumentUid?: string | null;
}

export class SalesOrderDTO implements ISalesOrderDTO {
    vin?: string | null;
    rvName?: string | null;
    orderNumber?: string | null;
    status?: string | null;
    deliveryMode?: string | null;
    trackingNumber?: string | null;
    statusDate?: moment.Moment;
    createdDate?: moment.Moment;

    constructor(data?: ISalesOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.rvName = _data["rvName"] !== undefined ? _data["rvName"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.deliveryMode = _data["deliveryMode"] !== undefined ? _data["deliveryMode"] : <any>null;
            this.trackingNumber = _data["trackingNumber"] !== undefined ? _data["trackingNumber"] : <any>null;
            this.statusDate = _data["statusDate"] ? moment(_data["statusDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SalesOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["rvName"] = this.rvName !== undefined ? this.rvName : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["deliveryMode"] = this.deliveryMode !== undefined ? this.deliveryMode : <any>null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : <any>null;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }

    clone(): SalesOrderDTO {
        const json = this.toJSON();
        let result = new SalesOrderDTO();
        result.init(json);
        return result;
    }
}

export interface ISalesOrderDTO {
    vin?: string | null;
    rvName?: string | null;
    orderNumber?: string | null;
    status?: string | null;
    deliveryMode?: string | null;
    trackingNumber?: string | null;
    statusDate?: moment.Moment;
    createdDate?: moment.Moment;
}

export class W9RequestDTO extends ValidationBaseDTO implements IW9RequestDTO {
    requestorId?: string | null;
    salesmanId?: number;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    phoneNumber?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    zipCode?: string | null;
    country?: string | null;
    customerAccount?: string | null;
    customerName?: string | null;
    status?: string | null;
    dateSubmitted?: string | null;
    dateUpdated?: string | null;
    comment?: string | null;
    documentUId?: string | null;
    totalItems?: number;

    constructor(data?: IW9RequestDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestorId = _data["requestorId"] !== undefined ? _data["requestorId"] : <any>null;
            this.salesmanId = _data["salesmanId"] !== undefined ? _data["salesmanId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateProvince = _data["stateProvince"] !== undefined ? _data["stateProvince"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.customerAccount = _data["customerAccount"] !== undefined ? _data["customerAccount"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] !== undefined ? _data["dateSubmitted"] : <any>null;
            this.dateUpdated = _data["dateUpdated"] !== undefined ? _data["dateUpdated"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.documentUId = _data["documentUId"] !== undefined ? _data["documentUId"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): W9RequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new W9RequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorId"] = this.requestorId !== undefined ? this.requestorId : <any>null;
        data["salesmanId"] = this.salesmanId !== undefined ? this.salesmanId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["ssn"] = this.ssn !== undefined ? this.ssn : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateProvince"] = this.stateProvince !== undefined ? this.stateProvince : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["customerAccount"] = this.customerAccount !== undefined ? this.customerAccount : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dateSubmitted"] = this.dateSubmitted !== undefined ? this.dateSubmitted : <any>null;
        data["dateUpdated"] = this.dateUpdated !== undefined ? this.dateUpdated : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["documentUId"] = this.documentUId !== undefined ? this.documentUId : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): W9RequestDTO {
        const json = this.toJSON();
        let result = new W9RequestDTO();
        result.init(json);
        return result;
    }
}

export interface IW9RequestDTO extends IValidationBaseDTO {
    requestorId?: string | null;
    salesmanId?: number;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    phoneNumber?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    zipCode?: string | null;
    country?: string | null;
    customerAccount?: string | null;
    customerName?: string | null;
    status?: string | null;
    dateSubmitted?: string | null;
    dateUpdated?: string | null;
    comment?: string | null;
    documentUId?: string | null;
    totalItems?: number;
}

export class VinWarrantyRegistrationDTO extends ValidationBaseDTO implements IVinWarrantyRegistrationDTO {
    vin?: string | null;
    firstnName?: string | null;
    lastName?: string | null;
    nickname?: string | null;
    secondaryOwnerFirstName?: string | null;
    secondaryOwnerLastName?: string | null;
    street?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    primaryPhoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    fax?: string | null;
    email?: string | null;
    customerSignature?: boolean;
    dateSold?: moment.Moment;
    retailSold?: boolean;

    constructor(data?: IVinWarrantyRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.firstnName = _data["firstnName"] !== undefined ? _data["firstnName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : <any>null;
            this.secondaryOwnerFirstName = _data["secondaryOwnerFirstName"] !== undefined ? _data["secondaryOwnerFirstName"] : <any>null;
            this.secondaryOwnerLastName = _data["secondaryOwnerLastName"] !== undefined ? _data["secondaryOwnerLastName"] : <any>null;
            this.street = _data["street"] !== undefined ? _data["street"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.primaryPhoneNumber = _data["primaryPhoneNumber"] !== undefined ? _data["primaryPhoneNumber"] : <any>null;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.customerSignature = _data["customerSignature"] !== undefined ? _data["customerSignature"] : <any>null;
            this.dateSold = _data["dateSold"] ? moment(_data["dateSold"].toString()) : <any>null;
            this.retailSold = _data["retailSold"] !== undefined ? _data["retailSold"] : <any>null;
        }
    }

    static fromJS(data: any): VinWarrantyRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinWarrantyRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["firstnName"] = this.firstnName !== undefined ? this.firstnName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["nickname"] = this.nickname !== undefined ? this.nickname : <any>null;
        data["secondaryOwnerFirstName"] = this.secondaryOwnerFirstName !== undefined ? this.secondaryOwnerFirstName : <any>null;
        data["secondaryOwnerLastName"] = this.secondaryOwnerLastName !== undefined ? this.secondaryOwnerLastName : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["primaryPhoneNumber"] = this.primaryPhoneNumber !== undefined ? this.primaryPhoneNumber : <any>null;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["customerSignature"] = this.customerSignature !== undefined ? this.customerSignature : <any>null;
        data["dateSold"] = this.dateSold ? this.dateSold.toISOString() : <any>null;
        data["retailSold"] = this.retailSold !== undefined ? this.retailSold : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): VinWarrantyRegistrationDTO {
        const json = this.toJSON();
        let result = new VinWarrantyRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IVinWarrantyRegistrationDTO extends IValidationBaseDTO {
    vin?: string | null;
    firstnName?: string | null;
    lastName?: string | null;
    nickname?: string | null;
    secondaryOwnerFirstName?: string | null;
    secondaryOwnerLastName?: string | null;
    street?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    primaryPhoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    fax?: string | null;
    email?: string | null;
    customerSignature?: boolean;
    dateSold?: moment.Moment;
    retailSold?: boolean;
}

export class WarrantyRegistrationDTO implements IWarrantyRegistrationDTO {
    vin?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    model?: string | null;
    status?: string | null;
    custAccount?: string | null;
    year?: number;
    dealerSold?: boolean;
    hasLegalLetter?: boolean;
    hasRecall?: boolean;
    ownerName?: string | null;
    completedDate?: moment.Moment;
    shipDate?: moment.Moment;
    registrationDate?: moment.Moment | null;
    isRegistered?: boolean;
    isAssociated?: boolean;
    totalItems?: number;

    constructor(data?: IWarrantyRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.brandName = _data["brandName"] !== undefined ? _data["brandName"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.custAccount = _data["custAccount"] !== undefined ? _data["custAccount"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.dealerSold = _data["dealerSold"] !== undefined ? _data["dealerSold"] : <any>null;
            this.hasLegalLetter = _data["hasLegalLetter"] !== undefined ? _data["hasLegalLetter"] : <any>null;
            this.hasRecall = _data["hasRecall"] !== undefined ? _data["hasRecall"] : <any>null;
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : <any>null;
            this.completedDate = _data["completedDate"] ? moment(_data["completedDate"].toString()) : <any>null;
            this.shipDate = _data["shipDate"] ? moment(_data["shipDate"].toString()) : <any>null;
            this.registrationDate = _data["registrationDate"] ? moment(_data["registrationDate"].toString()) : <any>null;
            this.isRegistered = _data["isRegistered"] !== undefined ? _data["isRegistered"] : <any>null;
            this.isAssociated = _data["isAssociated"] !== undefined ? _data["isAssociated"] : <any>null;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["brandName"] = this.brandName !== undefined ? this.brandName : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["custAccount"] = this.custAccount !== undefined ? this.custAccount : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["dealerSold"] = this.dealerSold !== undefined ? this.dealerSold : <any>null;
        data["hasLegalLetter"] = this.hasLegalLetter !== undefined ? this.hasLegalLetter : <any>null;
        data["hasRecall"] = this.hasRecall !== undefined ? this.hasRecall : <any>null;
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : <any>null;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>null;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>null;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>null;
        data["isRegistered"] = this.isRegistered !== undefined ? this.isRegistered : <any>null;
        data["isAssociated"] = this.isAssociated !== undefined ? this.isAssociated : <any>null;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        return data;
    }

    clone(): WarrantyRegistrationDTO {
        const json = this.toJSON();
        let result = new WarrantyRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyRegistrationDTO {
    vin?: string | null;
    brandId?: string | null;
    brandName?: string | null;
    model?: string | null;
    status?: string | null;
    custAccount?: string | null;
    year?: number;
    dealerSold?: boolean;
    hasLegalLetter?: boolean;
    hasRecall?: boolean;
    ownerName?: string | null;
    completedDate?: moment.Moment;
    shipDate?: moment.Moment;
    registrationDate?: moment.Moment | null;
    isRegistered?: boolean;
    isAssociated?: boolean;
    totalItems?: number;
}

export class WarrantyRegistrationSearchDTO extends PaginationBaseRequestDTO implements IWarrantyRegistrationSearchDTO {
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    ownerName?: string | null;
    isGlobalSearch?: boolean;
    hideExpired?: boolean | null;
    retailSold?: boolean | null;
    searchType?: WarrantyRegistrationSearchQueryType;

    constructor(data?: IWarrantyRegistrationSearchDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dealerLocationDynamicsId = _data["dealerLocationDynamicsId"] !== undefined ? _data["dealerLocationDynamicsId"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : <any>null;
            this.isGlobalSearch = _data["isGlobalSearch"] !== undefined ? _data["isGlobalSearch"] : <any>null;
            this.hideExpired = _data["hideExpired"] !== undefined ? _data["hideExpired"] : <any>null;
            this.retailSold = _data["retailSold"] !== undefined ? _data["retailSold"] : <any>null;
            this.searchType = _data["searchType"] !== undefined ? _data["searchType"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyRegistrationSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyRegistrationSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerLocationDynamicsId"] = this.dealerLocationDynamicsId !== undefined ? this.dealerLocationDynamicsId : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : <any>null;
        data["isGlobalSearch"] = this.isGlobalSearch !== undefined ? this.isGlobalSearch : <any>null;
        data["hideExpired"] = this.hideExpired !== undefined ? this.hideExpired : <any>null;
        data["retailSold"] = this.retailSold !== undefined ? this.retailSold : <any>null;
        data["searchType"] = this.searchType !== undefined ? this.searchType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): WarrantyRegistrationSearchDTO {
        const json = this.toJSON();
        let result = new WarrantyRegistrationSearchDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyRegistrationSearchDTO extends IPaginationBaseRequestDTO {
    dealerLocationDynamicsId?: string | null;
    vin?: string | null;
    ownerName?: string | null;
    isGlobalSearch?: boolean;
    hideExpired?: boolean | null;
    retailSold?: boolean | null;
    searchType?: WarrantyRegistrationSearchQueryType;
}

export enum WarrantyRegistrationSearchQueryType {
    All = 0,
    UnRegistered = 1,
    Registered = 2,
}

export class VinOwnerHistoryDTO implements IVinOwnerHistoryDTO {
    ownerName?: string | null;
    activationDate?: moment.Moment;
    inactiveDate?: moment.Moment;
    ownerStatus?: string | null;
    inactiveReason?: string | null;
    inServiceDate?: moment.Moment;

    constructor(data?: IVinOwnerHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : <any>null;
            this.activationDate = _data["activationDate"] ? moment(_data["activationDate"].toString()) : <any>null;
            this.inactiveDate = _data["inactiveDate"] ? moment(_data["inactiveDate"].toString()) : <any>null;
            this.ownerStatus = _data["ownerStatus"] !== undefined ? _data["ownerStatus"] : <any>null;
            this.inactiveReason = _data["inactiveReason"] !== undefined ? _data["inactiveReason"] : <any>null;
            this.inServiceDate = _data["inServiceDate"] ? moment(_data["inServiceDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): VinOwnerHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VinOwnerHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : <any>null;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>null;
        data["inactiveDate"] = this.inactiveDate ? this.inactiveDate.toISOString() : <any>null;
        data["ownerStatus"] = this.ownerStatus !== undefined ? this.ownerStatus : <any>null;
        data["inactiveReason"] = this.inactiveReason !== undefined ? this.inactiveReason : <any>null;
        data["inServiceDate"] = this.inServiceDate ? this.inServiceDate.toISOString() : <any>null;
        return data;
    }

    clone(): VinOwnerHistoryDTO {
        const json = this.toJSON();
        let result = new VinOwnerHistoryDTO();
        result.init(json);
        return result;
    }
}

export interface IVinOwnerHistoryDTO {
    ownerName?: string | null;
    activationDate?: moment.Moment;
    inactiveDate?: moment.Moment;
    ownerStatus?: string | null;
    inactiveReason?: string | null;
    inServiceDate?: moment.Moment;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
// @ts-nocheck
/* eslint-disable */

export interface Config {
  transformHeaders: (options: AxiosRequestConfig) => AxiosRequestConfig;
  transformResult(
    url: string,
    response: AxiosResponse,
    processor: (response: AxiosResponse) => Promise<any>
  ): Promise<any>;
}